{
  "level": "mt10",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt10",
    "objects": "AREAS.E3:mt10.e3",
    "mesh": "TREES.E3:mt10.e3"
  },
  "spawn_point": {
    "position": [
      -292.5569002714222,
      -2154.6166614803624,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -292.5569002714222,
      -2054.6166614803624,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3714.02392578125,
      -3518.638427734375,
      0.0
    ],
    "bbox_max": [
      196.0666046142578,
      -1905.1326904296875,
      1479.6412353515625
    ],
    "vertex_count": 2054,
    "vertices": [
      [
        -3714.02392578125,
        -2323.554931640625,
        1179.126953125
      ],
      [
        -567.1976928710938,
        -2150.822998046875,
        0.0
      ],
      [
        -648.268798828125,
        -1935.5194091796875,
        0.0
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73089599609375
      ],
      [
        -704.1276245117188,
        -2329.093994140625,
        74.91236877441406
      ],
      [
        -699.1730346679688,
        -2333.705078125,
        73.73088836669922
      ],
      [
        -694.7417602539062,
        -2341.75634765625,
        73.21707153320312
      ],
      [
        -542.742919921875,
        -2638.906005859375,
        475.2275085449219
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -542.2257690429688,
        -2659.7041015625,
        872.3767700195312
      ],
      [
        -488.8430480957031,
        -2803.202880859375,
        879.7427978515625
      ],
      [
        -529.8307495117188,
        -2692.434326171875,
        874.0250244140625
      ],
      [
        -689.266845703125,
        -2391.343994140625,
        865.4605712890625
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4804077148438
      ],
      [
        -994.6153564453125,
        -2086.76953125,
        406.15667724609375
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -719.7452392578125,
        -2356.772216796875,
        639.4212036132812
      ],
      [
        -756.295654296875,
        -2323.13134765625,
        639.4253540039062
      ],
      [
        -765.4027099609375,
        -2315.434326171875,
        648.81787109375
      ],
      [
        -766.3021850585938,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -766.3021850585938,
        -2314.824462890625,
        651.81005859375
      ],
      [
        -768.4712524414062,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -768.4713134765625,
        -2314.45263671875,
        674.0901489257812
      ],
      [
        -759.2192993164062,
        -2323.744140625,
        684.730224609375
      ],
      [
        -761.552978515625,
        -2318.2919921875,
        639.4187622070312
      ],
      [
        -765.4027099609375,
        -2315.434326171875,
        648.81787109375
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255126953125
      ],
      [
        -703.939208984375,
        -2371.302734375,
        865.4803466796875
      ],
      [
        -714.7833862304688,
        -2350.402099609375,
        639.3530883789062
      ],
      [
        -714.5018920898438,
        -2350.78662109375,
        639.3538208007812
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.402099609375,
        -2314.27783203125,
        639.3778686523438
      ],
      [
        -754.6287231445312,
        -2317.40283203125,
        639.3803100585938
      ],
      [
        -758.402099609375,
        -2314.27783203125,
        639.3778686523438
      ],
      [
        -761.5559692382812,
        -2318.289794921875,
        639.426025390625
      ],
      [
        -758.4042358398438,
        -2314.2763671875,
        639.3829345703125
      ],
      [
        -763.1381225585938,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -765.279052734375,
        -2310.43701171875,
        674.5700073242188
      ],
      [
        -754.98779296875,
        -2319.55615234375,
        685.8677978515625
      ],
      [
        -762.5052490234375,
        -2311.396728515625,
        649.1970825195312
      ],
      [
        -762.5052490234375,
        -2311.396728515625,
        649.1970825195312
      ],
      [
        -763.1381225585938,
        -2310.982421875,
        651.2776489257812
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -713.2835083007812,
        -2363.59228515625,
        866.0255126953125
      ],
      [
        -720.4444580078125,
        -2352.376708984375,
        865.884033203125
      ],
      [
        -926.8214111328125,
        -2137.733642578125,
        583.9189453125
      ],
      [
        -924.068359375,
        -2143.761474609375,
        682.6480712890625
      ],
      [
        -926.8212280273438,
        -2137.733642578125,
        583.9193115234375
      ],
      [
        -924.7864990234375,
        -2135.580322265625,
        467.37017822265625
      ],
      [
        -734.5917358398438,
        -2333.9970703125,
        639.3666381835938
      ],
      [
        -753.7207641601562,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -753.7208251953125,
        -2314.28271484375,
        639.3557739257812
      ],
      [
        -756.3106689453125,
        -2311.61328125,
        639.3507080078125
      ],
      [
        -758.4042358398438,
        -2314.2763671875,
        639.3829345703125
      ],
      [
        -760.3704223632812,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -762.0160522460938,
        -2306.33251953125,
        675.0604858398438
      ],
      [
        -760.0314331054688,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.0314331054688,
        -2307.949462890625,
        649.5208740234375
      ],
      [
        -760.3704833984375,
        -2307.621826171875,
        650.8119506835938
      ],
      [
        -924.0681762695312,
        -2143.76171875,
        682.6482543945312
      ],
      [
        -925.6937866210938,
        -2144.289306640625,
        741.553955078125
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7200927734375
      ],
      [
        -743.80419921875,
        -2328.31640625,
        866.7424926757812
      ],
      [
        -728.7424926757812,
        -2339.38037109375,
        865.7200927734375
      ],
      [
        -756.9921875,
        -2314.733154296875,
        867.2271728515625
      ],
      [
        -760.50927734375,
        -2303.75732421875,
        866.58154296875
      ],
      [
        -758.6404418945312,
        -2301.78271484375,
        759.6312255859375
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -757.0101318359375,
        -2300.060302734375,
        666.333251953125
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -755.9369506835938,
        -2302.220703125,
        650.1961669921875
      ],
      [
        -759.273681640625,
        -2308.695556640625,
        647.44970703125
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9295654296875,
        -2302.23388671875,
        650.0578002929688
      ],
      [
        -755.9306640625,
        -2302.23095703125,
        650.0648803710938
      ],
      [
        -761.9382934570312,
        -2306.4140625,
        675.1514892578125
      ],
      [
        -758.6405029296875,
        -2301.78271484375,
        759.632080078125
      ],
      [
        -765.0918579101562,
        -2295.123779296875,
        742.3956298828125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -750.8490600585938,
        -2317.2421875,
        639.357421875
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -753.7212524414062,
        -2308.314453125,
        639.3170776367188
      ],
      [
        -752.8091430664062,
        -2311.149658203125,
        639.3311767578125
      ],
      [
        -742.0281372070312,
        -2313.18505859375,
        639.28125
      ],
      [
        -756.3975830078125,
        -2299.9072265625,
        645.4571533203125
      ],
      [
        -756.9557495117188,
        -2300.09326171875,
        665.8226928710938
      ],
      [
        -756.95556640625,
        -2300.09375,
        665.8197631835938
      ],
      [
        -755.6075439453125,
        -2303.12060546875,
        648.49169921875
      ],
      [
        -756.3975219726562,
        -2299.90771484375,
        645.4580078125
      ],
      [
        -928.2157592773438,
        -2145.107666015625,
        832.941162109375
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -585.7559204101562,
        -2544.7578125,
        866.5881958007812
      ],
      [
        -642.5033569335938,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -642.5032958984375,
        -2459.815673828125,
        865.8818359375
      ],
      [
        -678.7124633789062,
        -2405.76025390625,
        865.4462890625
      ],
      [
        -704.3489990234375,
        -2348.25,
        630.2252807617188
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -708.7366943359375,
        -2344.52734375,
        641.6248779296875
      ],
      [
        -704.5856323242188,
        -2348.42529296875,
        641.6248779296875
      ],
      [
        -24.536930084228516,
        -3165.64599609375,
        850.4774169921875
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        196.0666046142578,
        -3518.638427734375,
        855.624267578125
      ],
      [
        161.8573760986328,
        -3463.04833984375,
        854.7364501953125
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -773.6272583007812,
        -2260.88818359375,
        863.9699096679688
      ],
      [
        -770.2017211914062,
        -2273.4775390625,
        864.7988891601562
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -881.6668090820312,
        -2161.587890625,
        869.2027587890625
      ],
      [
        -919.112548828125,
        -2148.940673828125,
        873.310546875
      ],
      [
        -768.545166015625,
        -2279.565673828125,
        865.1997680664062
      ],
      [
        -771.5575561523438,
        -2275.722412109375,
        865.232421875
      ],
      [
        -759.4661254882812,
        -2300.930419921875,
        757.4262084960938
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -768.0648193359375,
        -2280.178466796875,
        865.194580078125
      ],
      [
        -735.4168090820312,
        -2293.65966796875,
        639.28125
      ],
      [
        -697.0775756835938,
        -2335.688232421875,
        639.28125
      ],
      [
        -692.9767456054688,
        -2339.81640625,
        630.2252807617188
      ],
      [
        -704.5369873046875,
        -2348.38916015625,
        639.2811889648438
      ],
      [
        -693.1766357421875,
        -2339.964599609375,
        639.2811889648438
      ],
      [
        -697.1294555664062,
        -2335.726318359375,
        641.6248779296875
      ],
      [
        -693.2283935546875,
        -2340.0029296875,
        641.6248779296875
      ],
      [
        -738.8414916992188,
        -2290.000732421875,
        641.6248779296875
      ],
      [
        -735.4692993164062,
        -2293.697265625,
        641.6248779296875
      ],
      [
        -735.4692993164062,
        -2293.697265625,
        641.6248779296875
      ],
      [
        -735.4168090820312,
        -2293.65966796875,
        639.28125
      ],
      [
        -693.2283935546875,
        -2340.0029296875,
        641.6248779296875
      ],
      [
        -856.5706787109375,
        -2170.06396484375,
        866.44970703125
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -773.8917236328125,
        -2259.916259765625,
        863.9058837890625
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -856.1751708984375,
        -2170.197509765625,
        866.4063110351562
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -808.619384765625,
        -2222.050537109375,
        864.9612426757812
      ],
      [
        -855.3778076171875,
        -2170.466796875,
        866.31884765625
      ],
      [
        -693.1766357421875,
        -2339.964599609375,
        639.2811889648438
      ],
      [
        -560.1396484375,
        -2241.306640625,
        639.28125
      ],
      [
        -275.0,
        -1987.0,
        639.2813720703125
      ],
      [
        -275.0,
        -1979.0,
        639.2814331054688
      ],
      [
        -283.0,
        -1987.0,
        639.2813720703125
      ],
      [
        -275.0,
        -1987.0,
        639.2813720703125
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        622.6664428710938
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.3797607421875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        619.4662475585938
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        623.7628784179688
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        624.736083984375
      ],
      [
        -105.2154541015625,
        -2059.421630859375,
        618.412841796875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.4611206054688
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.0650024414062
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        621.3797607421875
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        618.5244140625
      ],
      [
        -92.5,
        -2071.60009765625,
        623.289794921875
      ],
      [
        -92.20442962646484,
        -2073.7763671875,
        623.3184814453125
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.0928955078125
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.4249877929688
      ],
      [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        618.5244140625
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        622.3348388671875
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.25299072265625,
        -2080.781494140625,
        623.4108276367188
      ],
      [
        -89.30126953125,
        -2081.89990234375,
        623.1181030273438
      ],
      [
        -91.10107421875,
        -2081.89990234375,
        623.3673095703125
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        622.4420776367188
      ],
      [
        -91.18240356445312,
        -2128.544921875,
        622.4412841796875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.4611206054688
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        618.412841796875
      ],
      [
        -105.22237396240234,
        -2069.38525390625,
        625.0650024414062
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.750244140625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        625.504150390625
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.3372802734375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4165649414062
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.6862182617188
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.2633666992188
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.4165649414062
      ],
      [
        -195.0,
        -1979.0,
        635.1311645507812
      ],
      [
        -195.0,
        -1987.0,
        635.39453125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        624.750244140625
      ],
      [
        -192.28419494628906,
        -1987.0,
        635.0
      ],
      [
        -195.0,
        -1987.0,
        635.39453125
      ],
      [
        -417.7513732910156,
        -2063.322021484375,
        641.6248779296875
      ],
      [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      [
        -599.7044677734375,
        -2193.9814453125,
        641.6248779296875
      ],
      [
        -514.9536743164062,
        -2132.99560546875,
        641.6248779296875
      ],
      [
        -598.208740234375,
        -2195.306396484375,
        639.2813110351562
      ],
      [
        -599.2575073242188,
        -2193.659912109375,
        641.6248779296875
      ],
      [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      [
        -514.9536743164062,
        -2132.99560546875,
        641.6248779296875
      ],
      [
        -599.1027221679688,
        -2193.90234375,
        641.6248779296875
      ],
      [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      [
        -413.4871520996094,
        -2061.216064453125,
        641.6248779296875
      ],
      [
        -407.52972412109375,
        -2058.7177734375,
        641.6248779296875
      ],
      [
        -417.7513732910156,
        -2063.322021484375,
        641.6248779296875
      ],
      [
        -413.4871520996094,
        -2061.216064453125,
        641.6248779296875
      ],
      [
        -415.853271484375,
        -2064.681640625,
        639.28125
      ],
      [
        -415.51983642578125,
        -2064.44287109375,
        639.3070678710938
      ],
      [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      [
        -415.51983642578125,
        -2064.44287109375,
        639.3070678710938
      ],
      [
        -635.3164672851562,
        -2162.76806640625,
        697.0984497070312
      ],
      [
        -633.0643310546875,
        -2161.42333984375,
        696.8292236328125
      ],
      [
        -581.8073120117188,
        -2131.190673828125,
        690.3378295898438
      ],
      [
        -438.25628662109375,
        -2050.9775390625,
        672.068359375
      ],
      [
        -489.5420837402344,
        -2082.13818359375,
        678.5451049804688
      ],
      [
        -489.5420837402344,
        -2082.13818359375,
        678.5451049804688
      ],
      [
        -581.8073120117188,
        -2131.190673828125,
        690.3378295898438
      ],
      [
        -387.0029296875,
        -2031.0791015625,
        664.73583984375
      ],
      [
        -356.554931640625,
        -2022.1925048828125,
        660.0204467773438
      ],
      [
        -438.25628662109375,
        -2050.9775390625,
        672.068359375
      ],
      [
        -410.681640625,
        -2040.0166015625,
        668.4696044921875
      ],
      [
        -387.0029296875,
        -2031.0791015625,
        664.73583984375
      ],
      [
        -559.5923461914062,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -481.7292785644531,
        -2175.087646484375,
        641.6248779296875
      ],
      [
        -478.2337341308594,
        -2172.9765625,
        641.6248779296875
      ],
      [
        -431.2630920410156,
        -2141.634033203125,
        641.6248779296875
      ],
      [
        -419.4507141113281,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.0796813964844,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -402.5533142089844,
        -2124.443359375,
        641.3375854492188
      ],
      [
        -404.71063232421875,
        -2126.043212890625,
        641.6248779296875
      ],
      [
        -419.4507141113281,
        -2134.6982421875,
        641.6248779296875
      ],
      [
        -427.0796813964844,
        -2139.177734375,
        641.6248779296875
      ],
      [
        -431.2630920410156,
        -2141.634033203125,
        641.6248779296875
      ],
      [
        -561.7347412109375,
        -2240.273681640625,
        641.6248779296875
      ],
      [
        -559.5923461914062,
        -2237.091064453125,
        641.6248779296875
      ],
      [
        -381.43682861328125,
        -2108.78369140625,
        639.28125
      ],
      [
        -383.08306884765625,
        -2106.674072265625,
        639.28125
      ],
      [
        -362.3825988769531,
        -2094.6533203125,
        640.7756958007812
      ],
      [
        -389.21783447265625,
        -2098.81298828125,
        639.28125
      ],
      [
        -360.9188537597656,
        -2078.708984375,
        641.466552734375
      ],
      [
        -356.9158630371094,
        -2079.7548828125,
        641.6248779296875
      ],
      [
        -351.5553283691406,
        -2086.6240234375,
        641.6248779296875
      ],
      [
        -358.59466552734375,
        -2077.0341796875,
        641.6248779296875
      ],
      [
        -356.9158630371094,
        -2079.7548828125,
        641.6248779296875
      ],
      [
        -360.9189453125,
        -2078.708984375,
        641.466552734375
      ],
      [
        -481.7292785644531,
        -2175.087646484375,
        641.6248779296875
      ],
      [
        -478.2337341308594,
        -2172.9765625,
        641.6248779296875
      ],
      [
        -377.63330078125,
        -2046.1796875,
        641.6248779296875
      ],
      [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -275.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -275.0,
        -1987.0,
        641.6248779296875
      ],
      [
        -275.0,
        -1979.0,
        641.6248779296875
      ],
      [
        -377.63330078125,
        -2046.1796875,
        641.6248779296875
      ],
      [
        -413.5242004394531,
        -2063.012939453125,
        639.4616088867188
      ],
      [
        -381.7651062011719,
        -2047.9124755859375,
        641.6248779296875
      ],
      [
        -407.52972412109375,
        -2058.7177734375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.6248779296875
      ],
      [
        -314.135009765625,
        -2131.402587890625,
        641.6248779296875
      ],
      [
        -348.6988830566406,
        -2090.284423828125,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.6248779296875
      ],
      [
        -403.0185852050781,
        -2125.049560546875,
        641.6248779296875
      ],
      [
        -506.8857421875,
        -2234.297607421875,
        676.8448486328125
      ],
      [
        -479.8502197265625,
        -2209.49267578125,
        673.8995361328125
      ],
      [
        -539.6183471679688,
        -2288.8349609375,
        679.6005249023438
      ],
      [
        -506.8857421875,
        -2234.297607421875,
        676.8448486328125
      ],
      [
        -479.8502197265625,
        -2209.49267578125,
        673.8995361328125
      ],
      [
        -436.0340576171875,
        -2177.475341796875,
        668.8553466796875
      ],
      [
        -292.998291015625,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -250.93359375,
        -2070.21044921875,
        645.7384643554688
      ],
      [
        -299.1501770019531,
        -2076.648193359375,
        652.2869262695312
      ],
      [
        -299.1034240722656,
        -2076.33544921875,
        652.1087646484375
      ],
      [
        -344.92059326171875,
        -2092.46240234375,
        641.6248779296875
      ],
      [
        -314.135009765625,
        -2131.402587890625,
        653.261962890625
      ],
      [
        -335.95623779296875,
        -2103.80126953125,
        656.8388061523438
      ],
      [
        -326.5126953125,
        -2098.354736328125,
        655.6403198242188
      ],
      [
        -329.4200439453125,
        -2095.0888671875,
        652.5117797851562
      ],
      [
        -299.1034240722656,
        -2076.33544921875,
        652.1087646484375
      ],
      [
        -299.1501770019531,
        -2076.648193359375,
        652.2869262695312
      ],
      [
        -335.46014404296875,
        -2104.4287109375,
        656.7574462890625
      ],
      [
        -337.21295166015625,
        -2102.211669921875,
        654.7059326171875
      ],
      [
        -329.4200439453125,
        -2095.0888671875,
        652.5117797851562
      ],
      [
        -326.5126953125,
        -2098.354736328125,
        655.6403198242188
      ],
      [
        -250.93359375,
        -2070.21044921875,
        645.7384643554688
      ],
      [
        -292.998291015625,
        -2065.633544921875,
        645.7384643554688
      ],
      [
        -268.69073486328125,
        -2050.952880859375,
        645.7384643554688
      ],
      [
        -250.4771270751953,
        -2067.064208984375,
        645.7384643554688
      ],
      [
        -254.21783447265625,
        -2042.298095703125,
        645.8165893554688
      ],
      [
        -249.72195434570312,
        -2060.558837890625,
        645.7645874023438
      ],
      [
        -250.47711181640625,
        -2067.064208984375,
        645.7384643554688
      ],
      [
        -268.69073486328125,
        -2050.952880859375,
        645.7384643554688
      ],
      [
        -436.0340576171875,
        -2177.475341796875,
        668.8553466796875
      ],
      [
        -418.6674499511719,
        -2163.538818359375,
        666.8972778320312
      ],
      [
        -299.1072692871094,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -299.1072692871094,
        -2058.383056640625,
        645.7384643554688
      ],
      [
        -276.98150634765625,
        -2043.619140625,
        645.7384643554688
      ],
      [
        -347.17816162109375,
        -2090.115478515625,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7095947265625
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7095947265625
      ],
      [
        -344.845703125,
        -2092.55712890625,
        641.7520141601562
      ],
      [
        -257.1222229003906,
        -2030.50146484375,
        645.8502197265625
      ],
      [
        -276.98150634765625,
        -2043.619140625,
        645.7384643554688
      ],
      [
        -293.2745361328125,
        -2066.11767578125,
        646.0267333984375
      ],
      [
        -405.9732971191406,
        -2135.6884765625,
        649.3046875
      ],
      [
        -409.7422180175781,
        -2137.800537109375,
        649.2176513671875
      ],
      [
        -409.74249267578125,
        -2137.800537109375,
        649.217529296875
      ],
      [
        -427.6854248046875,
        -2147.85595703125,
        648.80322265625
      ],
      [
        -345.69329833984375,
        -2091.48779296875,
        641.7091064453125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7198486328125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        641.7198486328125
      ],
      [
        -338.43505859375,
        -2100.665771484375,
        652.6318969726562
      ],
      [
        -339.98199462890625,
        -2098.708984375,
        650.8302612304688
      ],
      [
        -293.819580078125,
        -2065.990966796875,
        645.9889526367188
      ],
      [
        -299.0165100097656,
        -2075.753662109375,
        651.7774658203125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -344.6956787109375,
        -2092.7470703125,
        645.3406982421875
      ],
      [
        -344.8224182128906,
        -2092.92724609375,
        645.4060668945312
      ],
      [
        -347.2979431152344,
        -2089.455322265625,
        641.7266235351562
      ],
      [
        -347.7261962890625,
        -2089.609130859375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        643.966552734375
      ],
      [
        -348.379150390625,
        -2089.005615234375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.1882934570312
      ],
      [
        -347.660400390625,
        -2089.669677734375,
        641.7003173828125
      ],
      [
        -349.2778625488281,
        -2089.54248046875,
        641.6248779296875
      ],
      [
        -348.3093566894531,
        -2089.070068359375,
        641.6913452148438
      ],
      [
        -347.29803466796875,
        -2089.455322265625,
        641.7266235351562
      ],
      [
        -347.7991638183594,
        -2088.8212890625,
        641.726318359375
      ],
      [
        -398.3269348144531,
        -2148.872802734375,
        664.5492553710938
      ],
      [
        -418.6674499511719,
        -2163.538818359375,
        666.8972778320312
      ],
      [
        -338.4958801269531,
        -2100.5888671875,
        653.204345703125
      ],
      [
        -330.7851867675781,
        -2093.555419921875,
        651.0427856445312
      ],
      [
        -339.98199462890625,
        -2098.708984375,
        650.8302612304688
      ],
      [
        -337.2131042480469,
        -2102.21142578125,
        654.7056884765625
      ],
      [
        -338.4957275390625,
        -2100.5888671875,
        653.2045288085938
      ],
      [
        -336.19610595703125,
        -2103.497802734375,
        656.8781127929688
      ],
      [
        -344.69580078125,
        -2092.74658203125,
        645.3403930664062
      ],
      [
        -338.4957275390625,
        -2100.5888671875,
        653.2045288085938
      ],
      [
        -341.9140625,
        -2096.26513671875,
        649.2035522460938
      ],
      [
        -349.859375,
        -2088.79736328125,
        641.6248779296875
      ],
      [
        -349.04022216796875,
        -2088.394775390625,
        641.6248779296875
      ],
      [
        -348.3093566894531,
        -2089.070068359375,
        641.6912841796875
      ],
      [
        -348.9796142578125,
        -2088.45068359375,
        641.6820678710938
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.7898559570312
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        644.7898559570312
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.432861328125
      ],
      [
        -339.4874267578125,
        -2099.334716796875,
        657.4176025390625
      ],
      [
        -350.0618591308594,
        -2087.45068359375,
        641.6248779296875
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        647.4328002929688
      ],
      [
        -348.9795837402344,
        -2088.45068359375,
        641.6820068359375
      ],
      [
        -350.619873046875,
        -2087.82275390625,
        641.6248779296875
      ],
      [
        -350.02984619140625,
        -2087.480224609375,
        641.66748046875
      ],
      [
        -348.30291748046875,
        -2088.18408203125,
        641.7259521484375
      ],
      [
        -349.227783203125,
        -2087.014404296875,
        641.7254028320312
      ],
      [
        -342.9916687011719,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      [
        -342.9916687011719,
        -2083.39306640625,
        642.1755981445312
      ],
      [
        -304.09906005859375,
        -2038.2144775390625,
        645.7384643554688
      ],
      [
        -326.17437744140625,
        -2053.673828125,
        643.833251953125
      ],
      [
        -278.13726806640625,
        -2017.6419677734375,
        645.829345703125
      ],
      [
        -259.83282470703125,
        -2019.491943359375,
        645.881591796875
      ],
      [
        -293.0437316894531,
        -2029.410888671875,
        645.7384643554688
      ],
      [
        -304.09906005859375,
        -2038.2144775390625,
        645.7384643554688
      ],
      [
        -293.0437316894531,
        -2029.410888671875,
        645.7384643554688
      ],
      [
        -259.83270263671875,
        -2019.491943359375,
        645.881591796875
      ],
      [
        -278.13720703125,
        -2017.6419677734375,
        645.829345703125
      ],
      [
        -274.0508728027344,
        -2016.6390380859375,
        647.85302734375
      ],
      [
        -326.17437744140625,
        -2053.673828125,
        643.833251953125
      ],
      [
        -358.5946044921875,
        -2077.0341796875,
        641.6248779296875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.65234375
      ],
      [
        -350.02978515625,
        -2087.48046875,
        641.6674194335938
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        641.70263671875
      ],
      [
        -349.98590087890625,
        -2087.52099609375,
        641.7257080078125
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        658.4334716796875
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        655.4558715820312
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        658.4334716796875
      ],
      [
        -348.8742370605469,
        -2088.548095703125,
        658.9343872070312
      ],
      [
        -312.8653564453125,
        -2009.441162109375,
        653.2543334960938
      ],
      [
        -283.0,
        -1987.0,
        648.1774291992188
      ],
      [
        -275.0,
        -1987.0,
        647.015380859375
      ],
      [
        -275.0,
        -1987.0,
        647.015380859375
      ],
      [
        -275.0,
        -1979.0,
        646.7520141601562
      ],
      [
        -275.1496887207031,
        -2016.90869140625,
        647.308837890625
      ],
      [
        -298.2037048339844,
        -2033.5198974609375,
        645.7384643554688
      ],
      [
        -276.3931579589844,
        -2016.1690673828125,
        648.1777954101562
      ],
      [
        -300.8401184082031,
        -2011.2637939453125,
        651.5675659179688
      ],
      [
        -312.8653564453125,
        -2009.441162109375,
        653.2543334960938
      ],
      [
        -300.8400573730469,
        -2011.2637939453125,
        651.5675659179688
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        659.28759765625
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        -538.70947265625,
        -2290.83056640625,
        681.1611328125
      ],
      [
        -505.5890197753906,
        -2234.22900390625,
        677.7113647460938
      ],
      [
        -479.8081359863281,
        -2210.26318359375,
        674.6223754882812
      ],
      [
        -435.5717468261719,
        -2177.524658203125,
        669.1536865234375
      ],
      [
        -505.5890197753906,
        -2234.22900390625,
        677.7113647460938
      ],
      [
        -479.8081359863281,
        -2210.26318359375,
        674.6223754882812
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -105.300048828125,
        -2181.199951171875,
        623.3385009765625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        622.1809692382812
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        623.5617065429688
      ],
      [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        622.3347778320312
      ],
      [
        -92.20442962646484,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -91.4780502319336,
        -2130.7216796875,
        622.4104614257812
      ],
      [
        -91.48380279541016,
        -2130.763916015625,
        622.4384765625
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        623.95703125
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        624.4100341796875
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        624.61962890625
      ],
      [
        -398.3159484863281,
        -2148.8896484375,
        664.5693359375
      ],
      [
        -418.5774230957031,
        -2163.6953125,
        667.0779418945312
      ],
      [
        -435.5717468261719,
        -2177.524658203125,
        669.1536865234375
      ],
      [
        -418.5774230957031,
        -2163.6953125,
        667.0779418945312
      ],
      [
        -635.32763671875,
        -2162.75830078125,
        697.1158447265625
      ],
      [
        27.273828506469727,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        26.906936645507812,
        -2132.77880859375,
        606.0013427734375
      ],
      [
        27.273826599121094,
        -2132.59033203125,
        605.9542846679688
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -313.8014221191406,
        -2007.8206787109375,
        655.6990356445312
      ],
      [
        -386.3614807128906,
        -2030.3492431640625,
        665.2955932617188
      ],
      [
        -275.0,
        -1987.0,
        650.7435913085938
      ],
      [
        -275.0,
        -1979.0,
        650.9043579101562
      ],
      [
        -283.0,
        -1987.0,
        651.8515625
      ],
      [
        -275.0,
        -1987.0,
        650.7435913085938
      ],
      [
        -245.12722778320312,
        -2020.9781494140625,
        645.923583984375
      ],
      [
        -297.8909912109375,
        -2010.245361328125,
        653.4468383789062
      ],
      [
        -195.0,
        -1979.0,
        639.8246459960938
      ],
      [
        -195.0,
        -1987.0,
        639.6638793945312
      ],
      [
        -187.0,
        -1987.0,
        638.555908203125
      ],
      [
        -187.0,
        -1979.0,
        638.7167358398438
      ],
      [
        -195.0,
        -1987.0,
        639.6639404296875
      ],
      [
        -187.0,
        -1987.0,
        638.555908203125
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        625.3841552734375
      ],
      [
        -101.40150451660156,
        -2050.2138671875,
        625.4306030273438
      ],
      [
        -101.80962371826172,
        -2051.19921875,
        623.9706420898438
      ],
      [
        -245.12734985351562,
        -2020.9781494140625,
        645.923583984375
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.0199584960938
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        620.111572265625
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.779541015625
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        625.779541015625
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        -109.34033203125,
        -2064.5546875,
        626.241943359375
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        626.0529174804688
      ],
      [
        -108.29034423828125,
        -2066.72607421875,
        625.423095703125
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        622.0199584960938
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        623.4006958007812
      ],
      [
        -92.5,
        -2071.60009765625,
        623.7680053710938
      ],
      [
        -92.2044448852539,
        -2073.776123046875,
        623.683349609375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        623.3184814453125
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        626.0107421875
      ],
      [
        -108.0561294555664,
        -2067.21044921875,
        625.405029296875
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        624.9579467773438
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        625.8526000976562
      ],
      [
        -91.99929809570312,
        -2075.28662109375,
        623.6245727539062
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        623.33837890625
      ],
      [
        -91.76782989501953,
        -2076.990966796875,
        623.5582885742188
      ],
      [
        -91.75545501708984,
        -2077.08203125,
        623.362060546875
      ],
      [
        -386.3614807128906,
        -2030.3492431640625,
        665.2955932617188
      ],
      [
        -313.8014221191406,
        -2007.8206787109375,
        655.6990356445312
      ],
      [
        -297.89105224609375,
        -2010.245361328125,
        653.44677734375
      ],
      [
        149.87228393554688,
        -2063.799072265625,
        590.357177734375
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -187.0,
        -1979.0,
        705.8253784179688
      ],
      [
        -195.0,
        -1979.0,
        705.9292602539062
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -195.0,
        -1987.0,
        700.3240966796875
      ],
      [
        -187.0,
        -1987.0,
        700.22021484375
      ],
      [
        -275.0,
        -1987.0,
        681.065673828125
      ],
      [
        -275.0,
        -1979.0,
        692.4945068359375
      ],
      [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      [
        -275.0,
        -1987.0,
        681.065673828125
      ],
      [
        -96.41828918457031,
        -2045.7427978515625,
        651.5167236328125
      ],
      [
        -98.16725158691406,
        -1998.9012451171875,
        690.3646850585938
      ],
      [
        -97.8071060180664,
        -2033.1219482421875,
        666.070556640625
      ],
      [
        -97.46320343017578,
        -2039.248291015625,
        660.4767456054688
      ],
      [
        -72.37802124023438,
        -2000.3099365234375,
        687.002197265625
      ],
      [
        -80.47096252441406,
        -2046.98486328125,
        652.0723266601562
      ],
      [
        -78.00983428955078,
        -2034.1829833984375,
        663.50390625
      ],
      [
        -85.13467407226562,
        -2046.7047119140625,
        652.7044067382812
      ],
      [
        -88.04829406738281,
        -2046.2249755859375,
        653.3761596679688
      ],
      [
        -90.278564453125,
        -2045.5736083984375,
        653.6278076171875
      ],
      [
        -92.9021224975586,
        -2045.6607666015625,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.5736083984375,
        653.6278076171875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        623.4907836914062
      ],
      [
        -78.51063537597656,
        -2070.32080078125,
        621.8562622070312
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        645.5497436523438
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        629.0595703125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        629.0595703125
      ],
      [
        -106.79005432128906,
        -2061.427490234375,
        625.9515991210938
      ],
      [
        -100.88525390625,
        -2048.967529296875,
        651.923583984375
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.64306640625
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9339599609375
      ],
      [
        -67.10629272460938,
        -2071.697509765625,
        628.53857421875
      ],
      [
        -66.12939453125,
        -2071.8154296875,
        628.041259765625
      ],
      [
        -96.9736099243164,
        -2047.9700927734375,
        652.51318359375
      ],
      [
        -97.29429626464844,
        -2040.298095703125,
        659.0283813476562
      ],
      [
        -97.39114379882812,
        -2040.531982421875,
        659.3046875
      ],
      [
        -96.92051696777344,
        -2047.3251953125,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2045.8577880859375,
        653.890380859375
      ],
      [
        -96.99674224853516,
        -2047.5574951171875,
        652.8898315429688
      ],
      [
        -90.278564453125,
        -2045.8577880859375,
        653.890380859375
      ],
      [
        -98.24182891845703,
        -2047.87255859375,
        652.7044067382812
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.80126953125
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        630.9339599609375
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        636.337158203125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -108.26380157470703,
        -2066.781005859375,
        626.048095703125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        627.80126953125
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        623.683349609375
      ],
      [
        -92.5,
        -2071.60009765625,
        630.682861328125
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        628.6817016601562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        632.6511840820312
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        634.2090454101562
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        623.6245727539062
      ],
      [
        -92.0062026977539,
        -2075.235595703125,
        627.3397827148438
      ],
      [
        -91.999267578125,
        -2075.28662109375,
        627.2297973632812
      ],
      [
        -91.76782989501953,
        -2076.99072265625,
        623.5582885742188
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        642.6431274414062
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.447021484375
      ],
      [
        -109.34033203125,
        -2064.5546875,
        638.447021484375
      ],
      [
        -243.34588623046875,
        -2065.764892578125,
        645.7661743164062
      ],
      [
        -221.4729461669922,
        -2070.297119140625,
        642.3065185546875
      ],
      [
        -316.0190734863281,
        -2003.981689453125,
        661.4907836914062
      ],
      [
        -382.385009765625,
        -2025.8243408203125,
        668.7655639648438
      ],
      [
        -291.2507019042969,
        -2007.9521484375,
        657.6782836914062
      ],
      [
        -243.3459930419922,
        -2065.764892578125,
        645.7661743164062
      ],
      [
        -250.34518432617188,
        -2065.927734375,
        645.7430419921875
      ],
      [
        -316.0190734863281,
        -2003.981689453125,
        661.4907836914062
      ],
      [
        -291.2506103515625,
        -2007.9520263671875,
        657.6783447265625
      ],
      [
        -382.385009765625,
        -2025.8243408203125,
        668.7655639648438
      ],
      [
        -404.39532470703125,
        -2037.5177001953125,
        667.649169921875
      ],
      [
        -400.16082763671875,
        -2033.27099609375,
        670.569580078125
      ],
      [
        -333.45318603515625,
        -1969.59423828125,
        714.3178100585938
      ],
      [
        -275.0,
        -1987.0,
        688.9049682617188
      ],
      [
        -275.0,
        -1979.0,
        704.0978393554688
      ],
      [
        -283.0,
        -1987.0,
        687.859130859375
      ],
      [
        -275.0,
        -1987.0,
        688.9049682617188
      ],
      [
        -275.0,
        -1987.0,
        692.0354614257812
      ],
      [
        -275.0,
        -1979.0,
        704.5523071289062
      ],
      [
        -283.0,
        -1987.0,
        691.26025390625
      ],
      [
        -275.0,
        -1987.0,
        692.0354614257812
      ],
      [
        -341.9971008300781,
        -1974.9400634765625,
        710.683349609375
      ],
      [
        -275.0,
        -1987.0,
        701.3634033203125
      ],
      [
        -275.0,
        -1979.0,
        706.9683837890625
      ],
      [
        -283.0,
        -1987.0,
        701.46728515625
      ],
      [
        -275.0,
        -1987.0,
        701.3634033203125
      ],
      [
        -335.9170227050781,
        -1970.3802490234375,
        713.7991333007812
      ],
      [
        -333.45318603515625,
        -1969.59423828125,
        714.3178100585938
      ],
      [
        -336.52667236328125,
        -1970.9891357421875,
        713.3804931640625
      ],
      [
        -337.3862609863281,
        -1971.60986328125,
        712.9566650390625
      ],
      [
        -337.3862609863281,
        -1971.60986328125,
        712.9566650390625
      ],
      [
        -341.9970703125,
        -1974.9400634765625,
        710.683349609375
      ],
      [
        -336.52667236328125,
        -1970.9891357421875,
        713.3804931640625
      ],
      [
        -336.31640625,
        -1970.779052734375,
        713.52490234375
      ],
      [
        -336.31640625,
        -1970.779052734375,
        713.52490234375
      ],
      [
        -336.2025451660156,
        -1970.6654052734375,
        713.6030883789062
      ],
      [
        -335.9170227050781,
        -1970.3802490234375,
        713.7991333007812
      ],
      [
        -336.2025451660156,
        -1970.6654052734375,
        713.6030883789062
      ],
      [
        -220.87794494628906,
        -1974.3787841796875,
        718.9976196289062
      ],
      [
        -324.6526184082031,
        -1955.786376953125,
        741.6905517578125
      ],
      [
        -226.5302734375,
        -1974.1220703125,
        719.6976318359375
      ],
      [
        -226.5302734375,
        -1974.1220703125,
        719.6976318359375
      ],
      [
        -220.87794494628906,
        -1974.3787841796875,
        718.9976196289062
      ],
      [
        -348.0,
        -1923.6783447265625,
        766.5938110351562
      ],
      [
        -348.0,
        -1918.043212890625,
        766.0
      ],
      [
        -348.0,
        -1924.515869140625,
        766.0
      ],
      [
        -195.0,
        -1979.0,
        707.2992553710938
      ],
      [
        -195.0,
        -1980.298828125,
        705.019287109375
      ],
      [
        -187.0,
        -1979.0,
        706.1907348632812
      ],
      [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      [
        -375.7254638671875,
        -1990.46337890625,
        712.218017578125
      ],
      [
        -367.86041259765625,
        -2000.877685546875,
        692.84619140625
      ],
      [
        -350.28759765625,
        -1966.3572998046875,
        736.5458984375
      ],
      [
        -358.3292236328125,
        -1971.7314453125,
        733.4729614257812
      ],
      [
        -358.3292236328125,
        -1971.7314453125,
        733.4729614257812
      ],
      [
        -375.7254638671875,
        -1990.46337890625,
        712.218017578125
      ],
      [
        -372.4570007324219,
        -1981.1728515625,
        728.0743408203125
      ],
      [
        -344.8354187011719,
        -1961.2728271484375,
        739.6508178710938
      ],
      [
        -341.20098876953125,
        -1960.284912109375,
        740.0181274414062
      ],
      [
        -335.4994201660156,
        -1970.2470703125,
        713.8870239257812
      ],
      [
        -350.28753662109375,
        -1966.3572998046875,
        736.5458374023438
      ],
      [
        -348.385498046875,
        -1964.58349609375,
        737.6290283203125
      ],
      [
        -348.3855285644531,
        -1964.58349609375,
        737.6290283203125
      ],
      [
        -347.3651123046875,
        -1963.6319580078125,
        738.2101440429688
      ],
      [
        -344.8354187011719,
        -1961.2728271484375,
        739.6508178710938
      ],
      [
        -347.3651123046875,
        -1963.6319580078125,
        738.2101440429688
      ],
      [
        -324.6526184082031,
        -1955.786376953125,
        741.6905517578125
      ],
      [
        -275.0,
        -1987.0,
        704.3411865234375
      ],
      [
        -275.0,
        -1979.0,
        718.384521484375
      ],
      [
        -283.0,
        -1987.0,
        705.4492797851562
      ],
      [
        -275.0,
        -1987.0,
        704.3411865234375
      ],
      [
        -444.486572265625,
        -2047.226806640625,
        681.3184204101562
      ],
      [
        -420.6313781738281,
        -2015.7926025390625,
        707.9457397460938
      ],
      [
        -409.88433837890625,
        -2006.1849365234375,
        713.772216796875
      ],
      [
        -409.88433837890625,
        -2006.1849365234375,
        713.772216796875
      ],
      [
        -245.07896423339844,
        -2068.60986328125,
        645.750244140625
      ],
      [
        -439.96783447265625,
        -2049.947265625,
        674.6094360351562
      ],
      [
        -447.19268798828125,
        -2056.4072265625,
        673.1968994140625
      ],
      [
        -446.5450744628906,
        -2054.210205078125,
        675.1404418945312
      ],
      [
        -245.07907104492188,
        -2068.60986328125,
        645.750244140625
      ],
      [
        -248.38243103027344,
        -2068.917236328125,
        645.7384643554688
      ],
      [
        -250.77691650390625,
        -2069.130615234375,
        645.7384643554688
      ],
      [
        -248.38262939453125,
        -2068.9169921875,
        645.7384643554688
      ],
      [
        -275.0,
        -1987.0,
        715.01025390625
      ],
      [
        -275.0,
        -1979.0,
        720.6820068359375
      ],
      [
        -283.0,
        -1987.0,
        715.743408203125
      ],
      [
        -275.0,
        -1987.0,
        715.01025390625
      ],
      [
        -444.486572265625,
        -2047.226806640625,
        681.3184204101562
      ],
      [
        -187.0,
        -1987.0,
        706.9443969726562
      ],
      [
        -187.0,
        -1979.0,
        712.6160888671875
      ],
      [
        -195.0,
        -1979.0,
        713.3493041992188
      ],
      [
        -195.0,
        -1987.0,
        707.6776123046875
      ],
      [
        -195.0,
        -1987.0,
        707.6776733398438
      ],
      [
        -187.0,
        -1987.0,
        706.9443969726562
      ],
      [
        -299.21417236328125,
        -2077.076416015625,
        652.5308227539062
      ],
      [
        -301.4764099121094,
        -2078.49365234375,
        652.572021484375
      ],
      [
        -299.21417236328125,
        -2077.076416015625,
        652.5308227539062
      ],
      [
        -300.9224548339844,
        -2078.300537109375,
        652.658203125
      ],
      [
        -446.5450744628906,
        -2054.210205078125,
        675.1404418945312
      ],
      [
        -465.21954345703125,
        -2067.360107421875,
        675.4734497070312
      ],
      [
        -464.2539978027344,
        -2065.688232421875,
        676.5702514648438
      ],
      [
        -216.42385864257812,
        -2083.561767578125,
        641.18310546875
      ],
      [
        -219.54531860351562,
        -2083.32763671875,
        641.6351318359375
      ],
      [
        -295.3524169921875,
        -2077.643798828125,
        652.61328125
      ],
      [
        -299.313232421875,
        -2077.739501953125,
        652.908447265625
      ],
      [
        -299.313232421875,
        -2077.739501953125,
        652.908447265625
      ],
      [
        -454.3049011230469,
        -2059.23974609375,
        675.7669677734375
      ],
      [
        -463.86151123046875,
        -2065.008544921875,
        677.01611328125
      ],
      [
        -451.2431335449219,
        -2043.1591796875,
        691.3497924804688
      ],
      [
        -253.28384399414062,
        -2076.626953125,
        649.47802734375
      ],
      [
        -219.5453338623047,
        -2083.32763671875,
        641.6351318359375
      ],
      [
        -239.5581512451172,
        -2078.29150390625,
        647.0399169921875
      ],
      [
        -253.28384399414062,
        -2076.626953125,
        649.47802734375
      ],
      [
        -239.5581512451172,
        -2078.29150390625,
        647.0399169921875
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        634.935791015625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3053588867188
      ],
      [
        -79.672119140625,
        -2070.1806640625,
        634.935791015625
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.5714111328125
      ],
      [
        -98.01838684082031,
        -2071.3681640625,
        637.0621337890625
      ],
      [
        -90.278564453125,
        -2074.573974609375,
        628.3053588867188
      ],
      [
        -92.5,
        -2071.60009765625,
        635.1734008789062
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        630.484130859375
      ],
      [
        -92.20440673828125,
        -2073.7763671875,
        628.6817016601562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        636.5714111328125
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        636.3084106445312
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        636.3084106445312
      ],
      [
        -107.86448669433594,
        -2067.60693359375,
        635.5545043945312
      ],
      [
        -451.2431335449219,
        -2043.1591796875,
        691.3497924804688
      ],
      [
        -97.6234130859375,
        -2050.576416015625,
        653.6791381835938
      ],
      [
        -80.50997161865234,
        -2049.22021484375,
        653.0723266601562
      ],
      [
        -80.51241302490234,
        -2048.619384765625,
        652.7044067382812
      ],
      [
        -80.49156188964844,
        -2049.109375,
        653.1491088867188
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -96.99674224853516,
        -2047.5574951171875,
        652.8898315429688
      ],
      [
        -90.278564453125,
        -2047.364990234375,
        655.2828369140625
      ],
      [
        -97.63477325439453,
        -2049.502197265625,
        654.4420776367188
      ],
      [
        -79.91655731201172,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -79.41132354736328,
        -2049.59716796875,
        652.7044067382812
      ],
      [
        -79.91655731201172,
        -2049.2119140625,
        653.0237426757812
      ],
      [
        -102.37574768066406,
        -2052.56591796875,
        652.7044067382812
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        648.0020751953125
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.0797729492188
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        641.4745483398438
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        643.1660766601562
      ],
      [
        -107.177978515625,
        -2069.026611328125,
        641.4745483398438
      ],
      [
        -108.26382446289062,
        -2066.781005859375,
        636.337158203125
      ],
      [
        -102.37574768066406,
        -2052.56591796875,
        652.7044067382812
      ],
      [
        -99.73937225341797,
        -2050.113525390625,
        654.2015380859375
      ],
      [
        -99.73937225341797,
        -2050.113525390625,
        654.2015380859375
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.0797729492188
      ],
      [
        -100.58236694335938,
        -2070.30615234375,
        639.9630126953125
      ],
      [
        -105.278564453125,
        -2059.573974609375,
        648.0020751953125
      ],
      [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      [
        -108.98356628417969,
        -2065.29248046875,
        644.2874145507812
      ],
      [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      [
        -108.98380279541016,
        -2064.7919921875,
        644.642333984375
      ],
      [
        -108.98348999023438,
        -2065.292724609375,
        644.2874145507812
      ],
      [
        -108.98371887207031,
        -2064.7919921875,
        644.6423950195312
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        31.667320251464844,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        -126.01776885986328,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -87.22331237792969,
        -1971.048828125,
        733.6969604492188
      ],
      [
        -132.99351501464844,
        -1956.173095703125,
        738.7794189453125
      ],
      [
        -126.01776123046875,
        -1956.1983642578125,
        737.7685546875
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -570.8470458984375,
        -2080.698974609375,
        736.9747924804688
      ],
      [
        -562.6383056640625,
        -2045.0108642578125,
        810.5653686523438
      ],
      [
        -499.8879089355469,
        -2015.7177734375,
        798.3612670898438
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -360.0,
        -1939.0,
        769.9519653320312
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -360.0,
        -1939.0,
        769.9519653320312
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -348.0,
        -1928.0,
        767.0492553710938
      ],
      [
        -369.0,
        -1947.25,
        772.1289672851562
      ],
      [
        -369.0,
        -1939.0,
        771.2595825195312
      ],
      [
        -369.0,
        -1947.25,
        766.0
      ],
      [
        -406.8781433105469,
        -1972.0,
        778.7999267578125
      ],
      [
        -414.0,
        -1972.0,
        781.2753295898438
      ],
      [
        -408.11614990234375,
        -1972.0,
        780.4204711914062
      ],
      [
        -369.0,
        -1950.0,
        772.4187622070312
      ],
      [
        -418.30963134765625,
        -1976.85595703125,
        782.4132080078125
      ],
      [
        -407.94476318359375,
        -1972.796875,
        780.4795532226562
      ],
      [
        -405.1983947753906,
        -1972.0,
        778.7999267578125
      ],
      [
        -406.2380676269531,
        -1972.0,
        780.1475830078125
      ],
      [
        31.667320251464844,
        -2009.6890869140625,
        720.4949951171875
      ],
      [
        43.42919921875,
        -2015.640380859375,
        719.4132080078125
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.331787109375
      ],
      [
        -240.9657440185547,
        -1954.890869140625,
        754.331787109375
      ],
      [
        -223.3677520751953,
        -1955.846435546875,
        751.8756713867188
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967041015625
      ],
      [
        -317.3755187988281,
        -1944.3687744140625,
        764.32470703125
      ],
      [
        -365.45013427734375,
        -1961.2537841796875,
        762.07080078125
      ],
      [
        -365.3388671875,
        -1955.880615234375,
        771.4879150390625
      ],
      [
        -365.3388671875,
        -1955.880615234375,
        771.4879150390625
      ],
      [
        -365.3275146484375,
        -1955.3333740234375,
        772.4472045898438
      ],
      [
        -362.65618896484375,
        -1953.9971923828125,
        771.9182739257812
      ],
      [
        -355.47674560546875,
        -1950.406005859375,
        770.4967651367188
      ],
      [
        -362.65618896484375,
        -1953.9971923828125,
        771.9182739257812
      ],
      [
        -365.45013427734375,
        -1961.2537841796875,
        762.0708618164062
      ],
      [
        -369.1579284667969,
        -1971.7943115234375,
        744.0810546875
      ],
      [
        -369.1579284667969,
        -1971.7943115234375,
        744.0810546875
      ],
      [
        -372.4570007324219,
        -1981.1728515625,
        728.0743408203125
      ],
      [
        -524.27197265625,
        -2100.602294921875,
        682.9840698242188
      ],
      [
        -570.8470458984375,
        -2080.698974609375,
        736.9747924804688
      ],
      [
        -442.9516906738281,
        -2035.7467041015625,
        695.844970703125
      ],
      [
        -398.94171142578125,
        -1969.27099609375,
        778.7999267578125
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -405.90997314453125,
        -1972.0,
        780.0999145507812
      ],
      [
        -372.4520263671875,
        -1958.8970947265625,
        773.8579711914062
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5552978515625
      ],
      [
        -365.873291015625,
        -1955.6063232421875,
        772.5552978515625
      ],
      [
        -404.59869384765625,
        -1972.0,
        778.7999267578125
      ],
      [
        -405.909912109375,
        -1972.0,
        780.0999145507812
      ],
      [
        -105.7713851928711,
        -1979.2572021484375,
        737.2568359375
      ],
      [
        -111.82113647460938,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -98.96548461914062,
        -2058.040283203125,
        665.5609741210938
      ],
      [
        -111.82113647460938,
        -2013.17724609375,
        741.7103881835938
      ],
      [
        -104.87355041503906,
        -2022.8271484375,
        741.7178955078125
      ],
      [
        -68.56507873535156,
        -2021.0675048828125,
        736.257080078125
      ],
      [
        -67.27250671386719,
        -2016.555419921875,
        735.5938110351562
      ],
      [
        -80.66110229492188,
        -2059.479248046875,
        657.8760986328125
      ],
      [
        -65.14533233642578,
        -1981.62548828125,
        731.603759765625
      ],
      [
        -80.69052124023438,
        -2059.5654296875,
        657.7005615234375
      ],
      [
        -80.66110229492188,
        -2059.479248046875,
        657.8760986328125
      ],
      [
        -67.27250671386719,
        -2016.555419921875,
        735.5938110351562
      ],
      [
        -98.96548461914062,
        -2058.040283203125,
        665.5609741210938
      ],
      [
        -80.77708435058594,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -80.69474792480469,
        -2059.564208984375,
        657.7044067382812
      ],
      [
        -80.7760009765625,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -80.46390533447266,
        -2049.75927734375,
        653.7388916015625
      ],
      [
        -80.49156188964844,
        -2049.109375,
        653.1491088867188
      ],
      [
        -98.30575561523438,
        -2051.547119140625,
        656.0745849609375
      ],
      [
        -97.63475036621094,
        -2049.502197265625,
        654.4420776367188
      ],
      [
        -98.30575561523438,
        -2051.547119140625,
        656.0745849609375
      ],
      [
        -98.35592651367188,
        -2061.6728515625,
        657.7044067382812
      ],
      [
        -78.50768280029297,
        -2051.778564453125,
        652.7044067382812
      ],
      [
        -80.68840026855469,
        -2059.56591796875,
        657.69921875
      ],
      [
        -80.69474792480469,
        -2059.564208984375,
        657.7044067382812
      ],
      [
        -80.6580581665039,
        -2059.573974609375,
        657.6742553710938
      ],
      [
        -76.02014923095703,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -80.6580581665039,
        -2059.573974609375,
        657.6742553710938
      ],
      [
        -72.18734741210938,
        -2062.0478515625,
        650.2849731445312
      ],
      [
        -73.61585235595703,
        -2061.798583984375,
        651.1747436523438
      ],
      [
        -76.02014923095703,
        -2061.3642578125,
        652.7044067382812
      ],
      [
        -73.61585235595703,
        -2061.798583984375,
        651.1747436523438
      ],
      [
        -98.96708679199219,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -100.01700592041016,
        -2062.45703125,
        656.4622192382812
      ],
      [
        -98.96708679199219,
        -2061.745849609375,
        657.7044067382812
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -187.0,
        -1987.0,
        749.8746948242188
      ],
      [
        -195.0,
        -1979.0,
        750.1939697265625
      ],
      [
        -195.0,
        -1987.0,
        751.0370483398438
      ],
      [
        -187.0,
        -1987.0,
        749.8746948242188
      ],
      [
        -187.0,
        -1979.0,
        749.0316772460938
      ],
      [
        -396.96240234375,
        -1972.0,
        778.7999267578125
      ],
      [
        -260.7839660644531,
        -2083.035888671875,
        653.5272827148438
      ],
      [
        -300.5304870605469,
        -2085.88525390625,
        657.5479736328125
      ],
      [
        -260.7839660644531,
        -2083.035888671875,
        653.5272827148438
      ],
      [
        -235.58065795898438,
        -2082.7275390625,
        647.8012084960938
      ],
      [
        -218.785400390625,
        -2083.685302734375,
        641.5188598632812
      ],
      [
        -235.58065795898438,
        -2082.7275390625,
        647.8012084960938
      ],
      [
        -314.93994140625,
        -2089.174072265625,
        654.2220458984375
      ],
      [
        -300.5304870605469,
        -2085.88525390625,
        657.5479736328125
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        660.9608764648438
      ],
      [
        -346.3417663574219,
        -2090.888427734375,
        658.53662109375
      ],
      [
        -348.068359375,
        -2089.29296875,
        662.3568725585938
      ],
      [
        -218.78538513183594,
        -2083.685302734375,
        641.5188598632812
      ],
      [
        -273.6723327636719,
        -2032.0,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.1334838867188
      ],
      [
        -300.0,
        -2022.0,
        769.9810791015625
      ],
      [
        -290.1921691894531,
        -2031.807861328125,
        769.5896606445312
      ],
      [
        -290.0,
        -2032.0,
        769.1334838867188
      ],
      [
        -311.5650634765625,
        -1992.0,
        768.5
      ],
      [
        -320.0,
        -1992.0,
        769.7255249023438
      ],
      [
        -320.0,
        -1992.0,
        769.7255249023438
      ],
      [
        -325.0,
        -1987.0,
        769.925048828125
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -103.19319152832031,
        -2064.608642578125,
        652.7044067382812
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -107.14860534667969,
        -2069.031982421875,
        644.3267211914062
      ],
      [
        -105.54733276367188,
        -2067.07861328125,
        648.0633544921875
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        644.2874145507812
      ],
      [
        -108.2637939453125,
        -2066.781005859375,
        643.1660766601562
      ],
      [
        -100.88525390625,
        -2070.1806640625,
        640.3057250976562
      ],
      [
        -350.6188049316406,
        -2086.93603515625,
        667.9999389648438
      ],
      [
        -351.123291015625,
        -2086.4697265625,
        669.1162109375
      ],
      [
        -350.6188049316406,
        -2086.93603515625,
        667.9999389648438
      ],
      [
        -54.307289123535156,
        -2189.92578125,
        751.9800415039062
      ],
      [
        108.49942016601562,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        -505.26220703125,
        -2261.550537109375,
        690.6813354492188
      ],
      [
        -522.5567016601562,
        -2263.22607421875,
        679.4786987304688
      ],
      [
        -210.5,
        -2371.5,
        793.8082275390625
      ],
      [
        -207.0,
        -2371.5,
        793.2997436523438
      ],
      [
        -195.5,
        -2371.5,
        791.6288452148438
      ],
      [
        -199.0,
        -2371.5,
        792.1373901367188
      ],
      [
        -207.0,
        -2371.5,
        793.2997436523438
      ],
      [
        -207.0,
        -2373.0,
        793.4578247070312
      ],
      [
        -199.0,
        -2371.5,
        784.6668090820312
      ],
      [
        -199.0,
        -2373.0,
        792.2954711914062
      ],
      [
        -199.0,
        -2371.5,
        792.1373901367188
      ],
      [
        -195.5,
        -2360.5,
        790.4696655273438
      ],
      [
        -210.5,
        -2360.5,
        792.6490478515625
      ],
      [
        -195.5,
        -2360.5,
        790.4696655273438
      ],
      [
        -195.5,
        -2371.5,
        791.6288452148438
      ],
      [
        -210.5,
        -2371.5,
        793.8082275390625
      ],
      [
        -210.5,
        -2360.5,
        792.6490478515625
      ],
      [
        115.12509155273438,
        -2156.200927734375,
        723.8088989257812
      ],
      [
        110.78501892089844,
        -2156.85595703125,
        724.5084838867188
      ],
      [
        108.49942016601562,
        -2158.119384765625,
        724.9736938476562
      ],
      [
        110.78501892089844,
        -2156.85595703125,
        724.5084838867188
      ],
      [
        -370.3136901855469,
        -2233.106689453125,
        802.4439086914062
      ],
      [
        -443.2167053222656,
        -2206.14794921875,
        690.954345703125
      ],
      [
        -364.8431091308594,
        -2228.631103515625,
        801.1774291992188
      ],
      [
        -137.877685546875,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -133.850341796875,
        -2167.28466796875,
        669.0948486328125
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383666992188
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712036132812
      ],
      [
        -94.33013153076172,
        -2187.80908203125,
        757.572021484375
      ],
      [
        -133.8499755859375,
        -2167.284912109375,
        669.0949096679688
      ],
      [
        -95.86370849609375,
        -2187.012451171875,
        754.1383056640625
      ],
      [
        -84.30427551269531,
        -2188.33935546875,
        756.1712036132812
      ],
      [
        -54.307289123535156,
        -2189.92578125,
        751.9800415039062
      ],
      [
        -509.9615173339844,
        -2241.701416015625,
        678.1668090820312
      ],
      [
        -138.9290771484375,
        -2164.698486328125,
        657.9075927734375
      ],
      [
        -137.87770080566406,
        -2165.193115234375,
        660.0780029296875
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -105.28595733642578,
        -2160.9189453125,
        623.7440795898438
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -80.69756317138672,
        -2173.240966796875,
        677.7044067382812
      ],
      [
        -99.88970184326172,
        -2171.7001953125,
        677.7044067382812
      ],
      [
        -102.34302520751953,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -105.28976440429688,
        -2166.400146484375,
        652.7044067382812
      ],
      [
        -99.88549041748047,
        -2167.778076171875,
        657.7044067382812
      ],
      [
        -102.34302520751953,
        -2167.15185546875,
        655.4332885742188
      ],
      [
        -139.03781127929688,
        -2164.591064453125,
        657.4826049804688
      ],
      [
        -138.9290771484375,
        -2164.698486328125,
        657.9075927734375
      ],
      [
        -105.28579711914062,
        -2160.685302734375,
        623.748779296875
      ],
      [
        -105.28959655761719,
        -2166.15869140625,
        651.6570434570312
      ],
      [
        -102.34599304199219,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.28974151611328,
        -2166.364013671875,
        652.7044067382812
      ],
      [
        -102.34599304199219,
        -2167.134765625,
        655.4305419921875
      ],
      [
        -105.28974151611328,
        -2166.364013671875,
        652.7044067382812
      ],
      [
        -139.03756713867188,
        -2164.591064453125,
        657.4825439453125
      ],
      [
        -70.35123443603516,
        -2150.10498046875,
        631.6542358398438
      ],
      [
        -105.28959655761719,
        -2166.15625,
        651.6456298828125
      ],
      [
        -105.2795181274414,
        -2151.646240234375,
        623.9295654296875
      ],
      [
        -105.2835693359375,
        -2157.472412109375,
        644.7900390625
      ],
      [
        26.06302833557129,
        -2132.764404296875,
        606.1185302734375
      ],
      [
        -70.35123443603516,
        -2150.10498046875,
        631.6542358398438
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -80.69480895996094,
        -2164.060546875,
        677.7044067382812
      ],
      [
        -99.88368225097656,
        -2166.092529296875,
        677.7044067382812
      ],
      [
        -105.28510284423828,
        -2159.682861328125,
        652.7044067382812
      ],
      [
        -103.59709930419922,
        -2159.940673828125,
        654.2675170898438
      ],
      [
        -105.28510284423828,
        -2159.682861328125,
        652.7044067382812
      ],
      [
        -99.877685546875,
        -2160.506591796875,
        657.7044067382812
      ],
      [
        -103.59709930419922,
        -2159.940673828125,
        654.2675170898438
      ],
      [
        -443.2167053222656,
        -2206.14794921875,
        690.954345703125
      ],
      [
        -471.8009338378906,
        -2204.337158203125,
        673.6325073242188
      ],
      [
        -214.3408660888672,
        -2179.7744140625,
        774.1619873046875
      ],
      [
        -256.0735168457031,
        -2167.5234375,
        778.9343872070312
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -343.83367919921875,
        -2211.443115234375,
        796.3135986328125
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.8031616210938
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -278.7548522949219,
        -2146.581298828125,
        732.8900146484375
      ],
      [
        -256.0735168457031,
        -2167.5234375,
        778.9343872070312
      ],
      [
        -260.9524230957031,
        -2166.373291015625,
        779.5220336914062
      ],
      [
        -338.6815490722656,
        -2134.919677734375,
        667.9999389648438
      ],
      [
        -339.290283203125,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -390.7622985839844,
        -2160.5009765625,
        667.9999389648438
      ],
      [
        -352.2374267578125,
        -2141.043212890625,
        667.9999389648438
      ],
      [
        -339.290283203125,
        -2135.19482421875,
        667.9999389648438
      ],
      [
        -318.5452880859375,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -323.1556091308594,
        -2119.992431640625,
        654.7405395507812
      ],
      [
        -337.61962890625,
        -2136.82763671875,
        671.9999389648438
      ],
      [
        -317.15447998046875,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -318.5452880859375,
        -2125.823974609375,
        667.9999389648438
      ],
      [
        -317.15447998046875,
        -2127.583251953125,
        671.9999389648438
      ],
      [
        -291.5123291015625,
        -2183.931884765625,
        785.8125
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371337890625
      ],
      [
        -322.5062255859375,
        -2198.047119140625,
        791.8031616210938
      ],
      [
        -302.4618225097656,
        -2188.997314453125,
        787.9371337890625
      ],
      [
        -295.62738037109375,
        -2134.037109375,
        705.107177734375
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -279.776123046875,
        -2177.188720703125,
        783.396728515625
      ],
      [
        -298.5732421875,
        -2128.282470703125,
        692.6575317382812
      ],
      [
        -263.1219482421875,
        -2165.86181640625,
        779.7833251953125
      ],
      [
        -294.1927490234375,
        -2133.649658203125,
        705.6873168945312
      ],
      [
        -337.9850158691406,
        -2136.171142578125,
        671.9999389648438
      ],
      [
        -318.24664306640625,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.5613098144531,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -318.24664306640625,
        -2126.201904296875,
        671.9999389648438
      ],
      [
        -319.5613098144531,
        -2124.538818359375,
        667.9999389648438
      ],
      [
        -323.88018798828125,
        -2119.075927734375,
        654.8593139648438
      ],
      [
        -338.9958190917969,
        -2134.35498046875,
        667.9999389648438
      ],
      [
        -339.62249755859375,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -339.62249755859375,
        -2134.671630859375,
        667.9999389648438
      ],
      [
        -294.1368408203125,
        -2133.71826171875,
        705.8535766601562
      ],
      [
        -263.16839599609375,
        -2165.850830078125,
        779.7889404296875
      ],
      [
        -267.2416076660156,
        -2168.66357421875,
        780.6771850585938
      ],
      [
        -295.62738037109375,
        -2134.037109375,
        705.107177734375
      ],
      [
        -263.16839599609375,
        -2165.850830078125,
        779.7889404296875
      ],
      [
        -294.1368408203125,
        -2133.71826171875,
        705.8535766601562
      ],
      [
        -370.0530090332031,
        -2143.47509765625,
        669.8417358398438
      ],
      [
        -361.6016845703125,
        -2140.759765625,
        671.052490234375
      ],
      [
        -342.22503662109375,
        -2128.552978515625,
        667.9999389648438
      ],
      [
        -343.2315673828125,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -392.83599853515625,
        -2157.3134765625,
        667.9999389648438
      ],
      [
        -365.6939697265625,
        -2139.34716796875,
        667.9999389648438
      ],
      [
        -352.1156311035156,
        -2132.833984375,
        667.9999389648438
      ],
      [
        -343.2314758300781,
        -2128.98828125,
        667.9999389648438
      ],
      [
        -322.97528076171875,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -328.560302734375,
        -2113.156005859375,
        660.4228515625
      ],
      [
        -331.3143310546875,
        -2109.672607421875,
        656.077880859375
      ],
      [
        -339.9801940917969,
        -2132.58642578125,
        671.9999389648438
      ],
      [
        -320.0272216796875,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -322.97528076171875,
        -2120.220458984375,
        667.9999389648438
      ],
      [
        -320.0272216796875,
        -2123.94970703125,
        671.9999389648438
      ],
      [
        -348.8783264160156,
        -2148.298828125,
        683.38916015625
      ],
      [
        -349.05096435546875,
        -2140.84326171875,
        676.5720825195312
      ],
      [
        -340.4855041503906,
        -2131.678466796875,
        671.9999389648438
      ],
      [
        -321.22222900390625,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.757568359375,
        -2119.23095703125,
        667.9999389648438
      ],
      [
        -321.22222900390625,
        -2122.438232421875,
        671.9999389648438
      ],
      [
        -323.757568359375,
        -2119.23095703125,
        667.9999389648438
      ],
      [
        -342.42852783203125,
        -2128.187255859375,
        667.9999389648438
      ],
      [
        -343.4339599609375,
        -2128.669677734375,
        667.9999389648438
      ],
      [
        -343.4339599609375,
        -2128.66943359375,
        667.9999389648438
      ],
      [
        -361.024169921875,
        -2141.6953125,
        671.9999389648438
      ],
      [
        -361.6016845703125,
        -2140.759765625,
        671.052490234375
      ],
      [
        -359.44732666015625,
        -2140.774169921875,
        671.9999389648438
      ],
      [
        -349.05096435546875,
        -2140.84326171875,
        676.5720825195312
      ],
      [
        -363.35614013671875,
        -2137.91748046875,
        668.1741943359375
      ],
      [
        -362.9183654785156,
        -2137.510009765625,
        667.9999389648438
      ],
      [
        -352.1156311035156,
        -2132.833984375,
        667.9999389648438
      ],
      [
        -331.7146301269531,
        -2109.166259765625,
        656.1434936523438
      ],
      [
        -328.56005859375,
        -2113.156494140625,
        660.4232177734375
      ],
      [
        -294.1927490234375,
        -2133.649658203125,
        705.6873168945312
      ],
      [
        -329.0223083496094,
        -2112.57177734375,
        664.2924194335938
      ],
      [
        -326.6051940917969,
        -2110.63525390625,
        663.7936401367188
      ],
      [
        -341.31854248046875,
        -2130.181640625,
        671.9999389648438
      ],
      [
        -322.4369812011719,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -359.682373046875,
        -2135.367919921875,
        668.0
      ],
      [
        -362.8336181640625,
        -2137.530517578125,
        668.1135864257812
      ],
      [
        -343.9416809082031,
        -2125.468505859375,
        667.9999389648438
      ],
      [
        -345.03155517578125,
        -2126.153564453125,
        667.9999389648438
      ],
      [
        -359.6785888671875,
        -2135.365478515625,
        667.9999389648438
      ],
      [
        -345.03155517578125,
        -2126.153564453125,
        667.9999389648438
      ],
      [
        -325.8543701171875,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -329.02239990234375,
        -2112.57177734375,
        664.2921142578125
      ],
      [
        -331.8667907714844,
        -2108.973876953125,
        656.16845703125
      ],
      [
        -325.8543701171875,
        -2116.578857421875,
        667.9999389648438
      ],
      [
        -322.4369812011719,
        -2120.901611328125,
        671.9999389648438
      ],
      [
        -359.44732666015625,
        -2140.774169921875,
        671.9999389648438
      ],
      [
        -363.35614013671875,
        -2137.91748046875,
        668.1741943359375
      ],
      [
        -362.8336181640625,
        -2137.530517578125,
        668.1135864257812
      ],
      [
        -345.10400390625,
        -2126.03955078125,
        667.9999389648438
      ],
      [
        -346.99072265625,
        -2126.967041015625,
        667.9999389648438
      ],
      [
        -345.10400390625,
        -2126.03955078125,
        667.9999389648438
      ],
      [
        -343.0555419921875,
        -2127.060791015625,
        671.9999389648438
      ],
      [
        -326.3236389160156,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.72412109375,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -326.3236389160156,
        -2115.9853515625,
        671.9999389648438
      ],
      [
        -327.72412109375,
        -2114.2138671875,
        667.9999389648438
      ],
      [
        -344.153076171875,
        -2125.088623046875,
        667.9999389648438
      ],
      [
        -345.2477722167969,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -345.2477722167969,
        -2125.813232421875,
        667.9999389648438
      ],
      [
        -601.5318603515625,
        -2064.8515625,
        814.154052734375
      ],
      [
        -566.950439453125,
        -2063.758056640625,
        771.9077758789062
      ],
      [
        -395.2884216308594,
        -2153.543701171875,
        667.9999389648438
      ],
      [
        -365.69598388671875,
        -2139.3486328125,
        667.9999389648438
      ],
      [
        -396.04437255859375,
        -2152.381591796875,
        667.9999389648438
      ],
      [
        -392.9281921386719,
        -2150.49951171875,
        667.9999389648438
      ],
      [
        -362.9175109863281,
        -2137.509521484375,
        667.9999389648438
      ],
      [
        -396.31500244140625,
        -2151.965576171875,
        667.9999389648438
      ],
      [
        -357.05364990234375,
        -2101.909423828125,
        667.9999389648438
      ],
      [
        -359.3388977050781,
        -2101.161865234375,
        667.9999389648438
      ],
      [
        -330.61334228515625,
        -2110.559326171875,
        667.9999389648438
      ],
      [
        -334.1989440917969,
        -2106.02392578125,
        656.5507202148438
      ],
      [
        -333.36688232421875,
        -2107.076416015625,
        659.2074584960938
      ],
      [
        -356.2543640136719,
        -2103.345703125,
        671.9999389648438
      ],
      [
        -329.3607177734375,
        -2112.143798828125,
        671.9999389648438
      ],
      [
        -330.61334228515625,
        -2110.559326171875,
        667.9999389648438
      ],
      [
        -329.3607177734375,
        -2112.143798828125,
        671.9999389648438
      ],
      [
        115.12509155273438,
        -2156.200927734375,
        723.808837890625
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -105.2828140258789,
        -2156.387451171875,
        640.9058837890625
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        625.143310546875
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.543701171875
      ],
      [
        -92.5,
        -2138.245849609375,
        627.3795776367188
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        622.4317016601562
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        625.9423217773438
      ],
      [
        -91.48381805419922,
        -2130.76416015625,
        622.4384765625
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        636.99072265625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        631.2246704101562
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        634.4107666015625
      ],
      [
        -334.9626159667969,
        -2105.05810546875,
        656.6759033203125
      ],
      [
        -333.69879150390625,
        -2106.656494140625,
        658.1477661132812
      ],
      [
        -335.4600830078125,
        -2104.428955078125,
        656.7574462890625
      ],
      [
        -333.36700439453125,
        -2107.076171875,
        659.2072143554688
      ],
      [
        -338.656494140625,
        -2100.3857421875,
        667.9999389648438
      ],
      [
        -332.4829406738281,
        -2108.194580078125,
        671.9999389648438
      ],
      [
        -338.656494140625,
        -2100.3857421875,
        667.9999389648438
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        663.4459838867188
      ],
      [
        -332.48297119140625,
        -2108.194580078125,
        671.9999389648438
      ],
      [
        -345.89349365234375,
        -2106.735107421875,
        671.9999389648438
      ],
      [
        -348.068359375,
        -2089.29296875,
        662.3568725585938
      ],
      [
        -345.68505859375,
        -2091.495361328125,
        663.4459838867188
      ],
      [
        -114.99471282958984,
        -2097.310302734375,
        626.3668212890625
      ],
      [
        -189.77603149414062,
        -2082.166748046875,
        637.3945922851562
      ],
      [
        -128.5983428955078,
        -2162.389404296875,
        653.5570678710938
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.105712890625
      ],
      [
        -105.28356170654297,
        -2157.47216796875,
        644.7898559570312
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        629.813232421875
      ],
      [
        -98.66931915283203,
        -2138.74755859375,
        628.6243896484375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.025634765625
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        639.105712890625
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        632.042724609375
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        636.025634765625
      ],
      [
        -92.5,
        -2138.245849609375,
        636.5562133789062
      ],
      [
        -92.49179077148438,
        -2138.185302734375,
        636.5319213867188
      ],
      [
        -92.49179077148438,
        -2138.185302734375,
        636.5319213867188
      ],
      [
        -91.10107421875,
        -2127.946044921875,
        632.4207763671875
      ],
      [
        -90.278564453125,
        -2135.27197265625,
        634.9574584960938
      ],
      [
        -92.20443725585938,
        -2136.069580078125,
        635.6824340820312
      ],
      [
        -92.2044448852539,
        -2136.06982421875,
        625.9423217773438
      ],
      [
        -100.88525390625,
        -2139.665283203125,
        638.9500732421875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        643.8660888671875
      ],
      [
        -105.28394317626953,
        -2158.017822265625,
        646.7431030273438
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        642.92138671875
      ],
      [
        -105.278564453125,
        -2150.27197265625,
        643.8660888671875
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        641.6494750976562
      ],
      [
        -109.34033203125,
        -2145.291259765625,
        642.92138671875
      ],
      [
        -108.05611419677734,
        -2142.635498046875,
        633.6602172851562
      ],
      [
        -107.177978515625,
        -2140.8193359375,
        640.7797241210938
      ],
      [
        138.8248291015625,
        -2079.12548828125,
        712.2431640625
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        -209.06512451171875,
        -2181.046875,
        773.5294799804688
      ],
      [
        -214.3408660888672,
        -2179.7744140625,
        774.1619873046875
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -186.7020721435547,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -160.2327880859375,
        -2184.0478515625,
        766.7507934570312
      ],
      [
        -186.7020721435547,
        -2182.421142578125,
        770.4251708984375
      ],
      [
        -209.06512451171875,
        -2181.046875,
        773.529541015625
      ],
      [
        -137.9745330810547,
        -2185.415771484375,
        763.6610107421875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.282958984375
      ],
      [
        126.47466278076172,
        -2057.659423828125,
        711.775390625
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -128.04714965820312,
        -2186.02587890625,
        762.2828979492188
      ],
      [
        -95.67296600341797,
        -2187.738037109375,
        757.7596435546875
      ],
      [
        -75.01756286621094,
        -2043.592041015625,
        739.5682373046875
      ],
      [
        -90.22784423828125,
        -2043.1693115234375,
        741.733642578125
      ],
      [
        -75.01756286621094,
        -2043.592041015625,
        739.5682373046875
      ],
      [
        -90.22784423828125,
        -2043.1693115234375,
        741.733642578125
      ],
      [
        -80.77599334716797,
        -2059.573974609375,
        657.7044067382812
      ],
      [
        -80.68840026855469,
        -2059.56591796875,
        657.69921875
      ],
      [
        -258.4635009765625,
        -2032.0,
        765.0
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -290.0,
        -2032.0,
        769.5819702148438
      ],
      [
        -597.4422607421875,
        -2061.258056640625,
        817.3342895507812
      ],
      [
        -84.37628936767578,
        -2072.129150390625,
        652.7044067382812
      ],
      [
        -84.68487548828125,
        -2072.257080078125,
        631.8021850585938
      ],
      [
        -84.37628936767578,
        -2072.129150390625,
        652.7044067382812
      ],
      [
        -82.84538269042969,
        -2067.00732421875,
        656.8504028320312
      ],
      [
        -106.26387786865234,
        -2067.95263671875,
        646.3912353515625
      ],
      [
        -82.84538269042969,
        -2067.00732421875,
        656.8504028320312
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        641.2166748046875
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        645.4983520507812
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        645.4983520507812
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        648.5706787109375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        636.5319213867188
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        641.2166748046875
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        648.5706787109375
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        651.2399291992188
      ],
      [
        -92.20442962646484,
        -2073.776123046875,
        630.4844970703125
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        636.5319213867188
      ],
      [
        -92.20443725585938,
        -2073.776123046875,
        651.2399291992188
      ],
      [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      [
        -90.27850341796875,
        -2074.573974609375,
        651.2399291992188
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        641.2166748046875
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        645.4983520507812
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        645.4983520507812
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        648.5706787109375
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        636.5319213867188
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        641.2166748046875
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        648.5706787109375
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        651.2399291992188
      ],
      [
        -91.99927520751953,
        -2075.28662109375,
        627.2299194335938
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        636.5319213867188
      ],
      [
        -91.9992904663086,
        -2075.28662109375,
        651.2399291992188
      ],
      [
        -106.50885009765625,
        -2148.763427734375,
        650.1549682617188
      ],
      [
        -104.61626434326172,
        -2142.14794921875,
        648.9901733398438
      ],
      [
        -106.50885009765625,
        -2148.763427734375,
        650.1549682617188
      ],
      [
        -106.57212829589844,
        -2148.685791015625,
        643.5652465820312
      ],
      [
        -104.07628631591797,
        -2140.25048828125,
        648.4361572265625
      ],
      [
        -104.61624145507812,
        -2142.14794921875,
        648.990234375
      ],
      [
        -83.65042114257812,
        -2069.70068359375,
        654.6702270507812
      ],
      [
        -83.44608306884766,
        -2069.01708984375,
        655.2236328125
      ],
      [
        -84.4102783203125,
        -2144.114501953125,
        656.5999755859375
      ],
      [
        -81.70118713378906,
        -2150.65478515625,
        656.5999755859375
      ],
      [
        -85.5081787109375,
        -2141.464599609375,
        656.5999755859375
      ],
      [
        -88.83558654785156,
        -2140.086181640625,
        656.5999755859375
      ],
      [
        -83.74588775634766,
        -2137.977783203125,
        652.7044067382812
      ],
      [
        -96.65662384033203,
        -2143.32568359375,
        659.7044067382812
      ],
      [
        -90.95934295654297,
        -2140.9658203125,
        659.7044067382812
      ],
      [
        -90.60578918457031,
        -2141.8193359375,
        659.7044067382812
      ],
      [
        -96.29560089111328,
        -2144.176025390625,
        659.7044067382812
      ],
      [
        -87.16275787353516,
        -2141.974609375,
        657.7044067382812
      ],
      [
        -93.44232940673828,
        -2144.5,
        659.7044067382812
      ],
      [
        -95.74359130859375,
        -2145.476806640625,
        659.7044067382812
      ],
      [
        -99.86067199707031,
        -2144.653076171875,
        655.5597534179688
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        638.5621948242188
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -99.8548583984375,
        -2139.238525390625,
        652.7044067382812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        645.4983520507812
      ],
      [
        -92.20441436767578,
        -2136.069580078125,
        641.2166748046875
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        648.5706787109375
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        636.5319213867188
      ],
      [
        -92.2044448852539,
        -2136.069580078125,
        635.6824951171875
      ],
      [
        -88.47034454345703,
        -2134.52294921875,
        651.2399291992188
      ],
      [
        -92.20442199707031,
        -2136.069580078125,
        651.2399291992188
      ],
      [
        -99.8564224243164,
        -2140.694091796875,
        654.0486450195312
      ],
      [
        -104.31387329101562,
        -2141.08544921875,
        648.679931640625
      ],
      [
        -698.2745361328125,
        -2408.3671875,
        1479.6412353515625
      ],
      [
        -732.7146606445312,
        -2333.08203125,
        1138.8837890625
      ],
      [
        -783.6491088867188,
        -2253.35400390625,
        974.8684692382812
      ],
      [
        -781.6624145507812,
        -2256.458740234375,
        999.0401611328125
      ],
      [
        -783.6491088867188,
        -2253.35400390625,
        974.8685302734375
      ],
      [
        -787.02587890625,
        -2248.078369140625,
        929.3057861328125
      ],
      [
        -787.02587890625,
        -2248.078369140625,
        929.3057861328125
      ],
      [
        -792.2825317382812,
        -2239.863525390625,
        864.4647827148438
      ],
      [
        -779.0326538085938,
        -2261.742919921875,
        1062.6337890625
      ],
      [
        -779.9500732421875,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -733.7513427734375,
        -2332.292724609375,
        1165.042236328125
      ],
      [
        -733.7013549804688,
        -2332.134033203125,
        1156.9886474609375
      ],
      [
        -733.4500122070312,
        -2333.14013671875,
        1178.7674560546875
      ],
      [
        -733.7513427734375,
        -2332.292724609375,
        1165.042236328125
      ],
      [
        -732.7146606445312,
        -2333.08203125,
        1138.8837890625
      ],
      [
        -733.7013549804688,
        -2332.134033203125,
        1156.9886474609375
      ],
      [
        -733.4500122070312,
        -2333.14013671875,
        1178.7674560546875
      ],
      [
        -758.3310546875,
        -2310.554931640625,
        866.9813842773438
      ],
      [
        -779.0326538085938,
        -2261.742919921875,
        1062.6336669921875
      ],
      [
        -777.7197875976562,
        -2262.62646484375,
        1025.492919921875
      ],
      [
        -774.6849975585938,
        -2267.394775390625,
        972.223876953125
      ],
      [
        -774.6849975585938,
        -2267.394775390625,
        972.223876953125
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -770.5025634765625,
        -2273.9755859375,
        864.8950805664062
      ],
      [
        -773.9362182617188,
        -2268.5849609375,
        910.4227905273438
      ],
      [
        -771.3636474609375,
        -2272.616455078125,
        902.14453125
      ],
      [
        -773.9362182617188,
        -2268.5849609375,
        910.4227905273438
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -783.2196044921875,
        -2249.745361328125,
        864.1893920898438
      ],
      [
        -772.1714477539062,
        -2266.23828125,
        864.3221435546875
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -774.7032470703125,
        -2264.4326171875,
        932.4190063476562
      ],
      [
        -775.706787109375,
        -2263.27197265625,
        944.060791015625
      ],
      [
        -775.0944213867188,
        -2264.15380859375,
        942.9473266601562
      ],
      [
        -775.706787109375,
        -2263.27197265625,
        944.060791015625
      ],
      [
        -771.7662963867188,
        -2271.985595703125,
        903.440185546875
      ],
      [
        -775.6287231445312,
        -2264.03369140625,
        966.3355712890625
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -775.6287231445312,
        -2264.03369140625,
        966.3355712890625
      ],
      [
        -774.9893798828125,
        -2264.304931640625,
        942.7564086914062
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.5385131835938
      ],
      [
        -781.0300903320312,
        -2256.06494140625,
        969.53857421875
      ],
      [
        -781.3290405273438,
        -2254.945068359375,
        946.2813720703125
      ],
      [
        -718.0741577148438,
        -2355.997802734375,
        1190.5146484375
      ],
      [
        -732.9429321289062,
        -2332.72021484375,
        1154.580322265625
      ],
      [
        -733.1165161132812,
        -2332.730224609375,
        1164.02734375
      ],
      [
        -718.07421875,
        -2355.997802734375,
        1190.5146484375
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20263671875
      ],
      [
        -779.9500732421875,
        -2259.135009765625,
        1019.874267578125
      ],
      [
        -778.4437866210938,
        -2261.489013671875,
        1038.20263671875
      ],
      [
        -777.719970703125,
        -2262.626220703125,
        1025.497314453125
      ],
      [
        -732.9429321289062,
        -2332.72021484375,
        1154.580322265625
      ],
      [
        -733.1771850585938,
        -2332.494384765625,
        1158.943359375
      ],
      [
        -733.1165161132812,
        -2332.730224609375,
        1164.02734375
      ],
      [
        -733.18798828125,
        -2332.5322265625,
        1160.837646484375
      ],
      [
        -733.18798828125,
        -2332.5322265625,
        1160.837646484375
      ],
      [
        -733.1771850585938,
        -2332.494384765625,
        1158.943359375
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -781.840576171875,
        -2251.2490234375,
        864.1474609375
      ],
      [
        -772.4083862304688,
        -2265.36767578125,
        864.2648315429688
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.2893676757812,
        -2263.2548828125,
        941.2236938476562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -775.980712890625,
        -2262.449951171875,
        949.26513671875
      ],
      [
        -775.0944213867188,
        -2264.15380859375,
        942.9473266601562
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -778.34228515625,
        -2261.6484375,
        1036.420654296875
      ],
      [
        -775.9306640625,
        -2262.95849609375,
        964.4517822265625
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -775.4889526367188,
        -2263.15966796875,
        948.3524169921875
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.5615234375,
        -2257.5849609375,
        966.5499267578125
      ],
      [
        -779.7763061523438,
        -2256.816650390625,
        950.9082641601562
      ],
      [
        -778.195068359375,
        -2261.3818359375,
        1027.882080078125
      ],
      [
        -775.5611572265625,
        -2263.055419921875,
        948.4863891601562
      ],
      [
        -778.0450439453125,
        -2261.486328125,
        1023.680419921875
      ],
      [
        -54.50433349609375,
        -1975.6207275390625,
        809.7101440429688
      ],
      [
        -61.49348831176758,
        -1972.1915283203125,
        754.1234741210938
      ],
      [
        -54.50433349609375,
        -1975.6207275390625,
        809.710205078125
      ],
      [
        -131.19256591796875,
        -1937.994140625,
        877.8367919921875
      ],
      [
        -119.52893829345703,
        -1943.7169189453125,
        822.0950927734375
      ],
      [
        -131.19256591796875,
        -1937.994140625,
        877.8367919921875
      ],
      [
        -17.90656280517578,
        -1993.5772705078125,
        725.9998168945312
      ],
      [
        131.89161682128906,
        -2067.07470703125,
        711.9805908203125
      ],
      [
        -54.583187103271484,
        -1975.87353515625,
        809.25244140625
      ],
      [
        -129.078369140625,
        -1946.1995849609375,
        862.97998046875
      ],
      [
        -116.65182495117188,
        -1951.1494140625,
        804.3529052734375
      ],
      [
        -129.078369140625,
        -1946.1995849609375,
        862.97998046875
      ],
      [
        -61.8051872253418,
        -1972.9967041015625,
        752.2013549804688
      ],
      [
        -54.583187103271484,
        -1975.87353515625,
        809.2525024414062
      ],
      [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      [
        -170.0,
        -1924.0889892578125,
        765.0
      ],
      [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      [
        -171.66697692871094,
        -1920.0,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -180.0,
        -1925.915771484375,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      [
        -118.56554412841797,
        -1950.38720703125,
        813.3817138671875
      ],
      [
        -54.71514129638672,
        -1975.821044921875,
        797.9343872070312
      ],
      [
        -55.01028823852539,
        -1976.522216796875,
        790.7861328125
      ],
      [
        -103.21553802490234,
        -1964.927001953125,
        735.3753662109375
      ],
      [
        -55.010292053222656,
        -1976.522216796875,
        790.7861328125
      ],
      [
        -57.04606246948242,
        -1980.856689453125,
        730.3460083007812
      ],
      [
        -63.7107048034668,
        -1977.9193115234375,
        740.4506225585938
      ],
      [
        -57.608158111572266,
        -1976.0811767578125,
        786.1773681640625
      ],
      [
        -55.97739028930664,
        -1975.318115234375,
        798.2388305664062
      ],
      [
        -64.19151306152344,
        -1979.161376953125,
        737.4856567382812
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -144.57388305664062,
        -1940.0272216796875,
        819.6739501953125
      ],
      [
        -156.7864990234375,
        -1941.345947265625,
        768.1051025390625
      ],
      [
        -152.91407775878906,
        -1956.10107421875,
        741.6661376953125
      ],
      [
        -497.283447265625,
        -1979.7894287109375,
        1066.3836669921875
      ],
      [
        -497.2213439941406,
        -1977.98486328125,
        1075.6270751953125
      ],
      [
        -497.283447265625,
        -1979.7894287109375,
        1066.3836669921875
      ],
      [
        -494.2233581542969,
        -1977.7279052734375,
        1076.9432373046875
      ],
      [
        -493.35882568359375,
        -1977.131103515625,
        1080.0
      ],
      [
        -494.2233581542969,
        -1977.7279052734375,
        1076.9432373046875
      ],
      [
        -433.4872741699219,
        -1935.8033447265625,
        892.0023193359375
      ],
      [
        -433.4873352050781,
        -1935.8033447265625,
        912.0
      ],
      [
        -433.4873352050781,
        -1935.8033447265625,
        912.0
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      [
        -431.2306213378906,
        -1934.76953125,
        1080.0
      ],
      [
        -434.07354736328125,
        -1936.417724609375,
        960.4888305664062
      ],
      [
        -434.07354736328125,
        -1936.417724609375,
        960.4888305664062
      ],
      [
        -433.45745849609375,
        -1935.8306884765625,
        892.0023193359375
      ],
      [
        -433.4269714355469,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      [
        -421.84124755859375,
        -1928.0,
        930.0
      ],
      [
        -433.4269714355469,
        -1935.858642578125,
        912.0
      ],
      [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        892.0023193359375
      ],
      [
        -348.0,
        -1905.1326904296875,
        766.0
      ],
      [
        -348.0,
        -1905.1326904296875,
        912.0
      ],
      [
        -360.0,
        -1907.0894775390625,
        930.0
      ],
      [
        -433.3038635253906,
        -1935.971435546875,
        892.0023193359375
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      [
        -419.55340576171875,
        -1928.0,
        930.0
      ],
      [
        -433.3038330078125,
        -1935.9715576171875,
        912.0
      ],
      [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      [
        -348.0,
        -1928.0,
        818.517333984375
      ],
      [
        -348.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      [
        -360.0,
        -1939.0,
        799.35302734375
      ],
      [
        -348.0,
        -1928.0,
        818.517333984375
      ],
      [
        -360.0,
        -1939.0,
        799.35302734375
      ],
      [
        -369.0,
        -1939.0,
        804.1192626953125
      ],
      [
        -369.0,
        -1947.25,
        784.97998046875
      ],
      [
        -369.0,
        -1939.0,
        804.1193237304688
      ],
      [
        -369.0,
        -1947.25,
        772.1289672851562
      ],
      [
        -369.0,
        -1950.0,
        778.60009765625
      ],
      [
        -300.0,
        -1937.9559326171875,
        770.0
      ],
      [
        -290.0,
        -1935.67333984375,
        770.0
      ],
      [
        -514.3709106445312,
        -2022.4786376953125,
        801.177978515625
      ],
      [
        -408.11614990234375,
        -1972.0,
        780.42041015625
      ],
      [
        -414.0,
        -1972.0,
        788.1212768554688
      ],
      [
        -379.35943603515625,
        -1926.01708984375,
        839.7252807617188
      ],
      [
        -382.8941955566406,
        -1927.9451904296875,
        840.1409912109375
      ],
      [
        -407.739990234375,
        -1972.0,
        780.3657836914062
      ],
      [
        -414.00189208984375,
        -1975.1689453125,
        781.6095581054688
      ],
      [
        -180.0,
        -1942.098876953125,
        770.0
      ],
      [
        -200.0,
        -1943.6776123046875,
        770.0
      ],
      [
        -290.0,
        -1943.264892578125,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -270.0,
        -1944.6416015625,
        770.0
      ],
      [
        -200.0,
        -1943.6776123046875,
        770.0
      ],
      [
        -224.7366180419922,
        -1945.630126953125,
        770.0
      ],
      [
        -247.4969940185547,
        -1946.1907958984375,
        770.0
      ],
      [
        -300.0,
        -1942.5765380859375,
        770.0
      ],
      [
        -290.0,
        -1943.2650146484375,
        770.0
      ],
      [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      [
        -180.0,
        -1942.098876953125,
        770.0
      ],
      [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      [
        -170.0,
        -1944.1578369140625,
        765.0
      ],
      [
        -155.18882751464844,
        -1941.1734619140625,
        774.8514404296875
      ],
      [
        -180.0,
        -1944.5281982421875,
        770.0
      ],
      [
        -200.0,
        -1945.020751953125,
        770.0
      ],
      [
        -200.0,
        -1945.020751953125,
        770.0
      ],
      [
        -170.0,
        -1944.2816162109375,
        770.0
      ],
      [
        -180.0,
        -1944.5281982421875,
        770.0
      ],
      [
        -170.0,
        -1944.2816162109375,
        770.0
      ],
      [
        -170.0,
        -1947.109375,
        765.0
      ],
      [
        -208.44375610351562,
        -1914.585693359375,
        835.1259765625
      ],
      [
        -150.88075256347656,
        -1940.708251953125,
        793.0426025390625
      ],
      [
        -180.0,
        -1950.8372802734375,
        770.0
      ],
      [
        -200.0,
        -1949.4605712890625,
        770.0
      ],
      [
        -200.0,
        -1949.4605712890625,
        770.0
      ],
      [
        -170.0,
        -1951.5257568359375,
        770.0
      ],
      [
        -180.0,
        -1950.83740234375,
        770.0
      ],
      [
        -170.0,
        -1951.5257568359375,
        770.0
      ],
      [
        -170.0,
        -1954.1588134765625,
        765.0
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1928.0,
        930.0
      ],
      [
        -369.0,
        -1957.1702880859375,
        773.1744384765625
      ],
      [
        -369.0,
        -1936.5960693359375,
        809.6964721679688
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -369.0,
        -1939.0,
        912.0
      ],
      [
        -369.0,
        -1939.0,
        909.7214965820312
      ],
      [
        -366.6459655761719,
        -1939.0,
        802.8728637695312
      ],
      [
        -369.0,
        -1939.0,
        805.42919921875
      ],
      [
        -147.15267944335938,
        -1939.0,
        820.2978515625
      ],
      [
        -154.64501953125,
        -1939.0,
        795.7946166992188
      ],
      [
        -180.0,
        -1972.0,
        770.0
      ],
      [
        -200.0,
        -1972.0,
        770.0
      ],
      [
        -290.0,
        -1972.0,
        770.0
      ],
      [
        -270.0,
        -1972.0,
        770.0
      ],
      [
        -270.0,
        -1972.0,
        770.0
      ],
      [
        -200.0,
        -1972.0,
        770.0
      ],
      [
        -300.0,
        -1972.0,
        770.0
      ],
      [
        -290.0,
        -1972.0,
        770.0
      ],
      [
        -170.0,
        -1972.0,
        770.0
      ],
      [
        -180.0,
        -1972.0,
        770.0
      ],
      [
        -170.0,
        -1972.0,
        770.0
      ],
      [
        -170.0,
        -1972.0,
        765.0
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        780.0
      ],
      [
        -349.0,
        -1972.0,
        778.7999267578125
      ],
      [
        -532.369384765625,
        -2030.8807373046875,
        804.678466796875
      ],
      [
        -552.2520141601562,
        -2021.5494384765625,
        852.4758911132812
      ],
      [
        -65.38192749023438,
        -2204.348876953125,
        855.09765625
      ],
      [
        -82.27342987060547,
        -2206.352783203125,
        847.1928100585938
      ],
      [
        -65.38194274902344,
        -2204.348876953125,
        855.09765625
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -115.5,
        -2297.300048828125,
        825.0
      ],
      [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      [
        -210.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2371.5,
        825.0
      ],
      [
        -210.5,
        -2360.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        825.0
      ],
      [
        -195.5,
        -2371.5,
        825.0
      ],
      [
        -195.5,
        -2360.5,
        825.0
      ],
      [
        -210.5,
        -2360.5,
        825.0
      ],
      [
        -210.5,
        -2371.5,
        825.0
      ],
      [
        -315.0,
        -2297.300048828125,
        851.5
      ],
      [
        -327.5,
        -2297.300048828125,
        851.5
      ],
      [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      [
        -228.0,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -228.0,
        -2311.300048828125,
        834.7999877929688
      ],
      [
        -228.0,
        -2311.300048828125,
        825.0
      ],
      [
        -315.0,
        -2297.300048828125,
        838.5
      ],
      [
        -315.0,
        -2297.300048828125,
        851.5
      ],
      [
        -327.5,
        -2297.300048828125,
        851.5
      ],
      [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      [
        -315.0,
        -2297.300048828125,
        838.5
      ],
      [
        -323.3096923828125,
        -2308.6923828125,
        836.4999389648438
      ],
      [
        -323.8388671875,
        -2308.3388671875,
        836.9595947265625
      ],
      [
        -324.0652770996094,
        -2308.0,
        837.4999389648438
      ],
      [
        -324.0652770996094,
        -2308.0,
        851.5
      ],
      [
        -315.0,
        -2309.461669921875,
        835.4999389648438
      ],
      [
        -319.1261291503906,
        -2309.461669921875,
        835.4999389648438
      ],
      [
        -315.0,
        -2312.0,
        834.7999877929688
      ],
      [
        -315.0,
        -2309.461669921875,
        835.4999389648438
      ],
      [
        -315.0,
        -2310.0,
        834.7999877929688
      ],
      [
        -318.8074951171875,
        -2308.6923828125,
        836.4999389648438
      ],
      [
        -323.3096923828125,
        -2308.6923828125,
        836.4999389648438
      ],
      [
        -318.8074951171875,
        -2308.6923828125,
        836.4999389648438
      ],
      [
        -319.1261291503906,
        -2309.461669921875,
        835.4999389648438
      ],
      [
        -323.8388671875,
        -2308.3388671875,
        836.9595336914062
      ],
      [
        -323.5,
        -2308.0,
        837.4999389648438
      ],
      [
        -323.5,
        -2308.0,
        837.3998413085938
      ],
      [
        -323.5,
        -2308.0,
        837.4999389648438
      ],
      [
        -324.0652770996094,
        -2308.0,
        837.4999389648438
      ],
      [
        -318.5207214355469,
        -2308.0,
        836.4999389648438
      ],
      [
        -323.5,
        -2308.0,
        836.4999389648438
      ],
      [
        -315.0,
        -2308.0,
        835.4999389648438
      ],
      [
        -318.5207214355469,
        -2308.0,
        835.4999389648438
      ],
      [
        -315.0,
        -2308.0,
        835.4999389648438
      ],
      [
        -315.0,
        -2308.0,
        834.7999877929688
      ],
      [
        -318.5207214355469,
        -2308.0,
        836.4999389648438
      ],
      [
        -318.5207214355469,
        -2308.0,
        835.4999389648438
      ],
      [
        -323.5,
        -2308.0,
        836.4999389648438
      ],
      [
        -326.70440673828125,
        -2303.5,
        851.5
      ],
      [
        -326.70440673828125,
        -2303.5,
        838.4999389648438
      ],
      [
        -324.6571350097656,
        -2303.5,
        838.4999389648438
      ],
      [
        -326.70440673828125,
        -2303.5,
        838.4999389648438
      ],
      [
        -324.6571350097656,
        -2303.5,
        837.4999389648438
      ],
      [
        -324.6571350097656,
        -2303.5,
        838.4999389648438
      ],
      [
        -319.0,
        -2303.5,
        837.5
      ],
      [
        -324.6571350097656,
        -2303.5,
        837.4999389648438
      ],
      [
        -319.0,
        -2303.5,
        837.5
      ],
      [
        -318.3075866699219,
        -2302.8076171875,
        836.5
      ],
      [
        -319.0,
        -2303.5,
        837.4002685546875
      ],
      [
        -316.3699951171875,
        -2302.8076171875,
        836.5
      ],
      [
        -318.3075866699219,
        -2302.8076171875,
        836.5
      ],
      [
        -316.3699951171875,
        -2302.8076171875,
        836.5
      ],
      [
        -316.0513610839844,
        -2302.038330078125,
        835.5
      ],
      [
        -315.0,
        -2302.038330078125,
        835.5
      ],
      [
        -316.0513610839844,
        -2302.038330078125,
        835.5
      ],
      [
        -315.0,
        -2302.038330078125,
        835.5
      ],
      [
        -315.0,
        -2299.5,
        834.7999877929688
      ],
      [
        -315.0,
        -2301.499755859375,
        834.7999877929688
      ],
      [
        -316.65679931640625,
        -2303.5,
        836.5
      ],
      [
        -319.0,
        -2303.5,
        836.5
      ],
      [
        -315.0,
        -2303.5,
        835.5
      ],
      [
        -316.65679931640625,
        -2303.5,
        835.5
      ],
      [
        -315.0,
        -2303.5,
        835.5
      ],
      [
        -315.0,
        -2303.5,
        834.7999877929688
      ],
      [
        -316.65679931640625,
        -2303.5,
        836.5
      ],
      [
        -316.65679931640625,
        -2303.5,
        835.5
      ],
      [
        -319.0,
        -2303.5,
        836.5
      ],
      [
        -198.0,
        -2371.5,
        825.0
      ],
      [
        -198.0,
        -2371.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        836.5714111328125
      ],
      [
        -198.0,
        -2360.5,
        825.0
      ],
      [
        -198.0,
        -2360.5,
        836.5714111328125
      ],
      [
        -198.0,
        -2371.5,
        838.0
      ],
      [
        -198.0,
        -2360.5,
        838.0
      ],
      [
        -95.5,
        -2297.300048828125,
        836.5
      ],
      [
        -115.5,
        -2297.300048828125,
        836.5
      ],
      [
        -115.5,
        -2297.300048828125,
        836.5
      ],
      [
        -115.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -95.5,
        -2297.300048828125,
        836.5
      ],
      [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      [
        -228.0,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -198.0,
        -2313.199951171875,
        834.7999877929688
      ],
      [
        -85.5,
        -2294.34033203125,
        825.0
      ],
      [
        -327.5,
        -2294.34033203125,
        851.5
      ],
      [
        -327.5,
        -2294.34033203125,
        838.4999389648438
      ],
      [
        -315.0,
        -2294.34033203125,
        838.5
      ],
      [
        -315.0,
        -2294.34033203125,
        851.5
      ],
      [
        -315.0,
        -2294.34033203125,
        851.5
      ],
      [
        -327.5,
        -2294.34033203125,
        851.5
      ],
      [
        -327.5,
        -2294.34033203125,
        838.4999389648438
      ],
      [
        -315.0,
        -2294.34033203125,
        838.5
      ],
      [
        -85.5,
        -2294.34033203125,
        833.5
      ],
      [
        -85.5,
        -2294.34033203125,
        825.0
      ],
      [
        -85.5,
        -2294.34033203125,
        833.5
      ],
      [
        -196.92906188964844,
        -2239.39990234375,
        861.0
      ],
      [
        -125.63127899169922,
        -2221.324462890625,
        861.0
      ],
      [
        -272.5,
        -2258.558837890625,
        861.0
      ],
      [
        -196.92904663085938,
        -2239.39990234375,
        861.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -129.6965789794922,
        -2211.978759765625,
        825.0
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -235.0,
        -2238.675537109375,
        825.0
      ],
      [
        -237.85728454589844,
        -2239.39990234375,
        825.0
      ],
      [
        -197.5,
        -2229.16845703125,
        825.0
      ],
      [
        -160.0,
        -2219.661376953125,
        825.0
      ],
      [
        -235.0,
        -2238.675537109375,
        825.0
      ],
      [
        -197.5,
        -2229.16845703125,
        825.0
      ],
      [
        -237.85728454589844,
        -2239.39990234375,
        825.0
      ],
      [
        -272.5,
        -2248.1826171875,
        825.0
      ],
      [
        -116.0,
        -2283.0,
        803.5
      ],
      [
        -116.0,
        -2260.0,
        803.5
      ],
      [
        -82.0,
        -2262.0,
        803.5
      ],
      [
        -82.0,
        -2281.0,
        803.5
      ],
      [
        -99.0,
        -2283.0,
        803.5
      ],
      [
        -84.0,
        -2283.0,
        803.5
      ],
      [
        -116.0,
        -2283.0,
        803.5
      ],
      [
        -99.0,
        -2283.0,
        803.5
      ],
      [
        -99.0,
        -2260.0,
        803.5
      ],
      [
        -84.0,
        -2260.0,
        803.5
      ],
      [
        -99.0,
        -2260.0,
        803.5
      ],
      [
        -116.0,
        -2260.0,
        803.5
      ],
      [
        -84.0,
        -2260.0,
        803.5
      ],
      [
        -82.0,
        -2262.0,
        803.5
      ],
      [
        -82.0,
        -2281.0,
        803.5
      ],
      [
        -84.0,
        -2283.0,
        803.5
      ],
      [
        -326.5,
        -2260.431640625,
        820.0
      ],
      [
        -289.5,
        -2251.051513671875,
        820.0
      ],
      [
        -272.5,
        -2248.1826171875,
        825.0
      ],
      [
        -279.5,
        -2249.092529296875,
        822.0
      ],
      [
        -289.5,
        -2251.05126953125,
        820.0
      ],
      [
        -279.5,
        -2249.092529296875,
        822.0
      ],
      [
        -326.5,
        -2260.431640625,
        820.0
      ],
      [
        -326.5,
        -2294.34033203125,
        825.0
      ],
      [
        -326.5,
        -2261.872802734375,
        825.0
      ],
      [
        -304.0,
        -2284.537109375,
        825.0
      ],
      [
        -304.0,
        -2294.340087890625,
        825.0
      ],
      [
        -293.0,
        -2284.537109375,
        825.0
      ],
      [
        -293.0,
        -2294.340087890625,
        825.0
      ],
      [
        -292.0,
        -2294.340087890625,
        825.0
      ],
      [
        -292.0,
        -2284.537109375,
        825.0
      ],
      [
        -292.0,
        -2284.537109375,
        825.0
      ],
      [
        -293.0,
        -2284.537109375,
        825.0
      ],
      [
        -303.0,
        -2294.340087890625,
        825.0
      ],
      [
        -303.0,
        -2284.537109375,
        825.0
      ],
      [
        -303.0,
        -2284.537109375,
        825.0
      ],
      [
        -304.0,
        -2284.537109375,
        825.0
      ],
      [
        -315.5,
        -2284.537109375,
        825.0
      ],
      [
        -315.5,
        -2294.340087890625,
        825.0
      ],
      [
        -314.5,
        -2294.340087890625,
        825.0
      ],
      [
        -314.5,
        -2284.537109375,
        825.0
      ],
      [
        -314.5,
        -2284.537109375,
        825.0
      ],
      [
        -315.5,
        -2284.537109375,
        825.0
      ],
      [
        -325.5,
        -2294.340087890625,
        825.0
      ],
      [
        -325.5,
        -2284.537109375,
        825.0
      ],
      [
        -325.5,
        -2284.537109375,
        825.0
      ],
      [
        -326.5,
        -2284.537109375,
        825.0
      ],
      [
        -94.0,
        -2262.0,
        822.7843017578125
      ],
      [
        -94.0,
        -2281.0,
        822.7843017578125
      ],
      [
        -119.99773406982422,
        -2219.5,
        818.7062377929688
      ],
      [
        -117.70906066894531,
        -2219.5,
        825.0
      ],
      [
        -119.62411499023438,
        -2210.213623046875,
        825.0
      ],
      [
        -121.76891326904297,
        -2209.897216796875,
        819.28125
      ],
      [
        -120.01209259033203,
        -2219.434326171875,
        818.7039794921875
      ],
      [
        -87.0,
        -2281.0,
        823.8823852539062
      ],
      [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      [
        -94.0,
        -2281.0,
        822.7843017578125
      ],
      [
        -87.0,
        -2281.0,
        823.8823852539062
      ],
      [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      [
        -94.0,
        -2262.0,
        822.7843017578125
      ],
      [
        -312.5,
        -2263.0791015625,
        841.5
      ],
      [
        -300.5,
        -2260.037109375,
        841.5
      ],
      [
        -278.0,
        -2254.332763671875,
        841.5
      ],
      [
        -295.0,
        -2258.642578125,
        841.5
      ],
      [
        -118.92424011230469,
        -2239.39990234375,
        841.5
      ],
      [
        -118.92424011230469,
        -2294.34033203125,
        841.5
      ],
      [
        -120.56061553955078,
        -2264.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2287.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2292.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2269.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2239.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      [
        -120.56061553955078,
        -2244.300048828125,
        855.0
      ],
      [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      [
        -120.9000015258789,
        -2264.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2264.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2287.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2287.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2292.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2292.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2269.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2269.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2239.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2239.300048828125,
        854.5
      ],
      [
        -120.9000015258789,
        -2244.300048828125,
        855.0
      ],
      [
        -120.50000762939453,
        -2244.300048828125,
        854.5
      ],
      [
        -125.63127899169922,
        -2221.324462890625,
        861.0
      ],
      [
        -125.6351547241211,
        -2221.302001953125,
        860.9189453125
      ],
      [
        -123.13863372802734,
        -2215.072021484375,
        841.5
      ],
      [
        -124.02631378173828,
        -2219.0439453125,
        854.5
      ],
      [
        -118.92424011230469,
        -2239.39990234375,
        841.5
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -120.5204086303711,
        -2239.300048828125,
        854.5255126953125
      ],
      [
        -119.36579895019531,
        -2239.300048828125,
        845.0
      ],
      [
        -119.3484878540039,
        -2239.39990234375,
        845.0
      ],
      [
        -124.02632141113281,
        -2219.0439453125,
        854.5
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -125.82259368896484,
        -2220.219970703125,
        857.0
      ],
      [
        -120.91727447509766,
        -2239.300048828125,
        855.0
      ],
      [
        -120.517333984375,
        -2239.300048828125,
        854.5001220703125
      ],
      [
        -209.0,
        -2241.595703125,
        858.0
      ],
      [
        -209.0,
        -2240.5,
        854.1991577148438
      ],
      [
        -209.22642517089844,
        -2240.5,
        854.0
      ],
      [
        -222.0,
        -2243.73828125,
        854.0
      ],
      [
        -259.0,
        -2253.11865234375,
        854.0
      ],
      [
        -246.0,
        -2249.82275390625,
        854.0
      ],
      [
        -222.0,
        -2243.73828125,
        854.0
      ],
      [
        -222.0,
        -2244.89111328125,
        858.0
      ],
      [
        -209.0,
        -2240.5,
        854.1991577148438
      ],
      [
        -209.22642517089844,
        -2240.5,
        854.0
      ],
      [
        -246.0,
        -2250.975830078125,
        858.0
      ],
      [
        -246.0,
        -2249.82275390625,
        854.0
      ],
      [
        -259.0,
        -2253.11865234375,
        854.0
      ],
      [
        -259.0,
        -2254.271484375,
        858.0
      ],
      [
        -274.5,
        -2257.1923828125,
        854.5
      ],
      [
        -272.5,
        -2257.406005859375,
        857.0
      ],
      [
        -272.5,
        -2258.558837890625,
        861.0
      ],
      [
        -272.5,
        -2257.406005859375,
        857.0
      ],
      [
        -274.56060791015625,
        -2293.858154296875,
        854.0
      ],
      [
        -274.56060791015625,
        -2293.956298828125,
        854.0
      ],
      [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      [
        -274.56060791015625,
        -2293.956298828125,
        854.0
      ],
      [
        -274.56060791015625,
        -2293.858154296875,
        854.0
      ],
      [
        -274.5,
        -2257.1923828125,
        854.5
      ],
      [
        -274.56060791015625,
        -2257.063720703125,
        854.0
      ],
      [
        -277.5625,
        -2255.23046875,
        845.0
      ],
      [
        -278.0,
        -2254.332763671875,
        841.5
      ],
      [
        -276.9375,
        -2256.51318359375,
        850.0
      ],
      [
        -276.5,
        -2257.4111328125,
        853.5
      ],
      [
        -276.0757141113281,
        -2292.548095703125,
        841.5
      ],
      [
        -276.0758056640625,
        -2292.170166015625,
        841.5
      ],
      [
        -276.07574462890625,
        -2294.34033203125,
        841.5
      ],
      [
        -276.0757141113281,
        -2292.548095703125,
        841.5
      ],
      [
        -275.04541015625,
        -2256.033447265625,
        850.0
      ],
      [
        -276.0758056640625,
        -2292.170166015625,
        841.5
      ],
      [
        -275.651611328125,
        -2254.74609375,
        845.0
      ],
      [
        -276.0758056640625,
        -2253.8447265625,
        841.5
      ],
      [
        -275.651611328125,
        -2254.74609375,
        845.0
      ],
      [
        -277.5625,
        -2255.23046875,
        845.0
      ],
      [
        -276.9375,
        -2256.51318359375,
        850.0
      ],
      [
        -275.04541015625,
        -2256.03369140625,
        850.0
      ],
      [
        -301.5,
        -2263.749267578125,
        853.5
      ],
      [
        -311.5,
        -2266.284423828125,
        853.5
      ],
      [
        -276.5,
        -2257.4111328125,
        853.5
      ],
      [
        -295.0,
        -2262.101318359375,
        853.5
      ],
      [
        -295.0,
        -2262.101318359375,
        853.5
      ],
      [
        -295.0,
        -2258.642578125,
        841.5
      ],
      [
        -315.0,
        -2263.713134765625,
        841.5
      ],
      [
        -315.0,
        -2266.59521484375,
        851.5
      ],
      [
        -315.0,
        -2294.34033203125,
        841.5
      ],
      [
        -300.5,
        -2260.037109375,
        841.5
      ],
      [
        -300.5,
        -2262.919189453125,
        851.5
      ],
      [
        -312.5,
        -2265.96142578125,
        851.5
      ],
      [
        -312.5,
        -2263.0791015625,
        841.5
      ],
      [
        -301.5,
        -2263.749267578125,
        853.5
      ],
      [
        -300.5,
        -2262.919189453125,
        851.5
      ],
      [
        -311.5,
        -2266.284423828125,
        853.5
      ],
      [
        -312.5,
        -2265.96142578125,
        851.5
      ],
      [
        -315.0,
        -2266.59521484375,
        851.5
      ],
      [
        -327.5,
        -2269.764404296875,
        851.5
      ],
      [
        -327.5,
        -2269.764404296875,
        851.5
      ],
      [
        -327.5,
        -2266.882080078125,
        841.5
      ],
      [
        -327.5,
        -2294.34033203125,
        841.5
      ],
      [
        -294.0,
        -2261.41552734375,
        852.0
      ],
      [
        -294.0,
        -2261.39990234375,
        851.946044921875
      ],
      [
        -295.0,
        -2261.6689453125,
        852.0
      ],
      [
        -294.0,
        -2261.41552734375,
        852.0
      ],
      [
        -295.0,
        -2261.39990234375,
        851.0663452148438
      ],
      [
        -294.0,
        -2261.39990234375,
        851.946044921875
      ],
      [
        -276.5,
        -2252.511474609375,
        836.5
      ],
      [
        -279.5,
        -2253.271728515625,
        836.5
      ],
      [
        -289.5,
        -2255.80712890625,
        836.5
      ],
      [
        -279.5,
        -2253.271728515625,
        836.5
      ],
      [
        -326.5,
        -2265.1875,
        836.5
      ],
      [
        -289.5,
        -2255.80712890625,
        836.5
      ],
      [
        -276.5,
        -2252.511474609375,
        836.5
      ],
      [
        -276.5,
        -2252.943603515625,
        838.0
      ],
      [
        -327.5,
        -2266.017333984375,
        838.4999389648438
      ],
      [
        -315.0,
        -2262.848388671875,
        838.5
      ],
      [
        -315.0,
        -2262.848388671875,
        838.5
      ],
      [
        -327.5,
        -2266.017333984375,
        838.4999389648438
      ],
      [
        -276.5,
        -2252.943603515625,
        838.0
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -122.89964294433594,
        -2214.002685546875,
        838.0
      ],
      [
        -326.5,
        -2265.1875,
        836.5
      ],
      [
        -127.32233428955078,
        -2211.562744140625,
        825.0
      ],
      [
        -126.84452056884766,
        -2211.640625,
        826.3348999023438
      ],
      [
        -122.97138977050781,
        -2213.58837890625,
        836.5
      ],
      [
        -115.5,
        -2219.5,
        831.0748291015625
      ],
      [
        -115.5,
        -2211.447021484375,
        835.6416625976562
      ],
      [
        -117.47943115234375,
        -2210.52978515625,
        830.7184448242188
      ],
      [
        -118.0,
        -2252.099853515625,
        831.6123657226562
      ],
      [
        -118.0,
        -2250.71923828125,
        832.2999877929688
      ],
      [
        -118.0,
        -2250.718994140625,
        832.2999877929688
      ],
      [
        -118.0,
        -2242.2861328125,
        836.5
      ],
      [
        -116.5,
        -2253.8935546875,
        835.0315551757812
      ],
      [
        -116.5,
        -2250.945068359375,
        836.5
      ],
      [
        -118.0,
        -2252.099853515625,
        831.6123657226562
      ],
      [
        -117.45008087158203,
        -2253.8935546875,
        832.2999877929688
      ],
      [
        -116.5,
        -2253.8935546875,
        835.0315551757812
      ],
      [
        -117.45008087158203,
        -2253.8935546875,
        832.2999877929688
      ],
      [
        -114.01850128173828,
        -2216.406982421875,
        836.9028930664062
      ],
      [
        -114.96051025390625,
        -2211.697021484375,
        836.9834594726562
      ],
      [
        -115.3874282836914,
        -2211.499267578125,
        835.921630859375
      ],
      [
        -75.20278930664062,
        -2188.82080078125,
        754.8995361328125
      ],
      [
        -82.27342987060547,
        -2206.352783203125,
        847.1928100585938
      ],
      [
        -85.23536682128906,
        -2204.010009765625,
        836.4596557617188
      ],
      [
        -122.04180908203125,
        -2208.415771484375,
        819.3709106445312
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        -127.35315704345703,
        -2211.384765625,
        825.0
      ],
      [
        109.38627624511719,
        -2157.629150390625,
        724.793212890625
      ],
      [
        119.41747283935547,
        -2124.32177734375,
        739.994140625
      ],
      [
        127.53099060058594,
        -2115.85498046875,
        717.754638671875
      ],
      [
        119.41747283935547,
        -2124.32177734375,
        739.994140625
      ],
      [
        114.55088806152344,
        -2156.28759765625,
        723.9014282226562
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8880615234375
      ],
      [
        -106.53463745117188,
        -2187.16357421875,
        759.2772216796875
      ],
      [
        -93.01200103759766,
        -2197.859130859375,
        808.2791137695312
      ],
      [
        -87.60077667236328,
        -2202.13916015625,
        827.8880615234375
      ],
      [
        135.5572967529297,
        -2073.446044921875,
        712.1194458007812
      ],
      [
        -212.8021240234375,
        -2239.39990234375,
        861.0
      ],
      [
        -126.46916961669922,
        -2216.487548828125,
        861.0
      ],
      [
        -272.5,
        -2255.24365234375,
        861.0
      ],
      [
        -212.80210876464844,
        -2239.39990234375,
        861.0
      ],
      [
        -86.32891845703125,
        -2208.73486328125,
        861.0
      ],
      [
        -73.71690368652344,
        -2206.524169921875,
        861.0
      ],
      [
        -88.2540054321289,
        -2208.580322265625,
        861.0
      ],
      [
        -86.32891845703125,
        -2208.73486328125,
        861.0
      ],
      [
        -276.5,
        -2247.687255859375,
        836.5
      ],
      [
        -279.5,
        -2248.483154296875,
        836.5
      ],
      [
        -289.5,
        -2251.13720703125,
        836.5
      ],
      [
        -279.5,
        -2248.483154296875,
        836.5
      ],
      [
        -326.5,
        -2260.956787109375,
        836.5
      ],
      [
        -289.5,
        -2251.13720703125,
        836.5
      ],
      [
        -85.24032592773438,
        -2204.017578125,
        836.5
      ],
      [
        -85.22423553466797,
        -2204.018798828125,
        836.5
      ],
      [
        -301.5,
        -2260.302001953125,
        853.5
      ],
      [
        -311.5,
        -2262.955810546875,
        853.5
      ],
      [
        -276.5,
        -2253.6669921875,
        853.5
      ],
      [
        -295.0,
        -2258.576904296875,
        853.5
      ],
      [
        -220.92286682128906,
        -2240.5,
        858.0
      ],
      [
        -222.0,
        -2240.5,
        857.1873168945312
      ],
      [
        -259.0,
        -2249.198486328125,
        854.0
      ],
      [
        -246.0,
        -2245.74853515625,
        854.0
      ],
      [
        -246.0,
        -2247.1552734375,
        858.0
      ],
      [
        -246.0,
        -2245.74853515625,
        854.0
      ],
      [
        -259.0,
        -2249.198486328125,
        854.0
      ],
      [
        -259.0,
        -2250.60546875,
        858.0
      ],
      [
        -272.5,
        -2255.24365234375,
        861.0
      ],
      [
        -272.5,
        -2253.83642578125,
        857.0
      ],
      [
        -274.5,
        -2253.488037109375,
        854.5
      ],
      [
        -272.5,
        -2253.83642578125,
        857.0
      ],
      [
        -274.56060791015625,
        -2257.0634765625,
        854.0
      ],
      [
        -274.5,
        -2253.488037109375,
        854.5
      ],
      [
        -274.56060791015625,
        -2253.328125,
        854.0
      ],
      [
        -222.0,
        -2240.5,
        857.1873168945312
      ],
      [
        -222.0,
        -2240.785888671875,
        858.0
      ],
      [
        -274.6212158203125,
        -2256.934814453125,
        853.5
      ],
      [
        -274.6212158203125,
        -2253.16845703125,
        853.5
      ],
      [
        -126.46916961669922,
        -2216.487548828125,
        861.0
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -124.93572998046875,
        -2213.794189453125,
        854.5
      ],
      [
        -126.70217895507812,
        -2215.142578125,
        857.0
      ],
      [
        -124.87810516357422,
        -2213.42724609375,
        853.5
      ],
      [
        -124.93572998046875,
        -2213.794189453125,
        854.5
      ],
      [
        -123.9580307006836,
        -2218.738525390625,
        853.5
      ],
      [
        -123.64452362060547,
        -2209.702880859375,
        838.0
      ],
      [
        -124.59520721435547,
        -2211.625244140625,
        848.5909423828125
      ],
      [
        -115.61885070800781,
        -2208.4052734375,
        837.039794921875
      ],
      [
        -115.82784271240234,
        -2208.34375,
        836.5
      ],
      [
        -115.15489196777344,
        -2211.60693359375,
        836.5
      ],
      [
        -315.0,
        -2258.6083984375,
        838.5
      ],
      [
        -315.0,
        -2263.18115234375,
        851.5
      ],
      [
        -297.089599609375,
        -2254.910400390625,
        841.5
      ],
      [
        -295.0,
        -2254.35595703125,
        841.5
      ],
      [
        -312.5,
        -2259.0,
        841.5
      ],
      [
        -300.5,
        -2255.8154296875,
        841.5
      ],
      [
        -278.0,
        -2249.843994140625,
        841.5
      ],
      [
        -295.0,
        -2254.355712890625,
        841.5
      ],
      [
        -276.5,
        -2248.214599609375,
        838.0
      ],
      [
        -276.0758056640625,
        -2253.8447265625,
        841.5
      ],
      [
        -276.0758056640625,
        -2249.333251953125,
        841.5
      ],
      [
        -276.5,
        -2247.68701171875,
        836.5
      ],
      [
        -276.5,
        -2248.214599609375,
        838.0
      ],
      [
        -123.6874008178711,
        -2209.455322265625,
        836.5
      ],
      [
        -123.64452362060547,
        -2209.702880859375,
        838.0
      ],
      [
        -295.0,
        -2258.576904296875,
        853.5
      ],
      [
        -295.0,
        -2257.0,
        849.01708984375
      ],
      [
        -300.5,
        -2255.8154296875,
        841.5
      ],
      [
        -300.5,
        -2259.332763671875,
        851.5
      ],
      [
        -295.0,
        -2257.0,
        849.01708984375
      ],
      [
        -297.089599609375,
        -2254.910400390625,
        841.5
      ],
      [
        -312.5,
        -2262.517578125,
        851.5
      ],
      [
        -312.5,
        -2259.0,
        841.5
      ],
      [
        -301.5,
        -2260.302001953125,
        853.5
      ],
      [
        -300.5,
        -2259.332763671875,
        851.5
      ],
      [
        -311.5,
        -2262.955810546875,
        853.5
      ],
      [
        -312.5,
        -2262.517578125,
        851.5
      ],
      [
        -277.5625,
        -2250.958984375,
        845.0
      ],
      [
        -278.0,
        -2249.843994140625,
        841.5
      ],
      [
        -276.9375,
        -2252.552001953125,
        850.0
      ],
      [
        -276.5,
        -2253.6669921875,
        853.5
      ],
      [
        -275.04541015625,
        -2252.0498046875,
        850.0
      ],
      [
        -275.651611328125,
        -2250.451904296875,
        845.0
      ],
      [
        -275.651611328125,
        -2250.451904296875,
        845.0
      ],
      [
        -277.5625,
        -2250.958984375,
        845.0
      ],
      [
        -276.9375,
        -2252.552001953125,
        850.0
      ],
      [
        -275.04541015625,
        -2252.0498046875,
        850.0
      ],
      [
        -327.5,
        -2266.49853515625,
        851.5
      ],
      [
        -327.5,
        -2261.92578125,
        838.4999389648438
      ],
      [
        -327.5,
        -2261.92578125,
        838.4999389648438
      ],
      [
        -315.0,
        -2258.6083984375,
        838.5
      ],
      [
        -315.0,
        -2263.18115234375,
        851.5
      ],
      [
        -327.5,
        -2266.49853515625,
        851.5
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -159.40509033203125,
        -2212.5654296875,
        825.0
      ],
      [
        -127.92000579833984,
        -2208.112548828125,
        825.0
      ],
      [
        -235.0,
        -2232.6279296875,
        825.0
      ],
      [
        -260.5163269042969,
        -2239.39990234375,
        825.0
      ],
      [
        -197.5,
        -2222.67578125,
        825.0
      ],
      [
        -160.0,
        -2212.723388671875,
        825.0
      ],
      [
        -235.0,
        -2232.6279296875,
        825.0
      ],
      [
        -197.5,
        -2222.67578125,
        825.0
      ],
      [
        -260.5163269042969,
        -2239.39990234375,
        825.0
      ],
      [
        -272.5,
        -2242.580322265625,
        825.0
      ],
      [
        -289.5,
        -2245.333251953125,
        820.0
      ],
      [
        -310.4751892089844,
        -2250.89990234375,
        820.0
      ],
      [
        -326.5,
        -2255.15283203125,
        820.0
      ],
      [
        -310.4751892089844,
        -2250.89990234375,
        820.0
      ],
      [
        -122.21601867675781,
        -2206.461669921875,
        820.0
      ],
      [
        -122.41243743896484,
        -2206.40380859375,
        819.49267578125
      ],
      [
        -121.78887939453125,
        -2208.532958984375,
        820.0
      ],
      [
        -289.5,
        -2245.333251953125,
        820.0
      ],
      [
        -279.5,
        -2243.3828125,
        822.0
      ],
      [
        -120.28021240234375,
        -2207.031982421875,
        825.0
      ],
      [
        -119.77857971191406,
        -2209.46435546875,
        825.0
      ],
      [
        -272.5,
        -2242.580322265625,
        825.0
      ],
      [
        -279.5,
        -2243.3828125,
        822.0
      ],
      [
        -326.5,
        -2255.15283203125,
        820.0
      ],
      [
        -326.5,
        -2261.872802734375,
        825.0
      ],
      [
        -326.5,
        -2256.91162109375,
        825.0
      ],
      [
        -292.0,
        -2247.157470703125,
        823.2999877929688
      ],
      [
        -292.0,
        -2245.996826171875,
        820.0
      ],
      [
        -292.0,
        -2249.202880859375,
        825.0
      ],
      [
        -292.0,
        -2247.755615234375,
        825.0
      ],
      [
        -292.0,
        -2247.157470703125,
        823.2999877929688
      ],
      [
        -293.0,
        -2246.26220703125,
        820.0
      ],
      [
        -293.0,
        -2247.39990234375,
        823.234375
      ],
      [
        -293.0,
        -2249.202880859375,
        825.0
      ],
      [
        -293.0,
        -2247.434326171875,
        823.33251953125
      ],
      [
        -293.0,
        -2248.02099609375,
        825.0
      ],
      [
        -293.0,
        -2247.39990234375,
        823.234375
      ],
      [
        -292.9130554199219,
        -2247.39990234375,
        823.2999877929688
      ],
      [
        -293.0,
        -2247.434326171875,
        823.33251953125
      ],
      [
        -293.0,
        -2249.202880859375,
        825.0
      ],
      [
        -292.0,
        -2249.202880859375,
        825.0
      ],
      [
        -292.9130554199219,
        -2247.39990234375,
        823.2999877929688
      ],
      [
        -127.92000579833984,
        -2208.112548828125,
        825.0
      ],
      [
        -123.6874008178711,
        -2209.455322265625,
        836.5
      ],
      [
        -85.23536682128906,
        -2204.010009765625,
        836.4596557617188
      ],
      [
        -326.5,
        -2260.956787109375,
        836.5
      ],
      [
        -292.0,
        -2248.318359375,
        826.5999755859375
      ],
      [
        -292.0,
        -2250.89990234375,
        833.9390869140625
      ],
      [
        -292.0,
        -2248.318359375,
        826.5999755859375
      ],
      [
        -293.0,
        -2250.89990234375,
        833.1844482421875
      ],
      [
        -292.0,
        -2250.89990234375,
        833.9390869140625
      ],
      [
        -293.0,
        -2248.583740234375,
        826.5999755859375
      ],
      [
        -293.0,
        -2248.583740234375,
        826.5999755859375
      ],
      [
        -293.0,
        -2250.89990234375,
        833.1844482421875
      ],
      [
        -137.5782012939453,
        -2185.7607421875,
        765.2647705078125
      ],
      [
        -138.27777099609375,
        -2185.397216796875,
        763.703125
      ],
      [
        -137.5782012939453,
        -2185.7607421875,
        765.2647705078125
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -121.22845458984375,
        -2202.43359375,
        825.0
      ],
      [
        -123.37515258789062,
        -2201.177490234375,
        819.8090209960938
      ],
      [
        -120.28020477294922,
        -2207.031982421875,
        825.0
      ],
      [
        -116.2279281616211,
        -2205.35986328125,
        837.0918579101562
      ],
      [
        -128.56640625,
        -2204.381103515625,
        825.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.9848861694336,
        -2207.738037109375,
        838.0
      ],
      [
        -124.07225799560547,
        -2207.233642578125,
        836.5
      ],
      [
        -123.9848861694336,
        -2207.738037109375,
        838.0
      ],
      [
        -122.31401824951172,
        -2186.925537109375,
        857.0
      ],
      [
        -123.38775634765625,
        -2181.5,
        857.0
      ],
      [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      [
        -270.61224365234375,
        -2181.5,
        857.0
      ],
      [
        -124.42652130126953,
        -2186.925537109375,
        825.0
      ],
      [
        -125.54545593261719,
        -2181.5,
        825.0
      ],
      [
        -124.42652130126953,
        -2186.925537109375,
        825.0
      ],
      [
        -125.90447235107422,
        -2187.44677734375,
        820.6400756835938
      ],
      [
        -124.31903076171875,
        -2187.44677734375,
        825.0
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -269.2121276855469,
        -2181.5,
        825.0
      ],
      [
        -269.1110534667969,
        -2187.44677734375,
        820.6400756835938
      ],
      [
        -270.3253479003906,
        -2186.925537109375,
        825.0
      ],
      [
        -270.4322814941406,
        -2187.44677734375,
        825.0
      ],
      [
        -119.810546875,
        -2187.44677734375,
        837.3982543945312
      ],
      [
        -274.189453125,
        -2187.44677734375,
        837.3982543945312
      ],
      [
        -119.04776000976562,
        -2205.904052734375,
        861.0
      ],
      [
        -98.42771911621094,
        -2207.724609375,
        861.0
      ],
      [
        -98.42771911621094,
        -2207.724609375,
        861.0
      ],
      [
        -97.06643676757812,
        -2207.844970703125,
        861.0
      ],
      [
        -94.69258880615234,
        -2208.054443359375,
        861.0
      ],
      [
        -97.06643676757812,
        -2207.844970703125,
        861.0
      ],
      [
        -277.4501953125,
        -2218.526123046875,
        861.0
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -310.8897399902344,
        -2233.276611328125,
        861.0
      ],
      [
        -306.7088928222656,
        -2230.50927734375,
        861.0
      ],
      [
        -301.7933654785156,
        -2227.83984375,
        861.0
      ],
      [
        -291.0722351074219,
        -2224.105224609375,
        861.0
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -305.518310546875,
        -2229.72119140625,
        861.0
      ],
      [
        -301.7933654785156,
        -2227.83984375,
        861.0
      ],
      [
        -354.65496826171875,
        -2233.1513671875,
        817.8739624023438
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -267.6134948730469,
        -2188.101806640625,
        836.5
      ],
      [
        -267.2770690917969,
        -2187.44677734375,
        835.8590698242188
      ],
      [
        -330.51251220703125,
        -2217.7978515625,
        818.80322265625
      ],
      [
        -314.28076171875,
        -2209.87841796875,
        819.2825317382812
      ],
      [
        -314.28076171875,
        -2209.87841796875,
        819.2825317382812
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -278.0047912597656,
        -2248.08642578125,
        836.5
      ],
      [
        -278.6029052734375,
        -2241.5,
        841.5
      ],
      [
        -282.7768249511719,
        -2241.5,
        853.5
      ],
      [
        -277.80194091796875,
        -2206.37939453125,
        836.5
      ],
      [
        -278.0542907714844,
        -2206.77099609375,
        837.0676879882812
      ],
      [
        -280.4940490722656,
        -2219.5,
        836.5
      ],
      [
        -282.7768249511719,
        -2241.5,
        853.5
      ],
      [
        -285.28863525390625,
        -2255.99951171875,
        853.5
      ],
      [
        -295.0,
        -2257.0,
        851.5
      ],
      [
        -295.0,
        -2257.0,
        851.5
      ],
      [
        -295.0,
        -2257.873291015625,
        851.5
      ],
      [
        -280.1470947265625,
        -2250.413818359375,
        841.5
      ],
      [
        -278.6029052734375,
        -2241.5,
        841.5
      ],
      [
        -323.8388671875,
        -2245.1611328125,
        841.5
      ],
      [
        -319.783447265625,
        -2242.451416015625,
        841.5
      ],
      [
        -326.548583984375,
        -2249.216552734375,
        841.5
      ],
      [
        -323.8388671875,
        -2245.1611328125,
        841.5
      ],
      [
        -315.0,
        -2254.0,
        841.5
      ],
      [
        -315.0,
        -2259.66357421875,
        841.5
      ],
      [
        -327.5,
        -2254.0,
        841.5
      ],
      [
        -326.548583984375,
        -2249.216552734375,
        841.5
      ],
      [
        -270.5449523925781,
        -2195.120849609375,
        820.1755981445312
      ],
      [
        -272.9879150390625,
        -2242.63623046875,
        824.7908935546875
      ],
      [
        -277.6680908203125,
        -2214.285400390625,
        852.3663940429688
      ],
      [
        -281.7077941894531,
        -2220.269775390625,
        861.0
      ],
      [
        -286.6089782714844,
        -2200.54150390625,
        819.84765625
      ],
      [
        -270.5155944824219,
        -2194.963623046875,
        820.1851196289062
      ],
      [
        -269.19183349609375,
        -2187.879150390625,
        820.6138916015625
      ],
      [
        -276.988525390625,
        -2201.442138671875,
        837.1588134765625
      ],
      [
        -272.2456970214844,
        -2187.44677734375,
        830.9840087890625
      ],
      [
        -275.4665832519531,
        -2193.832275390625,
        837.2890014648438
      ],
      [
        -124.31903076171875,
        -2187.44677734375,
        825.0
      ],
      [
        -121.22845458984375,
        -2202.43359375,
        825.0
      ],
      [
        -122.00170135498047,
        -2198.683837890625,
        825.0
      ],
      [
        -120.77140808105469,
        -2198.79248046875,
        825.0
      ],
      [
        -113.07188415527344,
        -2198.500244140625,
        819.97119140625
      ],
      [
        -110.81917572021484,
        -2199.67138671875,
        825.0
      ],
      [
        -120.77140808105469,
        -2198.79248046875,
        825.0
      ],
      [
        -267.8114929199219,
        -2189.244873046875,
        838.0
      ],
      [
        -267.6134948730469,
        -2188.101806640625,
        836.5
      ],
      [
        -276.86383056640625,
        -2241.5,
        853.5
      ],
      [
        -279.09063720703125,
        -2254.3544921875,
        853.5
      ],
      [
        -277.6394958496094,
        -2214.84228515625,
        853.5
      ],
      [
        -278.1985168457031,
        -2215.071044921875,
        853.5
      ],
      [
        -276.86383056640625,
        -2241.5,
        850.58935546875
      ],
      [
        -276.86383056640625,
        -2241.5,
        853.5
      ],
      [
        -278.0,
        -2248.058837890625,
        841.5
      ],
      [
        -278.32415771484375,
        -2249.929931640625,
        841.5
      ],
      [
        -276.86383056640625,
        -2241.5,
        850.58935546875
      ],
      [
        -277.21026611328125,
        -2243.5,
        847.81787109375
      ],
      [
        -277.5625,
        -2245.533203125,
        845.0
      ],
      [
        -278.0,
        -2248.058837890625,
        841.5
      ],
      [
        -277.21026611328125,
        -2243.5,
        845.5
      ],
      [
        -277.21026611328125,
        -2243.5,
        847.81787109375
      ],
      [
        -277.5625,
        -2245.533203125,
        845.0
      ],
      [
        -277.296875,
        -2244.0,
        845.0
      ],
      [
        -277.296875,
        -2244.0,
        845.0
      ],
      [
        -277.21026611328125,
        -2243.5,
        845.5
      ],
      [
        -267.7305603027344,
        -2200.322998046875,
        854.5
      ],
      [
        -267.8114929199219,
        -2189.244873046875,
        838.0
      ],
      [
        -276.5,
        -2250.245361328125,
        853.5
      ],
      [
        -277.12127685546875,
        -2253.831787109375,
        853.5
      ],
      [
        -276.9375,
        -2250.322021484375,
        850.0
      ],
      [
        -276.5,
        -2250.245361328125,
        853.5
      ],
      [
        -277.5625,
        -2250.43115234375,
        845.0
      ],
      [
        -277.7562561035156,
        -2250.465087890625,
        843.4498901367188
      ],
      [
        -275.8423156738281,
        -2244.0,
        850.0
      ],
      [
        -276.9375,
        -2250.322021484375,
        850.0
      ],
      [
        -277.5625,
        -2250.43115234375,
        845.0
      ],
      [
        -276.4483947753906,
        -2244.0,
        845.0
      ],
      [
        -276.3011779785156,
        -2243.5,
        845.5
      ],
      [
        -275.81634521484375,
        -2243.5,
        849.5
      ],
      [
        -275.81634521484375,
        -2243.5,
        849.5
      ],
      [
        -275.8423156738281,
        -2244.0,
        850.0
      ],
      [
        -276.4483947753906,
        -2244.0,
        845.0
      ],
      [
        -276.3011779785156,
        -2243.5,
        845.5
      ],
      [
        -265.8015441894531,
        -2200.732666015625,
        857.0
      ],
      [
        -267.7305603027344,
        -2200.322998046875,
        854.5
      ],
      [
        -266.32958984375,
        -2203.78076171875,
        861.0
      ],
      [
        -265.8015441894531,
        -2200.732666015625,
        857.0
      ],
      [
        -272.5,
        -2255.02685546875,
        860.3839111328125
      ],
      [
        -125.16639709472656,
        -2200.917724609375,
        838.0
      ],
      [
        -126.63629913330078,
        -2203.9775390625,
        854.5
      ],
      [
        -117.00479888916016,
        -2201.4755859375,
        837.1583251953125
      ],
      [
        -122.00172424316406,
        -2198.683837890625,
        825.0
      ],
      [
        -276.72222900390625,
        -2250.2841796875,
        851.72216796875
      ],
      [
        -276.72222900390625,
        -2253.1005859375,
        851.72216796875
      ],
      [
        -276.6817932128906,
        -2240.449462890625,
        836.5
      ],
      [
        -276.681640625,
        -2247.7353515625,
        836.5
      ],
      [
        -128.44635009765625,
        -2205.07421875,
        861.0
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -126.63629913330078,
        -2203.9775390625,
        854.5
      ],
      [
        -128.5823974609375,
        -2204.288818359375,
        857.0
      ],
      [
        -129.67066955566406,
        -2198.006591796875,
        825.0
      ],
      [
        -125.21744537353516,
        -2200.623046875,
        836.5
      ],
      [
        -125.21744537353516,
        -2200.623046875,
        836.5
      ],
      [
        -125.16639709472656,
        -2200.917724609375,
        838.0
      ],
      [
        -582.3368530273438,
        -2047.9849853515625,
        829.080810546875
      ],
      [
        -543.0773315429688,
        -2025.8553466796875,
        830.4201049804688
      ],
      [
        -354.3086242675781,
        -2220.0126953125,
        798.7386474609375
      ],
      [
        -347.122314453125,
        -2228.36083984375,
        818.1638793945312
      ],
      [
        -253.25575256347656,
        -2185.724365234375,
        817.9110107421875
      ],
      [
        -279.11785888671875,
        -2176.740966796875,
        783.25390625
      ],
      [
        -251.1885986328125,
        -2186.446044921875,
        820.7006225585938
      ],
      [
        -253.25575256347656,
        -2185.724365234375,
        817.9110107421875
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -4840.0,
        -300.0
      ],
      "bbox_max": [
        2500.0,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -2341.75634765625,
        -300.0
      ],
      "bbox_max": [
        -567.1976928710938,
        2200.0,
        1179.126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4100.0,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        2200.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -704.1276245117188,
        -2341.75634765625,
        0.0
      ],
      "bbox_max": [
        -567.1976928710938,
        -1920.0,
        74.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -704.1276245117188,
        -2341.75634765625,
        0.0
      ],
      "bbox_max": [
        -694.7417602539062,
        -2329.093994140625,
        74.91236877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -699.1730346679688,
        -2341.75634765625,
        0.0
      ],
      "bbox_max": [
        -694.7417602539062,
        -2332.319091796875,
        73.73088836669922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14300712943077087,
        0.10372389853000641,
        0.9842714667320251
      ],
      "plane_d": -505.2385559082031,
      "bbox_min": [
        -4912.15185546875,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        2154.178466796875,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600968956947327,
        0.260924369096756,
        0.10065929591655731
      ],
      "plane_d": 4053.40478515625,
      "bbox_min": [
        -4912.15185546875,
        -4840.0,
        0.0
      ],
      "bbox_max": [
        2500.0,
        2154.178466796875,
        1300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6843019127845764,
        0.7287558913230896,
        0.02541181445121765
      ],
      "plane_d": 2177.273193359375,
      "bbox_min": [
        -1103.7593994140625,
        -3518.638427734375,
        73.21707153320312
      ],
      "bbox_max": [
        199.43505859375,
        -1918.043212890625,
        879.9163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8764687180519104,
        0.48085832595825195,
        0.02404039539396763
      ],
      "plane_d": 1733.21240234375,
      "bbox_min": [
        -1103.7593994140625,
        -3518.638427734375,
        73.21707153320312
      ],
      "bbox_max": [
        199.43505859375,
        -2022.358642578125,
        879.9163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.034249160438776016,
        0.9861814379692078,
        0.16208960115909576
      ],
      "plane_d": 2026.164306640625,
      "bbox_min": [
        -1103.7593994140625,
        -2803.202880859375,
        219.68569946289062
      ],
      "bbox_max": [
        -482.3701171875,
        -2022.358642578125,
        879.9163818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -994.6153564453125,
        -2803.202880859375,
        406.15667724609375
      ],
      "bbox_max": [
        -482.3701171875,
        -2086.76953125,
        879.7427978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -994.6153564453125,
        -2435.9833984375,
        406.15667724609375
      ],
      "bbox_max": [
        -673.747314453125,
        -2086.76953125,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -994.6153564453125,
        -2435.9833984375,
        406.15667724609375
      ],
      "bbox_max": [
        -703.939208984375,
        -2086.76953125,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -789.134033203125,
        -2435.9833984375,
        639.4212036132812
      ],
      "bbox_max": [
        -719.7452392578125,
        -2323.13134765625,
        640.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -837.259033203125,
        -2405.9833984375,
        639.4187622070312
      ],
      "bbox_max": [
        -759.2192993164062,
        -2314.45263671875,
        684.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -837.259033203125,
        -2405.9833984375,
        639.4187622070312
      ],
      "bbox_max": [
        -759.2192993164062,
        -2314.45263671875,
        684.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -837.259033203125,
        -2405.9833984375,
        639.4187622070312
      ],
      "bbox_max": [
        -759.2192993164062,
        -2314.45263671875,
        684.730224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -830.384033203125,
        -2405.9833984375,
        639.4187622070312
      ],
      "bbox_max": [
        -761.552978515625,
        -2315.434326171875,
        648.81787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -969.41943359375,
        -2371.302734375,
        467.37017822265625
      ],
      "bbox_max": [
        -703.939208984375,
        -2121.847900390625,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -768.4713134765625,
        -2356.772216796875,
        639.3530883789062
      ],
      "bbox_max": [
        -714.5018920898438,
        -2310.43701171875,
        685.8677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -761.5559692382812,
        -2318.2919921875,
        639.3778686523438
      ],
      "bbox_max": [
        -758.402099609375,
        -2314.2763671875,
        639.426025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -768.4713134765625,
        -2323.744140625,
        639.3829345703125
      ],
      "bbox_max": [
        -754.98779296875,
        -2310.43701171875,
        685.8677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -768.4713134765625,
        -2323.744140625,
        639.3829345703125
      ],
      "bbox_max": [
        -754.98779296875,
        -2310.43701171875,
        685.8677978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -766.3021850585938,
        -2318.289794921875,
        639.3829345703125
      ],
      "bbox_max": [
        -758.4042358398438,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -766.3021850585938,
        -2315.434326171875,
        648.81787109375
      ],
      "bbox_max": [
        -762.5052490234375,
        -2310.982421875,
        651.81005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.37017822265625
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -969.41943359375,
        -2363.59228515625,
        467.37017822265625
      ],
      "bbox_max": [
        -713.2835083007812,
        -2121.847900390625,
        866.0255126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -969.41943359375,
        -2333.9970703125,
        467.37017822265625
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        741.553955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -964.5498046875,
        -2333.9970703125,
        467.37017822265625
      ],
      "bbox_max": [
        -734.5917358398438,
        -2121.847900390625,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -765.279052734375,
        -2333.9970703125,
        639.3507080078125
      ],
      "bbox_max": [
        -734.5917358398438,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -758.4042358398438,
        -2314.27783203125,
        639.3507080078125
      ],
      "bbox_max": [
        -756.3106689453125,
        -2311.61328125,
        639.3829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -765.279052734375,
        -2319.55615234375,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -765.279052734375,
        -2319.55615234375,
        639.3507080078125
      ],
      "bbox_max": [
        -752.123779296875,
        -2306.33251953125,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483171820640564,
        -0.5690407156944275,
        0.3409017026424408
      ],
      "plane_d": -965.9954833984375,
      "bbox_min": [
        -763.1381225585938,
        -2311.396728515625,
        649.1970825195312
      ],
      "bbox_max": [
        -760.0314331054688,
        -2307.621826171875,
        651.2776489257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2144.289306640625,
        650.2186279296875
      ],
      "bbox_max": [
        -924.0681762695312,
        -2127.7587890625,
        741.553955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -765.0918579101562,
        -2352.376708984375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -728.7424926757812,
        -2352.376708984375,
        686.9425659179688
      ],
      "bbox_max": [
        -720.4444580078125,
        -2339.38037109375,
        865.884033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -765.0918579101562,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2295.123779296875,
        867.2271728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -762.0160522460938,
        -2308.695556640625,
        647.44970703125
      ],
      "bbox_max": [
        -755.9295654296875,
        -2302.23095703125,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -762.0160522460938,
        -2306.4140625,
        675.0604858398438
      ],
      "bbox_max": [
        -761.55126953125,
        -2305.747802734375,
        675.1514892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -765.0918579101562,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2295.123779296875,
        759.632080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5426011085510254,
        -0.3395310938358307,
        -0.7683115005493164
      ],
      "plane_d": 149.05596923828125,
      "bbox_min": [
        -761.9382934570312,
        -2316.721435546875,
        675.13037109375
      ],
      "bbox_max": [
        -752.123779296875,
        -2305.747802734375,
        686.6377563476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -759.273681640625,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2302.23388671875,
        650.0578002929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -756.3106689453125,
        -2317.2421875,
        639.3170776367188
      ],
      "bbox_max": [
        -750.8490600585938,
        -2308.314453125,
        639.357421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -757.0101318359375,
        -2350.402099609375,
        639.28125
      ],
      "bbox_max": [
        -714.7833862304688,
        -2299.9072265625,
        666.333251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -757.0101318359375,
        -2303.12060546875,
        648.49169921875
      ],
      "bbox_max": [
        -755.6075439453125,
        -2300.060302734375,
        666.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7748749256134033,
        -0.6262521743774414,
        0.08588986098766327
      ],
      "plane_d": -911.8594360351562,
      "bbox_min": [
        -755.9369506835938,
        -2302.23388671875,
        650.0578002929688
      ],
      "bbox_max": [
        -755.906494140625,
        -2302.20166015625,
        650.1961669921875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -755.9295654296875,
        -2303.12060546875,
        648.49169921875
      ],
      "bbox_max": [
        -755.6075439453125,
        -2302.20166015625,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7030006051063538,
        -0.5471718311309814,
        0.45430508255958557
      ],
      "plane_d": -1023.6231079101562,
      "bbox_min": [
        -756.3975219726562,
        -2308.314453125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.90771484375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.775994062423706,
        0.5936565399169922,
        0.21308477222919464
      ],
      "plane_d": 1814.778076171875,
      "bbox_min": [
        -756.3975219726562,
        -2304.79736328125,
        639.28125
      ],
      "bbox_max": [
        -750.960693359375,
        -2299.90771484375,
        650.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9562264084815979,
        0.139556884765625,
        0.257205992937088
      ],
      "plane_d": 836.2110595703125,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        676.75634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8815664052963257,
        0.47085967659950256,
        0.03364010900259018
      ],
      "plane_d": 1707.248779296875,
      "bbox_min": [
        -742.0281372070312,
        -2404.270751953125,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2313.18505859375,
        649.505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.005797189194709063,
        0.006173789035528898,
        0.9999641180038452
      ],
      "plane_d": -620.675537109375,
      "bbox_min": [
        -742.0281372070312,
        -2350.78662109375,
        639.28125
      ],
      "bbox_max": [
        -708.852294921875,
        -2313.18505859375,
        639.3538208007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6762436032295227,
        0.7347268462181091,
        0.053582221269607544
      ],
      "plane_d": 2184.045166015625,
      "bbox_min": [
        -1049.821533203125,
        -2145.107666015625,
        219.68569946289062
      ],
      "bbox_max": [
        -925.6937866210938,
        -2022.358642578125,
        832.941162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -969.41943359375,
        -2145.107666015625,
        650.2186279296875
      ],
      "bbox_max": [
        -925.6937866210938,
        -2127.7587890625,
        832.941162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -708.7366943359375,
        -3518.638427734375,
        443.0972900390625
      ],
      "bbox_max": [
        199.43505859375,
        -2344.52734375,
        872.3767700195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -689.266845703125,
        -2459.815673828125,
        558.2156982421875
      ],
      "bbox_max": [
        -642.5032958984375,
        -2391.343994140625,
        865.8818359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -689.266845703125,
        -2405.76025390625,
        558.2156982421875
      ],
      "bbox_max": [
        -673.747314453125,
        -2391.343994140625,
        865.4605712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        630.2252807617188
      ],
      "bbox_max": [
        -704.3489990234375,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -708.7366943359375,
        -2349.337158203125,
        641.6248779296875
      ],
      "bbox_max": [
        -704.5856323242188,
        -2344.52734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -24.536930084228516,
        -3518.638427734375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3164.78857421875,
        855.624267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        161.8573760986328,
        -3518.638427734375,
        748.3753662109375
      ],
      "bbox_max": [
        199.43505859375,
        -3463.04833984375,
        855.624267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7385133504867554,
        0.6736845970153809,
        0.027333253994584084
      ],
      "plane_d": 2070.8447265625,
      "bbox_min": [
        -928.2157592773438,
        -2385.0,
        386.6241149902344
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        873.310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34745892882347107,
        0.9374035000801086,
        0.023386523127555847
      ],
      "plane_d": 2312.29541015625,
      "bbox_min": [
        -928.2157592773438,
        -2348.42529296875,
        386.6241149902344
      ],
      "bbox_max": [
        -692.9767456054688,
        -2135.580322265625,
        873.310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -928.2157592773438,
        -2348.42529296875,
        560.3877563476562
      ],
      "bbox_max": [
        -692.9767456054688,
        -2137.733642578125,
        873.310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -928.2157592773438,
        -2300.930419921875,
        583.9189453125
      ],
      "bbox_max": [
        -756.95556640625,
        -2137.733642578125,
        873.310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -928.2157592773438,
        -2168.956298828125,
        583.9189453125
      ],
      "bbox_max": [
        -852.66796875,
        -2137.733642578125,
        873.310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3005043566226959,
        0.9524807333946228,
        0.04977479577064514
      ],
      "plane_d": 2285.599609375,
      "bbox_min": [
        -926.8214111328125,
        -2168.956298828125,
        583.9189453125
      ],
      "bbox_max": [
        -852.66796875,
        -2137.733642578125,
        733.704833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -771.5575561523438,
        -2300.930419921875,
        742.3956298828125
      ],
      "bbox_max": [
        -759.4661254882812,
        -2275.722412109375,
        865.232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -768.545166015625,
        -2348.42529296875,
        560.3877563476562
      ],
      "bbox_max": [
        -692.9767456054688,
        -2257.5107421875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -768.0648193359375,
        -2303.75732421875,
        759.6312255859375
      ],
      "bbox_max": [
        -758.6404418945312,
        -2280.178466796875,
        866.58154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -753.871337890625,
        -2348.42529296875,
        630.2252807617188
      ],
      "bbox_max": [
        -692.9767456054688,
        -2290.000732421875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -704.5369873046875,
        -2348.38916015625,
        630.2252807617188
      ],
      "bbox_max": [
        -692.9767456054688,
        -2339.81640625,
        639.2811889648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -753.871337890625,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -693.1766357421875,
        -2290.000732421875,
        641.6248779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -750.960693359375,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -693.1766357421875,
        -2293.65966796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -704.5856323242188,
        -2348.42529296875,
        639.2811889648438
      ],
      "bbox_max": [
        -693.1766357421875,
        -2339.964599609375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -881.6668090820312,
        -2170.06396484375,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2161.587890625,
        869.2027587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -856.5706787109375,
        -2385.0,
        560.3877563476562
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -856.5706787109375,
        -2259.916259765625,
        560.3877563476562
      ],
      "bbox_max": [
        -765.472412109375,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.5706787109375,
        -2170.197509765625,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.44970703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -856.1751708984375,
        -2222.050537109375,
        733.704833984375
      ],
      "bbox_max": [
        -808.619384765625,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -856.1751708984375,
        -2170.466796875,
        733.704833984375
      ],
      "bbox_max": [
        -852.66796875,
        -2168.956298828125,
        866.4063110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137159526348114,
        -0.01990017108619213,
        0.9903489947319031
      ],
      "plane_d": -646.2860107421875,
      "bbox_min": [
        -738.8414916992188,
        -2385.0,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        817.3342895507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1436760127544403,
        0.03255536034703255,
        0.9890891313552856
      ],
      "plane_d": -535.7574462890625,
      "bbox_min": [
        -738.8414916992188,
        -2340.0029296875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13787776231765747,
        -0.03273407742381096,
        0.9899080991744995
      ],
      "plane_d": -673.2636108398438,
      "bbox_min": [
        -738.8414916992188,
        -2340.0029296875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        4.0210002794083266e-07,
        -1.1187556765435147e-06,
        0.9999999403953552
      ],
      "plane_d": -639.283447265625,
      "bbox_min": [
        -738.8414916992188,
        -2340.0029296875,
        618.4127807617188
      ],
      "bbox_max": [
        -66.12939453125,
        -1979.0,
        697.0984497070312
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -693.1766357421875,
        -2339.964599609375,
        618.4127807617188
      ],
      "bbox_max": [
        -66.12939453125,
        -1979.0,
        639.2814331054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        639.2813720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -195.0,
        -2181.199951171875,
        618.4127807617188
      ],
      "bbox_max": [
        -66.12939453125,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -105.22237396240234,
        -2139.665283203125,
        618.412841796875
      ],
      "bbox_max": [
        -66.12939453125,
        -2048.967529296875,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -105.2154541015625,
        -2059.421630859375,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2048.967529296875,
        624.736083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442962646484,
        -2071.60009765625,
        623.3184814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -105.22237396240234,
        -2139.665283203125,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        618.5244140625
      ],
      "bbox_max": [
        -92.20442199707031,
        -2136.069580078125,
        622.3348388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -105.22237396240234,
        -2136.069580078125,
        618.412841796875
      ],
      "bbox_max": [
        -89.30126953125,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -91.10107421875,
        -2081.89990234375,
        618.5244140625
      ],
      "bbox_max": [
        -89.30126953125,
        -2081.89990234375,
        623.3673095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -105.22237396240234,
        -2136.069580078125,
        618.412841796875
      ],
      "bbox_max": [
        -91.10107421875,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -105.22237396240234,
        -2070.1806640625,
        618.412841796875
      ],
      "bbox_max": [
        -100.88525390625,
        -2069.38525390625,
        625.0650024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -195.0,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2064.5546875,
        625.504150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2069.38525390625,
        618.412841796875
      ],
      "bbox_max": [
        -105.22237396240234,
        -2069.026611328125,
        625.3372802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        618.412841796875
      ],
      "bbox_max": [
        -105.278564453125,
        -2140.8193359375,
        624.4165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        618.412841796875
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        624.4165649414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2059.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1979.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -195.0,
        -2059.573974609375,
        618.412841796875
      ],
      "bbox_max": [
        -105.2154541015625,
        -1987.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -192.28419494628906,
        -1987.0,
        635.39453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.582447350025177,
        -0.8128684759140015,
        -1.3322576251084683e-06
      ],
      "plane_d": -1436.1011962890625,
      "bbox_min": [
        -738.8414916992188,
        -2340.0029296875,
        639.2811889648438
      ],
      "bbox_max": [
        -249.72195434570312,
        -1979.0,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -738.8414916992188,
        -2293.697265625,
        639.28125
      ],
      "bbox_max": [
        -356.554931640625,
        -2022.1925048828125,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -600.715087890625,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -407.52972412109375,
        -2058.7177734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -600.715087890625,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -600.715087890625,
        -2195.306396484375,
        639.2813110351562
      ],
      "bbox_max": [
        -598.208740234375,
        -2191.379638671875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -599.2575073242188,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -510.4124755859375,
        -2130.041748046875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.2575073242188,
        -2195.333251953125,
        639.2813110351562
      ],
      "bbox_max": [
        -598.191650390625,
        -2193.659912109375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -599.1027221679688,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -407.52972412109375,
        -2058.7177734375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428605794906616,
        0.5381312370300293,
        -0.0008949324255809188
      ],
      "plane_d": 1686.1417236328125,
      "bbox_min": [
        -599.1027221679688,
        -2195.333251953125,
        639.28125
      ],
      "bbox_max": [
        -413.5885009765625,
        -2063.05908203125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -416.1728515625,
        -2064.681640625,
        639.28125
      ],
      "bbox_max": [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -635.3164672851562,
        -2193.9814453125,
        641.6248779296875
      ],
      "bbox_max": [
        -356.554931640625,
        -2022.1925048828125,
        697.0984497070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -581.8073120117188,
        -2132.99560546875,
        641.6248779296875
      ],
      "bbox_max": [
        -489.5420837402344,
        -2082.13818359375,
        690.3378295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -438.25628662109375,
        -2063.322021484375,
        641.6248779296875
      ],
      "bbox_max": [
        -356.554931640625,
        -2022.1925048828125,
        672.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -438.25628662109375,
        -2063.322021484375,
        641.6248779296875
      ],
      "bbox_max": [
        -387.0029296875,
        -2031.0791015625,
        672.068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -641.6248779296875,
      "bbox_min": [
        -697.1294555664062,
        -2340.0029296875,
        639.2811889648438
      ],
      "bbox_max": [
        -249.72195434570312,
        -1979.0,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.595664381980896,
        -0.8032335042953491,
        0.0
      ],
      "plane_d": -1466.6373291015625,
      "bbox_min": [
        -693.2283935546875,
        -2340.0029296875,
        639.2811889648438
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -351.5553283691406,
        -2077.0341796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580781817436218,
        0.6098334789276123,
        0.7070240378379822
      ],
      "plane_d": 697.9700927734375,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -362.3825988769531,
        -2094.6533203125,
        641.6248779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -563.099609375,
        -2240.273681640625,
        639.28125
      ],
      "bbox_max": [
        -559.5923461914062,
        -2237.091064453125,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -383.08306884765625,
        -2108.78369140625,
        639.28125
      ],
      "bbox_max": [
        -362.3825988769531,
        -2094.6533203125,
        640.7756958007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -481.86572265625,
        -2175.087646484375,
        639.28125
      ],
      "bbox_max": [
        -351.5553283691406,
        -2077.0341796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -360.9189453125,
        -2079.7548828125,
        641.466552734375
      ],
      "bbox_max": [
        -356.9158630371094,
        -2077.0341796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -415.853271484375,
        -2098.81298828125,
        639.28125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -415.51983642578125,
        -2078.708984375,
        639.2813720703125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        639.2813720703125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -413.5885009765625,
        -2063.05908203125,
        639.4384155273438
      ],
      "bbox_max": [
        -377.63330078125,
        -2046.1796875,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -413.5242004394531,
        -2063.012939453125,
        639.4616088867188
      ],
      "bbox_max": [
        -381.7651062011719,
        -2047.9124755859375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -404.71063232421875,
        -2131.402587890625,
        639.28125
      ],
      "bbox_max": [
        -314.135009765625,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -404.71063232421875,
        -2126.043212890625,
        639.28125
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2091.495361328125,
        639.9999389648438
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3580781817436218,
        0.6098334789276123,
        0.7070240378379822
      ],
      "plane_d": 697.9700927734375,
      "bbox_min": [
        -404.71063232421875,
        -2126.043212890625,
        641.3375854492188
      ],
      "bbox_max": [
        -402.5533142089844,
        -2124.443359375,
        641.6248779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -561.7347412109375,
        -2288.8349609375,
        641.6248779296875
      ],
      "bbox_max": [
        -249.72195434570312,
        -1979.0,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -561.7347412109375,
        -2288.8349609375,
        641.6248779296875
      ],
      "bbox_max": [
        -249.72195434570312,
        -2016.6390380859375,
        679.6005249023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -481.7292785644531,
        -2209.49267578125,
        641.6248779296875
      ],
      "bbox_max": [
        -249.72195434570312,
        -2016.6390380859375,
        673.8995361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -344.92059326171875,
        -2131.402587890625,
        641.6248779296875
      ],
      "bbox_max": [
        -249.72195434570312,
        -2042.298095703125,
        656.8388061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -344.92059326171875,
        -2131.402587890625,
        641.6248779296875
      ],
      "bbox_max": [
        -299.1034240722656,
        -2076.33544921875,
        656.8388061523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -337.21295166015625,
        -2104.4287109375,
        652.1087646484375
      ],
      "bbox_max": [
        -299.1034240722656,
        -2076.33544921875,
        656.7574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -337.21295166015625,
        -2104.4287109375,
        652.5117797851562
      ],
      "bbox_max": [
        -326.5126953125,
        -2095.0888671875,
        656.7574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -292.998291015625,
        -2070.21044921875,
        645.7384643554688
      ],
      "bbox_max": [
        -249.72195434570312,
        -2042.298095703125,
        645.8165893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -268.69073486328125,
        -2067.064208984375,
        645.7384643554688
      ],
      "bbox_max": [
        -249.72195434570312,
        -2042.298095703125,
        645.8165893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -478.2337341308594,
        -2177.475341796875,
        641.6248779296875
      ],
      "bbox_max": [
        -254.21783447265625,
        -2016.6390380859375,
        668.8553466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -431.2630920410156,
        -2163.538818359375,
        641.6248779296875
      ],
      "bbox_max": [
        -254.21783447265625,
        -2030.50146484375,
        666.8972778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -347.17816162109375,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -254.21783447265625,
        -2030.50146484375,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.17816162109375,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -344.845703125,
        -2090.115478515625,
        641.7520141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -345.68505859375,
        -2092.55712890625,
        641.6248779296875
      ],
      "bbox_max": [
        -344.845703125,
        -2091.495361328125,
        641.7520141601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -254.21783447265625,
        -2030.50146484375,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -297.43212890625,
        -2066.11767578125,
        645.7384643554688
      ],
      "bbox_max": [
        -292.998291015625,
        -2065.151123046875,
        646.0267333984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -431.2630920410156,
        -2163.538818359375,
        641.6248779296875
      ],
      "bbox_max": [
        -293.2745361328125,
        -2065.151123046875,
        666.8972778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -431.2630920410156,
        -2147.85595703125,
        641.6248779296875
      ],
      "bbox_max": [
        -293.2745361328125,
        -2065.151123046875,
        652.6318969726562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -345.69329833984375,
        -2100.665771484375,
        641.7091064453125
      ],
      "bbox_max": [
        -293.2745361328125,
        -2065.990966796875,
        652.6318969726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -299.1034240722656,
        -2076.33544921875,
        645.9889526367188
      ],
      "bbox_max": [
        -293.2745361328125,
        -2065.990966796875,
        652.1087646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -349.2778625488281,
        -2098.708984375,
        641.6248779296875
      ],
      "bbox_max": [
        -293.819580078125,
        -2065.151123046875,
        651.7774658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -349.2778625488281,
        -2092.92724609375,
        641.6248779296875
      ],
      "bbox_max": [
        -344.6956787109375,
        -2088.8212890625,
        645.4060668945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -347.7261962890625,
        -2091.495361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2089.609130859375,
        643.966552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -349.2778625488281,
        -2091.495361328125,
        641.6248779296875
      ],
      "bbox_max": [
        -345.68505859375,
        -2088.8212890625,
        644.1882934570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.2778625488281,
        -2090.284423828125,
        641.6248779296875
      ],
      "bbox_max": [
        -347.660400390625,
        -2089.070068359375,
        641.7003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -348.3093566894531,
        -2089.669677734375,
        641.6913452148438
      ],
      "bbox_max": [
        -347.29803466796875,
        -2088.8212890625,
        641.7266235351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -347.7991638183594,
        -2092.7470703125,
        641.726318359375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        645.3406982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -347.7991638183594,
        -2089.455322265625,
        641.726318359375
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        642.3384399414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -427.6854248046875,
        -2163.538818359375,
        641.6248779296875
      ],
      "bbox_max": [
        -329.4200439453125,
        -2079.83544921875,
        666.8972778320312
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -339.98199462890625,
        -2103.80126953125,
        650.8302612304688
      ],
      "bbox_max": [
        -329.4200439453125,
        -2093.555419921875,
        656.8781127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -339.98199462890625,
        -2102.21142578125,
        650.8302612304688
      ],
      "bbox_max": [
        -337.2131042480469,
        -2098.708984375,
        654.7056884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -338.4957275390625,
        -2103.80126953125,
        653.2045288085938
      ],
      "bbox_max": [
        -335.95623779296875,
        -2100.5888671875,
        656.8781127929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -350.619873046875,
        -2103.497802734375,
        641.6248779296875
      ],
      "bbox_max": [
        -330.7851867675781,
        -2079.83544921875,
        657.4176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37263402342796326,
        0.536638617515564,
        0.7570752501487732
      ],
      "plane_d": 506.03204345703125,
      "bbox_min": [
        -349.859375,
        -2100.5888671875,
        641.6248779296875
      ],
      "bbox_max": [
        -338.4957275390625,
        -2084.468994140625,
        653.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -344.69580078125,
        -2100.5888671875,
        645.3403930664062
      ],
      "bbox_max": [
        -338.4957275390625,
        -2092.74658203125,
        653.2045288085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.859375,
        -2096.26513671875,
        641.6248779296875
      ],
      "bbox_max": [
        -338.8740234375,
        -2084.468994140625,
        649.2035522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -349.04022216796875,
        -2089.070068359375,
        641.6248779296875
      ],
      "bbox_max": [
        -348.3093566894531,
        -2088.394775390625,
        641.6912841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -348.9796142578125,
        -2096.26513671875,
        641.6820678710938
      ],
      "bbox_max": [
        -341.9140625,
        -2088.45068359375,
        649.2035522460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -348.9796142578125,
        -2091.495361328125,
        641.6820678710938
      ],
      "bbox_max": [
        -345.68505859375,
        -2088.45068359375,
        644.7898559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -350.619873046875,
        -2103.497802734375,
        641.6248779296875
      ],
      "bbox_max": [
        -336.19610595703125,
        -2079.83544921875,
        657.4176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -350.619873046875,
        -2088.79736328125,
        641.6248779296875
      ],
      "bbox_max": [
        -348.9795837402344,
        -2087.480224609375,
        641.6820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -350.02984619140625,
        -2088.45068359375,
        641.66748046875
      ],
      "bbox_max": [
        -348.30291748046875,
        -2087.014404296875,
        641.7259521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -349.227783203125,
        -2088.18408203125,
        641.7254028320312
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -342.9916687011719,
        -2084.468994140625,
        642.1755981445312
      ],
      "bbox_max": [
        -336.9632263183594,
        -2079.83544921875,
        642.5633544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -358.5946044921875,
        -2099.334716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -257.1222229003906,
        -2016.6390380859375,
        658.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -304.09906005859375,
        -2058.383056640625,
        645.7384643554688
      ],
      "bbox_max": [
        -257.1222229003906,
        -2016.6390380859375,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -278.13720703125,
        -2019.491943359375,
        645.829345703125
      ],
      "bbox_max": [
        -259.83270263671875,
        -2016.6390380859375,
        647.85302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -358.5946044921875,
        -2099.334716796875,
        641.6248779296875
      ],
      "bbox_max": [
        -326.17437744140625,
        -2053.673828125,
        658.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04958168417215347,
        -0.038692716509103775,
        0.998020350933075
      ],
      "plane_d": -738.5225219726562,
      "bbox_min": [
        -356.9158630371094,
        -2087.82275390625,
        641.6248779296875
      ],
      "bbox_max": [
        -342.9916687011719,
        -2079.7548828125,
        642.1755981445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2087.48046875,
        641.6248779296875
      ],
      "bbox_max": [
        -350.02978515625,
        -2086.4697265625,
        641.6674194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2087.52099609375,
        641.65234375
      ],
      "bbox_max": [
        -349.98590087890625,
        -2086.4697265625,
        641.7257080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -351.123291015625,
        -2099.334716796875,
        641.70263671875
      ],
      "bbox_max": [
        -339.4874267578125,
        -2086.4697265625,
        658.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2091.495361328125,
        641.70263671875
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        658.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -407.52972412109375,
        -2088.548095703125,
        641.6248779296875
      ],
      "bbox_max": [
        -274.0508728027344,
        -1979.0,
        660.0204467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        648.1774291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -275.0,
        -1987.0,
        641.6248779296875
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        647.015380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04707995429635048,
        -0.029050050303339958,
        0.9984686374664307
      ],
      "plane_d": -717.8629150390625,
      "bbox_min": [
        -377.63330078125,
        -2088.548095703125,
        641.6248779296875
      ],
      "bbox_max": [
        -274.0508728027344,
        -2009.441162109375,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -309.987548828125,
        -2033.5198974609375,
        645.7384643554688
      ],
      "bbox_max": [
        -278.13726806640625,
        -2014.4228515625,
        645.829345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2033.5198974609375,
        645.7384643554688
      ],
      "bbox_max": [
        -293.0437316894531,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07334648817777634,
        -0.018153509125113487,
        0.9971413016319275
      ],
      "plane_d": -703.1978759765625,
      "bbox_min": [
        -351.123291015625,
        -2088.548095703125,
        643.833251953125
      ],
      "bbox_max": [
        -274.0508728027344,
        -2009.441162109375,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -309.987548828125,
        -2038.2144775390625,
        645.7384643554688
      ],
      "bbox_max": [
        -274.0508728027344,
        -2014.4228515625,
        648.1777954101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -309.987548828125,
        -2038.2144775390625,
        645.7384643554688
      ],
      "bbox_max": [
        -298.2037048339844,
        -2014.4228515625,
        645.7384643554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -351.123291015625,
        -2088.548095703125,
        645.7384643554688
      ],
      "bbox_max": [
        -276.3931579589844,
        -2009.441162109375,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -351.123291015625,
        -2088.548095703125,
        645.7384643554688
      ],
      "bbox_max": [
        -300.8400573730469,
        -2009.441162109375,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2088.548095703125,
        655.4558715820312
      ],
      "bbox_max": [
        -348.8742370605469,
        -2086.4697265625,
        659.28759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -635.32763671875,
        -2290.83056640625,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -506.8857421875,
        -2234.297607421875,
        622.0928955078125
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.7216796875,
        677.7113647460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4699274003505707,
        0.5901298522949219,
        0.6564411520957947
      ],
      "plane_d": 636.0174560546875,
      "bbox_min": [
        -506.8857421875,
        -2234.297607421875,
        622.0928955078125
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.7216796875,
        677.7113647460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2181.199951171875,
        622.0928955078125
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.7216796875,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -100.88525390625,
        -2139.665283203125,
        622.0928955078125
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.7216796875,
        623.5617065429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.3040161132812
      ],
      "bbox_max": [
        -92.20442199707031,
        -2136.069580078125,
        622.4317016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442962646484,
        -2136.069580078125,
        622.3347778320312
      ],
      "bbox_max": [
        -91.4780502319336,
        -2130.7216796875,
        622.4384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.6862182617188
      ],
      "bbox_max": [
        -105.278564453125,
        -2140.8193359375,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.2633666992188
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        624.61962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -436.0340576171875,
        -2177.524658203125,
        664.5492553710938
      ],
      "bbox_max": [
        -398.3159484863281,
        -2148.872802734375,
        669.1536865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -436.0340576171875,
        -2177.524658203125,
        666.8972778320312
      ],
      "bbox_max": [
        -418.5774230957031,
        -2163.538818359375,
        669.1536865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44907262921333313,
        -0.624068021774292,
        0.6394317150115967
      ],
      "plane_d": -1510.1580810546875,
      "bbox_min": [
        -635.32763671875,
        -2162.76806640625,
        696.8292236328125
      ],
      "bbox_max": [
        -633.0643310546875,
        -2161.42333984375,
        697.1158447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -91.48380279541016,
        -2132.77880859375,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2113.157470703125,
        622.4412841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        26.906936645507812,
        -2132.77880859375,
        605.8223876953125
      ],
      "bbox_max": [
        27.273826599121094,
        -2132.563232421875,
        606.0013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -91.48380279541016,
        -2130.763916015625,
        622.4104614257812
      ],
      "bbox_max": [
        -91.18240356445312,
        -2128.544921875,
        622.4412841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -410.681640625,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1979.0,
        668.4696044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        646.7520141601562
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        651.8515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        647.015380859375
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        651.8515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -410.681640625,
        -2077.08203125,
        619.4662475585938
      ],
      "bbox_max": [
        -66.12939453125,
        -1979.0,
        668.4696044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -2051.19921875,
        623.7628784179688
      ],
      "bbox_max": [
        -100.88525390625,
        -1979.0,
        639.8246459960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -2051.19921875,
        623.7628784179688
      ],
      "bbox_max": [
        -100.88525390625,
        -1979.0,
        639.6639404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        635.0
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        639.6639404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -101.80962371826172,
        -2051.19921875,
        623.7628784179688
      ],
      "bbox_max": [
        -100.88525390625,
        -2048.967529296875,
        625.4306030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -410.681640625,
        -2077.08203125,
        619.4662475585938
      ],
      "bbox_max": [
        -66.12939453125,
        -2007.8206787109375,
        668.4696044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        623.9706420898438
      ],
      "bbox_max": [
        -101.40150451660156,
        -2050.2138671875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        624.750244140625
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.72607421875,
        625.423095703125
      ],
      "bbox_max": [
        -108.29034423828125,
        -2064.5546875,
        626.241943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -108.29034423828125,
        -2077.08203125,
        621.3797607421875
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -108.29034423828125,
        -2075.28662109375,
        623.0650024414062
      ],
      "bbox_max": [
        -90.278564453125,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -108.29034423828125,
        -2073.776123046875,
        623.289794921875
      ],
      "bbox_max": [
        -92.20443725585938,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.29034423828125,
        -2067.21044921875,
        625.405029296875
      ],
      "bbox_max": [
        -108.0561294555664,
        -2066.72607421875,
        626.0529174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.0561294555664,
        -2075.28662109375,
        623.3184814453125
      ],
      "bbox_max": [
        -91.9992904663086,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.0561294555664,
        -2069.026611328125,
        625.3372802734375
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.21044921875,
        626.0107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.2044448852539,
        -2075.28662109375,
        623.3184814453125
      ],
      "bbox_max": [
        -91.9992904663086,
        -2073.776123046875,
        623.683349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99929809570312,
        -2077.08203125,
        623.33837890625
      ],
      "bbox_max": [
        -91.75545501708984,
        -2075.28662109375,
        623.6245727539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -410.681640625,
        -2040.0166015625,
        651.5675659179688
      ],
      "bbox_max": [
        -297.89105224609375,
        -2007.8206787109375,
        668.4696044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -313.8014221191406,
        -2011.2637939453125,
        651.5675659179688
      ],
      "bbox_max": [
        -297.89105224609375,
        -2007.8206787109375,
        655.6990356445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        -91.76782989501953,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2063.799072265625,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.76782989501953,
        -2080.781494140625,
        623.362060546875
      ],
      "bbox_max": [
        -91.25299072265625,
        -2076.990966796875,
        623.5582885742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10736268758773804,
        -0.8992251753807068,
        0.42410773038864136
      ],
      "plane_d": -2122.285888671875,
      "bbox_min": [
        -674.18994140625,
        -2385.0,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -1918.043212890625,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05980534851551056,
        -0.671236515045166,
        0.7388266921043396
      ],
      "plane_d": -1850.9669189453125,
      "bbox_min": [
        -465.21954345703125,
        -2083.561767578125,
        620.111572265625
      ],
      "bbox_max": [
        121.512451171875,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.010637740604579449,
        -0.5737824440002441,
        0.8189386129379272
      ],
      "plane_d": -1711.5538330078125,
      "bbox_min": [
        -447.19268798828125,
        -2078.106689453125,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17199364304542542,
        -0.8070312738418579,
        0.5649060010910034
      ],
      "plane_d": -2035.607421875,
      "bbox_min": [
        -404.39532470703125,
        -2078.106689453125,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -283.0,
        -2071.8154296875,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -1979.0,
        705.9292602539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        638.555908203125
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        705.9292602539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        638.555908203125
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        700.3240966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        650.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        692.4945068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        650.7435913085938
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        681.065673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -106.79005432128906,
        -2071.8154296875,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -1998.9012451171875,
        690.3646850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -92.9021224975586,
        -2071.8154296875,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -2000.3099365234375,
        687.002197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -92.9021224975586,
        -2046.7047119140625,
        652.7044067382812
      ],
      "bbox_max": [
        -85.13467407226562,
        -2044.573974609375,
        653.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -92.9021224975586,
        -2045.6607666015625,
        652.7044067382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2044.573974609375,
        653.6278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -78.51063537597656,
        -2071.8154296875,
        620.111572265625
      ],
      "bbox_max": [
        -66.12939453125,
        -2070.32080078125,
        623.4907836914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -106.79005432128906,
        -2061.427490234375,
        625.3841552734375
      ],
      "bbox_max": [
        -100.88525390625,
        -2048.967529296875,
        645.5497436523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -106.79005432128906,
        -2061.427490234375,
        625.779541015625
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        629.0595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19249416887760162,
        -0.6418299078941345,
        0.7422939538955688
      ],
      "plane_d": -1820.3388671875,
      "bbox_min": [
        -404.39532470703125,
        -2078.106689453125,
        621.8562622070312
      ],
      "bbox_max": [
        -66.12939453125,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2076.99072265625,
        621.8562622070312
      ],
      "bbox_max": [
        -66.12939453125,
        -2039.248291015625,
        660.4767456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -108.26380157470703,
        -2076.99072265625,
        621.8562622070312
      ],
      "bbox_max": [
        -66.12939453125,
        -2040.298095703125,
        659.3046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -98.24182891845703,
        -2047.9700927734375,
        651.5167236328125
      ],
      "bbox_max": [
        -88.04829406738281,
        -2040.298095703125,
        659.3046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -96.99674224853516,
        -2047.5574951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -88.04829406738281,
        -2045.5736083984375,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -90.278564453125,
        -2046.2249755859375,
        653.3761596679688
      ],
      "bbox_max": [
        -88.04829406738281,
        -2045.5736083984375,
        653.890380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -98.24182891845703,
        -2047.87255859375,
        652.7044067382812
      ],
      "bbox_max": [
        -96.92051696777344,
        -2047.3251953125,
        652.8898315429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -108.26380157470703,
        -2076.99072265625,
        622.0199584960938
      ],
      "bbox_max": [
        -79.672119140625,
        -2066.781005859375,
        636.337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26380157470703,
        -2075.28662109375,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2066.781005859375,
        636.337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.177978515625,
        -2075.28662109375,
        623.4006958007812
      ],
      "bbox_max": [
        -90.278564453125,
        -2069.026611328125,
        634.2090454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        623.683349609375
      ],
      "bbox_max": [
        -92.20440673828125,
        -2071.60009765625,
        630.682861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.177978515625,
        -2075.28662109375,
        623.6245727539062
      ],
      "bbox_max": [
        -91.999267578125,
        -2069.026611328125,
        634.2090454101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20442962646484,
        -2075.28662109375,
        623.6245727539062
      ],
      "bbox_max": [
        -91.999267578125,
        -2073.776123046875,
        628.6817016601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.99927520751953,
        -2076.99072265625,
        623.5582885742188
      ],
      "bbox_max": [
        -91.76782989501953,
        -2075.28662109375,
        627.2297973632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        625.9515991210938
      ],
      "bbox_max": [
        -97.29429626464844,
        -2039.248291015625,
        660.4767456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        626.048095703125
      ],
      "bbox_max": [
        -108.26380157470703,
        -2064.5546875,
        638.447021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -97.46320343017578,
        -2040.531982421875,
        659.0283813476562
      ],
      "bbox_max": [
        -97.29429626464844,
        -2039.248291015625,
        660.4767456054688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -404.39532470703125,
        -2078.106689453125,
        626.3668212890625
      ],
      "bbox_max": [
        -112.20849609375,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.308013379573822,
        -0.7344424724578857,
        0.6047495603561401
      ],
      "plane_d": -1774.5074462890625,
      "bbox_min": [
        -404.39532470703125,
        -2065.927734375,
        645.7430419921875
      ],
      "bbox_max": [
        -217.74951171875,
        -2003.981689453125,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -404.39532470703125,
        -2065.927734375,
        645.7430419921875
      ],
      "bbox_max": [
        -217.74951171875,
        -2003.981689453125,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -404.39532470703125,
        -2037.5177001953125,
        665.2955932617188
      ],
      "bbox_max": [
        -382.385009765625,
        -2025.8243408203125,
        670.569580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -400.16082763671875,
        -2033.27099609375,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        678.6296997070312
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        688.9049682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05210539326071739,
        -0.8414621353149414,
        0.5377978086471558
      ],
      "plane_d": -2058.4892578125,
      "bbox_min": [
        -400.16082763671875,
        -2033.27099609375,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.859130859375
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        704.5523071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        687.859130859375
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        692.0354614257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08399815112352371,
        -0.8149160742759705,
        0.5734597444534302
      ],
      "plane_d": -2037.928955078125,
      "bbox_min": [
        -400.16082763671875,
        -2033.27099609375,
        646.001708984375
      ],
      "bbox_max": [
        -217.74951171875,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -341.9970703125,
        -1987.0,
        691.26025390625
      ],
      "bbox_max": [
        -275.0,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -341.9970703125,
        -1987.0,
        691.26025390625
      ],
      "bbox_max": [
        -275.0,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -341.9970703125,
        -1974.9400634765625,
        710.3526000976562
      ],
      "bbox_max": [
        -333.45318603515625,
        -1969.59423828125,
        714.3178100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -341.9970703125,
        -1974.9400634765625,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1970.3802490234375,
        713.7991333007812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -336.52667236328125,
        -1971.594482421875,
        710.3526000976562
      ],
      "bbox_max": [
        -334.72802734375,
        -1970.3802490234375,
        713.7991333007812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -447.19268798828125,
        -2070.297119140625,
        642.3065185546875
      ],
      "bbox_max": [
        -99.61474609375,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1980.298828125,
        705.019287109375
      ],
      "bbox_max": [
        -187.0,
        -1918.043212890625,
        766.5938110351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1980.298828125,
        705.019287109375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        707.2992553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -187.0,
        -1979.346435546875,
        705.5827026367188
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        706.1907348632812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -375.7254638671875,
        -2000.877685546875,
        692.84619140625
      ],
      "bbox_max": [
        -275.0,
        -1955.786376953125,
        741.6905517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794841408729553,
        -0.8249640464782715,
        0.4013371765613556
      ],
      "plane_d": -1778.3809814453125,
      "bbox_min": [
        -375.7254638671875,
        -1990.46337890625,
        701.3634033203125
      ],
      "bbox_max": [
        -275.0,
        -1955.786376953125,
        741.6905517578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -350.28753662109375,
        -1970.9891357421875,
        713.3804931640625
      ],
      "bbox_max": [
        -335.9170227050781,
        -1961.2728271484375,
        739.6508178710938
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -341.20098876953125,
        -1987.0,
        701.3634033203125
      ],
      "bbox_max": [
        -275.0,
        -1955.786376953125,
        741.6905517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3634033203125
      ],
      "bbox_max": [
        -275.0,
        -1979.0,
        718.384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -283.0,
        -1987.0,
        701.3634033203125
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        705.4492797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -447.19268798828125,
        -2070.297119140625,
        642.3065185546875
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        728.0743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -250.77691650390625,
        -2069.130615234375,
        645.7384643554688
      ],
      "bbox_max": [
        -243.3459930419922,
        -2065.764892578125,
        645.7661743164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -446.5450744628906,
        -2054.210205078125,
        674.6094360351562
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        720.6820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -446.5450744628906,
        -2054.210205078125,
        674.6094360351562
      ],
      "bbox_max": [
        -275.0,
        -1987.0,
        715.743408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -446.5450744628906,
        -2054.210205078125,
        674.6094360351562
      ],
      "bbox_max": [
        -439.96783447265625,
        -2047.226806640625,
        681.3184204101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.22021484375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        713.3493041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.22021484375
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        713.3493041992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        700.22021484375
      ],
      "bbox_max": [
        -187.0,
        -1987.0,
        707.6776733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13752444088459015,
        -0.08930294960737228,
        0.9864643812179565
      ],
      "plane_d": -788.0382080078125,
      "bbox_min": [
        -465.21954345703125,
        -2083.561767578125,
        626.3668212890625
      ],
      "bbox_max": [
        -67.10629272460938,
        -2015.7926025390625,
        707.9457397460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -465.21954345703125,
        -2078.49365234375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07907104492188,
        -2054.210205078125,
        676.5702514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -301.4764099121094,
        -2078.49365234375,
        652.2869262695312
      ],
      "bbox_max": [
        -299.1501770019531,
        -2076.648193359375,
        652.658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -465.21954345703125,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07907104492188,
        -2054.210205078125,
        676.5702514648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        1.0
      ],
      "plane_d": -645.7384643554688,
      "bbox_min": [
        -250.93359375,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07907104492188,
        -2068.60986328125,
        645.750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003222076455131173,
        -0.003642512019723654,
        0.9999881982803345
      ],
      "plane_d": -654.0671997070312,
      "bbox_min": [
        -248.38243103027344,
        -2070.70849609375,
        645.7384643554688
      ],
      "bbox_max": [
        -245.07907104492188,
        -2068.60986328125,
        645.750244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -464.2539978027344,
        -2083.561767578125,
        626.3668212890625
      ],
      "bbox_max": [
        -67.10629272460938,
        -2015.7926025390625,
        707.9457397460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -464.2539978027344,
        -2078.300537109375,
        645.7384643554688
      ],
      "bbox_max": [
        -246.357421875,
        -2059.23974609375,
        677.01611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -300.9224548339844,
        -2078.300537109375,
        652.5308227539062
      ],
      "bbox_max": [
        -299.21417236328125,
        -2077.076416015625,
        652.908447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -464.2539978027344,
        -2065.688232421875,
        675.7669677734375
      ],
      "bbox_max": [
        -454.3049011230469,
        -2059.23974609375,
        677.01611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -463.86151123046875,
        -2083.32763671875,
        627.3397827148438
      ],
      "bbox_max": [
        -67.10629272460938,
        -2015.7926025390625,
        707.9457397460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -253.28384399414062,
        -2083.32763671875,
        627.3397827148438
      ],
      "bbox_max": [
        -67.10629272460938,
        -2067.60693359375,
        649.47802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -253.28384399414062,
        -2078.29150390625,
        645.7384643554688
      ],
      "bbox_max": [
        -239.5581512451172,
        -2070.70849609375,
        649.47802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -107.86448669433594,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -67.10629272460938,
        -2067.60693359375,
        637.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.86448669433594,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -90.278564453125,
        -2067.60693359375,
        637.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2073.7763671875,
        628.6817016601562
      ],
      "bbox_max": [
        -92.20440673828125,
        -2071.60009765625,
        635.1734008789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.86448669433594,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -92.0062026977539,
        -2067.60693359375,
        636.5714111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -107.86448669433594,
        -2069.026611328125,
        634.2090454101562
      ],
      "bbox_max": [
        -107.177978515625,
        -2067.60693359375,
        636.3084106445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20440673828125,
        -2075.235595703125,
        627.3397827148438
      ],
      "bbox_max": [
        -92.0062026977539,
        -2073.7763671875,
        630.484130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -109.34033203125,
        -2071.3681640625,
        635.5545043945312
      ],
      "bbox_max": [
        -78.00983428955078,
        -2033.1219482421875,
        666.070556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -97.63477325439453,
        -2049.59716796875,
        652.0723266601562
      ],
      "bbox_max": [
        -78.00983428955078,
        -2034.1829833984375,
        663.50390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -97.63477325439453,
        -2049.502197265625,
        652.7044067382812
      ],
      "bbox_max": [
        -80.49156188964844,
        -2045.8577880859375,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -97.63477325439453,
        -2049.502197265625,
        652.8898315429688
      ],
      "bbox_max": [
        -90.278564453125,
        -2045.8577880859375,
        655.2828369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -80.51241302490234,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41132354736328,
        -2048.619384765625,
        653.1491088867188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -79.91655731201172,
        -2049.59716796875,
        652.7044067382812
      ],
      "bbox_max": [
        -79.41132354736328,
        -2048.967529296875,
        653.0237426757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -109.34033203125,
        -2071.3681640625,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.26382446289062,
        -2071.3681640625,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.26382446289062,
        -2069.026611328125,
        635.5545043945312
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -100.88525390625,
        -2050.113525390625,
        652.7044067382812
      ],
      "bbox_max": [
        -96.99674224853516,
        -2047.5574951171875,
        654.4420776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2071.3681640625,
        636.5714111328125
      ],
      "bbox_max": [
        -98.01838684082031,
        -2070.1806640625,
        640.0797729492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.337158203125
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        648.0020751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -109.34033203125,
        -2066.781005859375,
        636.337158203125
      ],
      "bbox_max": [
        -108.2637939453125,
        -2064.0283203125,
        645.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        -0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": -1098.954833984375,
      "bbox_min": [
        -109.34033203125,
        -2065.292724609375,
        644.2874145507812
      ],
      "bbox_max": [
        -108.91099548339844,
        -2064.0283203125,
        645.1771240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -109.34033203125,
        -2065.292724609375,
        644.2874145507812
      ],
      "bbox_max": [
        -108.98348999023438,
        -2064.5546875,
        644.6423950195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1923.6783447265625,
        810.5653686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -132.99351501464844,
        -1971.048828125,
        711.7363891601562
      ],
      "bbox_max": [
        -87.22331237792969,
        -1956.173095703125,
        738.7794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -132.99351501464844,
        -1968.943359375,
        711.7363891601562
      ],
      "bbox_max": [
        -99.61474609375,
        -1956.173095703125,
        738.7794189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1923.6783447265625,
        810.5653686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.6783447265625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.6783447265625,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -348.0,
        -1928.0,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1923.6783447265625,
        767.0492553710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -406.8781433105469,
        -1972.0,
        781.2753295898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -369.0,
        -1947.25,
        772.4187622070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2032.99267578125,
        716.4224243164062
      ],
      "bbox_max": [
        -405.1983947753906,
        -1972.0,
        782.4132080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -408.11614990234375,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -405.1983947753906,
        -1972.0,
        780.4204711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        637.62353515625
      ],
      "bbox_max": [
        121.512451171875,
        -1944.3687744140625,
        780.4795532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        639.9630126953125
      ],
      "bbox_max": [
        -65.14533233642578,
        -1944.3687744140625,
        780.4795532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -240.9657440185547,
        -1974.3787841796875,
        718.9976196289062
      ],
      "bbox_max": [
        -220.87794494628906,
        -1954.890869140625,
        754.331787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -372.4570007324219,
        -1981.1728515625,
        728.0743408203125
      ],
      "bbox_max": [
        -317.3755187988281,
        -1944.3687744140625,
        772.4472045898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47034135460853577,
        -0.768880307674408,
        0.43313068151474
      ],
      "plane_d": -1666.1593017578125,
      "bbox_min": [
        -372.4570007324219,
        -1981.1728515625,
        728.0743408203125
      ],
      "bbox_max": [
        -344.8354187011719,
        -1950.406005859375,
        772.4472045898438
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -372.4570007324219,
        -1981.1728515625,
        728.0743408203125
      ],
      "bbox_max": [
        -350.28759765625,
        -1961.2537841796875,
        762.0708618164062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -570.8470458984375,
        -2100.602294921875,
        639.9630126953125
      ],
      "bbox_max": [
        -65.14533233642578,
        -1955.3333740234375,
        780.4795532226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.473610520362854,
        -0.6577551364898682,
        0.5857056975364685
      ],
      "plane_d": -1535.112548828125,
      "bbox_min": [
        -489.5420837402344,
        -2082.13818359375,
        675.4734497070312
      ],
      "bbox_max": [
        -442.9516906738281,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2043.1591796875,
        691.3497924804688
      ],
      "bbox_max": [
        -442.9516906738281,
        -2032.99267578125,
        716.4224243164062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -468.130615234375,
        -2090.888427734375,
        639.9630126953125
      ],
      "bbox_max": [
        -65.14533233642578,
        -1955.3333740234375,
        780.4795532226562
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.47035908699035645,
        -0.7688663601875305,
        0.4331360161304474
      ],
      "plane_d": -1666.129638671875,
      "bbox_min": [
        -406.2380676269531,
        -1972.0,
        762.07080078125
      ],
      "bbox_max": [
        -365.3275146484375,
        -1955.3333740234375,
        780.1475830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -406.2380676269531,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -404.59869384765625,
        -1972.0,
        780.1475830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -468.130615234375,
        -2090.888427734375,
        639.9630126953125
      ],
      "bbox_max": [
        -65.14533233642578,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -111.82113647460938,
        -2062.45703125,
        650.2849731445312
      ],
      "bbox_max": [
        -65.14533233642578,
        -1981.62548828125,
        741.7178955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -99.86669921875,
        -2061.6728515625,
        653.1491088867188
      ],
      "bbox_max": [
        -80.46390533447266,
        -2047.364990234375,
        665.5609741210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        653.1491088867188
      ],
      "bbox_max": [
        -80.46390533447266,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2706061899662018,
        0.6532682776451111,
        0.7071157693862915
      ],
      "plane_d": 898.547607421875,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        653.1491088867188
      ],
      "bbox_max": [
        -80.46390533447266,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        654.4420776367188
      ],
      "bbox_max": [
        -90.278564453125,
        -2047.364990234375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -99.86669921875,
        -2059.573974609375,
        656.0745849609375
      ],
      "bbox_max": [
        -97.058349609375,
        -2051.547119140625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2061.6728515625,
        657.7044067382812
      ],
      "bbox_max": [
        -80.7760009765625,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -83.4990234375,
        -2059.56591796875,
        652.7044067382812
      ],
      "bbox_max": [
        -78.50768280029297,
        -2049.109375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -80.68840026855469,
        -2062.0478515625,
        650.2849731445312
      ],
      "bbox_max": [
        -72.18734741210938,
        -2051.778564453125,
        657.69921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -76.02014923095703,
        -2062.0478515625,
        650.2849731445312
      ],
      "bbox_max": [
        -72.18734741210938,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -76.02014923095703,
        -2061.798583984375,
        651.1747436523438
      ],
      "bbox_max": [
        -73.61585235595703,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -100.01700592041016,
        -2062.45703125,
        656.4622192382812
      ],
      "bbox_max": [
        -98.35592651367188,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -657.704345703125,
      "bbox_min": [
        -99.86669921875,
        -2061.745849609375,
        657.7044067382812
      ],
      "bbox_max": [
        -98.35592651367188,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.369244784116745,
        -0.7477149367332458,
        0.5518883466720581
      ],
      "plane_d": -1742.62939453125,
      "bbox_min": [
        -468.130615234375,
        -2090.888427734375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -405.909912109375,
        -2090.888427734375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -405.909912109375,
        -1987.0,
        706.9443969726562
      ],
      "bbox_max": [
        -187.0,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -187.0,
        -1987.0,
        706.9443969726562
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        749.8746948242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -405.909912109375,
        -1987.0,
        715.01025390625
      ],
      "bbox_max": [
        -275.0,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -405.909912109375,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -396.96240234375,
        -1972.0,
        780.0999145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -351.123291015625,
        -2090.888427734375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -1987.0,
        769.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -351.123291015625,
        -2090.888427734375,
        641.18310546875
      ],
      "bbox_max": [
        -216.42385864257812,
        -2076.626953125,
        662.3568725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -351.123291015625,
        -2090.888427734375,
        641.18310546875
      ],
      "bbox_max": [
        -216.42385864257812,
        -2077.739501953125,
        662.3568725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -351.123291015625,
        -2090.888427734375,
        652.572021484375
      ],
      "bbox_max": [
        -299.313232421875,
        -2077.739501953125,
        662.3568725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2090.888427734375,
        658.53662109375
      ],
      "bbox_max": [
        -346.3417663574219,
        -2086.4697265625,
        662.3568725585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -219.54531860351562,
        -2083.685302734375,
        641.18310546875
      ],
      "bbox_max": [
        -216.42385864257812,
        -2083.32763671875,
        641.6351318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -351.123291015625,
        -2089.29296875,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -1987.0,
        769.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -325.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -290.0,
        -1987.0,
        769.9810791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        768.5
      ],
      "bbox_max": [
        -320.0,
        -1987.0,
        769.925048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.653276264667511,
        0.27059444785118103,
        0.7071129083633423
      ],
      "plane_d": 26.99755859375,
      "bbox_min": [
        -351.123291015625,
        -2089.29296875,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        669.1162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -108.98371887207031,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -108.98371887207031,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        656.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -108.98371887207031,
        -2069.031982421875,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        656.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238802790641785,
        0.3826817274093628,
        0.0
      ],
      "plane_d": 690.8965454101562,
      "bbox_min": [
        -108.98356628417969,
        -2069.026611328125,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        656.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.2637939453125,
        -2069.026611328125,
        641.4745483398438
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        656.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060118317604065,
        0.6532711982727051,
        0.7071150541305542
      ],
      "plane_d": 849.6947021484375,
      "bbox_min": [
        -99.73937225341797,
        -2051.547119140625,
        654.2015380859375
      ],
      "bbox_max": [
        -97.63475036621094,
        -2049.502197265625,
        656.0745849609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749751210212708,
        0.6319916248321533,
        0.0
      ],
      "plane_d": 1220.0452880859375,
      "bbox_min": [
        -108.98356628417969,
        -2066.781005859375,
        643.1660766601562
      ],
      "bbox_max": [
        -105.278564453125,
        -2059.573974609375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        -0.4353194236755371,
        -0.0
      ],
      "plane_d": -997.17724609375,
      "bbox_min": [
        -108.98356628417969,
        -2066.781005859375,
        643.1660766601562
      ],
      "bbox_max": [
        -108.2637939453125,
        -2065.29248046875,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -100.88525390625,
        -2070.30615234375,
        639.9630126953125
      ],
      "bbox_max": [
        -100.58236694335938,
        -2070.1806640625,
        640.3057250976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2089.29296875,
        660.9608764648438
      ],
      "bbox_max": [
        -348.068359375,
        -2086.4697265625,
        669.1162109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -674.18994140625,
        -2385.0,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -538.70947265625,
        -2385.0,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2261.550537109375,
        793.8082275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2385.0,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2359.0,
        793.8082275390625
      ],
      "face_count": 11
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -210.5,
        -2385.0,
        780.0
      ],
      "bbox_max": [
        -195.5,
        -2371.5,
        793.4578247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        793.4578247070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.40613850951194763,
        0.9138116240501404
      ],
      "plane_d": -1680.195068359375,
      "bbox_min": [
        -207.0,
        -2382.0,
        780.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        792.2954711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -784.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        784.6668090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -199.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        784.6668090820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -199.0,
        -2373.0,
        784.0
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        792.2954711914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2359.0,
        793.8082275390625
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -638.0,
      "bbox_min": [
        -207.0,
        -2360.5,
        638.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        638.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        793.8082275390625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        638.0
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        793.8082275390625
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        -674.18994140625,
        -2263.22607421875,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -522.5567016601562,
        -2263.22607421875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        802.4439086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -522.5567016601562,
        -2263.22607421875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        757.572021484375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        623.3385009765625
      ],
      "bbox_max": [
        -80.69756317138672,
        -2160.9189453125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.89990234375,
        -2181.199951171875,
        677.7044067382812
      ],
      "bbox_max": [
        -80.69756317138672,
        -2171.7001953125,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.300048828125,
        -2181.199951171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.88549041748047,
        -2166.400146484375,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -139.03781127929688,
        -2167.778076171875,
        623.7440795898438
      ],
      "bbox_max": [
        -99.88549041748047,
        -2160.685302734375,
        657.9075927734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        623.7440795898438
      ],
      "bbox_max": [
        -105.28579711914062,
        -2160.685302734375,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6793980598449707,
        0.0004719383723568171,
        0.7337697148323059
      ],
      "plane_d": -549.4459838867188,
      "bbox_min": [
        -105.28976440429688,
        -2167.778076171875,
        651.6570434570312
      ],
      "bbox_max": [
        -99.88549041748047,
        -2166.15869140625,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28976440429688,
        -2166.400146484375,
        651.6570434570312
      ],
      "bbox_max": [
        -105.28959655761719,
        -2166.15869140625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -139.03756713867188,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28959655761719,
        -2166.15625,
        623.748779296875
      ],
      "bbox_max": [
        -105.2795181274414,
        -2151.646240234375,
        651.6456298828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -105.28974151611328,
        -2173.240966796875,
        606.0013427734375
      ],
      "bbox_max": [
        26.906936645507812,
        -2132.764404296875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -99.88970184326172,
        -2173.240966796875,
        677.7044067382812
      ],
      "bbox_max": [
        -80.69480895996094,
        -2164.060546875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        644.7900390625
      ],
      "bbox_max": [
        -99.877685546875,
        -2157.472412109375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -105.28974151611328,
        -2167.778076171875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.877685546875,
        -2159.682861328125,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -509.9615173339844,
        -2241.701416015625,
        673.6325073242188
      ],
      "bbox_max": [
        -443.2167053222656,
        -2204.337158203125,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5318214893341064,
        0.35797059535980225,
        0.7674782276153564
      ],
      "plane_d": 10.77642822265625,
      "bbox_min": [
        -509.9615173339844,
        -2241.701416015625,
        677.7113647460938
      ],
      "bbox_max": [
        -478.577392578125,
        -2232.79736328125,
        695.7612915039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -674.18994140625,
        -2228.631103515625,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -674.18994140625,
        -2228.631103515625,
        653.261962890625
      ],
      "bbox_max": [
        -256.0735168457031,
        -2063.758056640625,
        814.154052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36162224411964417,
        0.8005647659301758,
        0.4778340458869934
      ],
      "plane_d": 1267.4736328125,
      "bbox_min": [
        -390.7622985839844,
        -2198.047119140625,
        653.261962890625
      ],
      "bbox_max": [
        -256.0735168457031,
        -2119.075927734375,
        791.8031616210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -390.7622985839844,
        -2170.64208984375,
        653.261962890625
      ],
      "bbox_max": [
        -256.0735168457031,
        -2119.992431640625,
        779.5220336914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -323.1556091308594,
        -2131.402587890625,
        653.261962890625
      ],
      "bbox_max": [
        -314.135009765625,
        -2119.992431640625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -337.61962890625,
        -2144.902587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -318.5452880859375,
        -2131.402587890625,
        667.9999389648438
      ],
      "bbox_max": [
        -314.135009765625,
        -2125.823974609375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -355.803466796875,
        -2198.047119140625,
        654.7405395507812
      ],
      "bbox_max": [
        -260.9524230957031,
        -2119.075927734375,
        791.8031616210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -355.803466796875,
        -2198.047119140625,
        654.7405395507812
      ],
      "bbox_max": [
        -260.9524230957031,
        -2119.075927734375,
        791.8031616210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -355.803466796875,
        -2177.188720703125,
        654.7405395507812
      ],
      "bbox_max": [
        -260.9524230957031,
        -2119.075927734375,
        783.396728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -352.2374267578125,
        -2141.043212890625,
        654.7405395507812
      ],
      "bbox_max": [
        -317.15447998046875,
        -2119.075927734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -352.2374267578125,
        -2141.043212890625,
        667.9999389648438
      ],
      "bbox_max": [
        -338.6815490722656,
        -2134.35498046875,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -295.62738037109375,
        -2168.66357421875,
        705.107177734375
      ],
      "bbox_max": [
        -263.1219482421875,
        -2133.649658203125,
        780.6771850585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -294.1927490234375,
        -2165.86181640625,
        705.6873168945312
      ],
      "bbox_max": [
        -263.1219482421875,
        -2133.649658203125,
        779.7889404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062765598297119,
        0.638495922088623,
        0.7060579061508179
      ],
      "plane_d": 782.314453125,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        654.8593139648438
      ],
      "bbox_max": [
        -294.1368408203125,
        -2108.973876953125,
        705.8535766601562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        654.8593139648438
      ],
      "bbox_max": [
        -305.860595703125,
        -2109.672607421875,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -392.83599853515625,
        -2160.5009765625,
        654.8593139648438
      ],
      "bbox_max": [
        -318.24664306640625,
        -2109.672607421875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -331.3143310546875,
        -2124.538818359375,
        654.8593139648438
      ],
      "bbox_max": [
        -319.5613098144531,
        -2109.672607421875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -339.9801940917969,
        -2136.171142578125,
        667.9999389648438
      ],
      "bbox_max": [
        -318.24664306640625,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -322.97528076171875,
        -2126.201904296875,
        667.9999389648438
      ],
      "bbox_max": [
        -318.24664306640625,
        -2120.220458984375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -361.6016845703125,
        -2150.153564453125,
        660.4228515625
      ],
      "bbox_max": [
        -305.860595703125,
        -2113.156005859375,
        683.38916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -361.6016845703125,
        -2141.6953125,
        660.4228515625
      ],
      "bbox_max": [
        -320.0272216796875,
        -2113.156005859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -361.6016845703125,
        -2141.6953125,
        667.9999389648438
      ],
      "bbox_max": [
        -342.22503662109375,
        -2128.187255859375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -361.024169921875,
        -2150.153564453125,
        671.9999389648438
      ],
      "bbox_max": [
        -349.05096435546875,
        -2140.774169921875,
        680.5648193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2608638405799866,
        0.6026611328125,
        0.7541548013687134
      ],
      "plane_d": 689.7464599609375,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        656.077880859375
      ],
      "bbox_max": [
        -294.1368408203125,
        -2108.973876953125,
        705.8535766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -365.6939697265625,
        -2139.34716796875,
        656.077880859375
      ],
      "bbox_max": [
        -328.56005859375,
        -2109.166259765625,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -331.7146301269531,
        -2113.156494140625,
        656.077880859375
      ],
      "bbox_max": [
        -328.56005859375,
        -2109.166259765625,
        660.4232177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -363.35614013671875,
        -2148.298828125,
        656.1434936523438
      ],
      "bbox_max": [
        -294.1368408203125,
        -2108.973876953125,
        705.8535766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -305.860595703125,
        -2133.649658203125,
        677.8638305664062
      ],
      "bbox_max": [
        -294.1927490234375,
        -2121.553955078125,
        705.6873168945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2629581093788147,
        0.5350224375724792,
        0.8028724193572998
      ],
      "plane_d": 510.412353515625,
      "bbox_min": [
        -363.35614013671875,
        -2140.84326171875,
        656.1434936523438
      ],
      "bbox_max": [
        -294.1368408203125,
        -2108.973876953125,
        705.8535766601562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.31740716099739075,
        0.5046849250793457,
        0.8028361797332764
      ],
      "plane_d": 427.22772216796875,
      "bbox_min": [
        -363.35614013671875,
        -2140.774169921875,
        656.1434936523438
      ],
      "bbox_max": [
        -321.22222900390625,
        -2108.973876953125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -362.9183654785156,
        -2137.510009765625,
        656.1434936523438
      ],
      "bbox_max": [
        -321.22222900390625,
        -2108.973876953125,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -331.8667907714844,
        -2119.23095703125,
        656.1434936523438
      ],
      "bbox_max": [
        -323.757568359375,
        -2108.973876953125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -325.8543701171875,
        -2122.438232421875,
        667.9999389648438
      ],
      "bbox_max": [
        -321.22222900390625,
        -2116.578857421875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.35614013671875,
        -2140.774169921875,
        667.9999389648438
      ],
      "bbox_max": [
        -341.3185729980469,
        -2125.468505859375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -359.6785888671875,
        -2135.365478515625,
        667.9999389648438
      ],
      "bbox_max": [
        -343.9416809082031,
        -2125.468505859375,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -359.44732666015625,
        -2140.84326171875,
        671.9999389648438
      ],
      "bbox_max": [
        -341.3185729980469,
        -2130.181640625,
        676.5720825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -346.99072265625,
        -2134.037109375,
        664.2921142578125
      ],
      "bbox_max": [
        -294.1368408203125,
        -2112.57177734375,
        705.8535766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -346.99072265625,
        -2134.037109375,
        664.2921142578125
      ],
      "bbox_max": [
        -294.1368408203125,
        -2112.57177734375,
        705.8535766601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -346.99072265625,
        -2130.181640625,
        664.2921142578125
      ],
      "bbox_max": [
        -322.4369812011719,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -346.99072265625,
        -2126.967041015625,
        664.2921142578125
      ],
      "bbox_max": [
        -322.4369812011719,
        -2112.57177734375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -346.99072265625,
        -2126.967041015625,
        667.9999389648438
      ],
      "bbox_max": [
        -343.9416809082031,
        -2125.088623046875,
        667.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.43007606267929077,
        -0.6611618995666504,
        0.6147352457046509
      ],
      "plane_d": -1583.2156982421875,
      "bbox_min": [
        -674.18994140625,
        -2206.14794921875,
        656.16845703125
      ],
      "bbox_max": [
        -326.3236389160156,
        -2063.758056640625,
        814.154052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.37619760632514954,
        0.6228957772254944,
        0.6859126091003418
      ],
      "plane_d": 733.5289306640625,
      "bbox_min": [
        -471.8009338378906,
        -2206.14794921875,
        664.5693359375
      ],
      "bbox_max": [
        -362.9175109863281,
        -2137.509521484375,
        690.954345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3062775135040283,
        0.6384968161582947,
        0.7060566544532776
      ],
      "plane_d": 782.3170166015625,
      "bbox_min": [
        -408.99609375,
        -2180.35791015625,
        667.9998168945312
      ],
      "bbox_max": [
        -362.9175109863281,
        -2137.509521484375,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -395.2884216308594,
        -2157.3134765625,
        667.9999389648438
      ],
      "bbox_max": [
        -365.69598388671875,
        -2139.3486328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -396.04437255859375,
        -2153.543701171875,
        667.9999389648438
      ],
      "bbox_max": [
        -362.9175109863281,
        -2137.509521484375,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35807520151138306,
        0.6098346710205078,
        0.7070246934890747
      ],
      "plane_d": 697.973388671875,
      "bbox_min": [
        -435.5717468261719,
        -2180.35791015625,
        664.5693359375
      ],
      "bbox_max": [
        -392.9281921386719,
        -2148.8896484375,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39295151829719543,
        0.5888877511024475,
        0.7062578797340393
      ],
      "plane_d": 638.5640869140625,
      "bbox_min": [
        -435.5717468261719,
        -2180.35791015625,
        667.0779418945312
      ],
      "bbox_max": [
        -392.9281921386719,
        -2150.49951171875,
        686.3023681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -396.31500244140625,
        -2152.381591796875,
        667.9999389648438
      ],
      "bbox_max": [
        -392.9281921386719,
        -2150.49951171875,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -406.736328125,
        -2151.965576171875,
        656.16845703125
      ],
      "bbox_max": [
        -326.3236389160156,
        -2101.161865234375,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.26295778155326843,
        0.5350207686424255,
        0.8028736114501953
      ],
      "plane_d": 510.40802001953125,
      "bbox_min": [
        -333.36688232421875,
        -2112.57177734375,
        659.2074584960938
      ],
      "bbox_max": [
        -326.6051940917969,
        -2107.076416015625,
        664.2924194335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        667.9999389648438
      ],
      "bbox_max": [
        -326.3236389160156,
        -2103.345703125,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        667.9999389648438
      ],
      "bbox_max": [
        -326.3236389160156,
        -2110.559326171875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31740716099739075,
        0.5046849250793457,
        0.8028361797332764
      ],
      "plane_d": 427.22772216796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        668.0
      ],
      "bbox_max": [
        -359.682373046875,
        -2135.367919921875,
        668.1741943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.329372763633728,
        0.5637140274047852,
        0.757456362247467
      ],
      "plane_d": 579.381591796875,
      "bbox_min": [
        -363.46234130859375,
        -2137.91748046875,
        668.0
      ],
      "bbox_max": [
        -362.8336181640625,
        -2137.530517578125,
        668.1741943359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20432525873184204,
        0.34070679545402527,
        0.9176982641220093
      ],
      "plane_d": 163.24847412109375,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12511777877807617,
        0.5348695516586304,
        0.8356195688247681
      ],
      "plane_d": 631.0053100585938,
      "bbox_min": [
        -360.30859375,
        -2163.4716796875,
        606.1185302734375
      ],
      "bbox_max": [
        26.06302833557129,
        -2082.166748046875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2156.387451171875,
        622.1809692382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.76416015625,
        640.9058837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -100.88525390625,
        -2139.665283203125,
        622.1809692382812
      ],
      "bbox_max": [
        -90.278564453125,
        -2130.76416015625,
        629.543701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        622.4288940429688
      ],
      "bbox_max": [
        -92.20442199707031,
        -2136.069580078125,
        627.3795776367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.20442199707031,
        -2136.069580078125,
        622.4317016601562
      ],
      "bbox_max": [
        -91.48381805419922,
        -2130.76416015625,
        625.9423217773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        623.95703125
      ],
      "bbox_max": [
        -105.278564453125,
        -2140.8193359375,
        636.99072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        624.4100341796875
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        634.4107666015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.33603790402412415,
        0.4438745677471161,
        0.8306947946548462
      ],
      "plane_d": 465.50872802734375,
      "bbox_min": [
        -360.30859375,
        -2163.4716796875,
        622.4384765625
      ],
      "bbox_max": [
        -70.35123443603516,
        -2082.166748046875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.053122229874134064,
        0.48821669816970825,
        0.8711041808128357
      ],
      "plane_d": 461.5360107421875,
      "bbox_min": [
        -360.30859375,
        -2121.553955078125,
        653.5272827148438
      ],
      "bbox_max": [
        -260.7839660644531,
        -2083.035888671875,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30194443464279175,
        0.5054901242256165,
        0.8082754611968994
      ],
      "plane_d": 432.17095947265625,
      "bbox_min": [
        -359.3388977050781,
        -2121.553955078125,
        654.2220458984375
      ],
      "bbox_max": [
        -300.5304870605469,
        -2085.88525390625,
        677.8638305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -335.4600830078125,
        -2107.076171875,
        656.6759033203125
      ],
      "bbox_max": [
        -333.36700439453125,
        -2104.428955078125,
        659.2072143554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        0.0
      ],
      "plane_d": 1568.28173828125,
      "bbox_min": [
        -359.3388977050781,
        -2112.143798828125,
        656.7574462890625
      ],
      "bbox_max": [
        -329.3607177734375,
        -2089.29296875,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -359.3388977050781,
        -2112.143798828125,
        658.4334716796875
      ],
      "bbox_max": [
        -329.3607177734375,
        -2089.29296875,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -667.9999389648438,
      "bbox_min": [
        -359.3388977050781,
        -2101.909423828125,
        667.9999389648438
      ],
      "bbox_max": [
        -357.05364990234375,
        -2098.995361328125,
        667.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -671.9999389648438,
      "bbox_min": [
        -360.30859375,
        -2108.194580078125,
        662.3568725585938
      ],
      "bbox_max": [
        -332.4829406738281,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7844587564468384,
        0.620181143283844,
        -0.0
      ],
      "plane_d": 1568.2816162109375,
      "bbox_min": [
        -351.123291015625,
        -2108.194580078125,
        662.3568725585938
      ],
      "bbox_max": [
        -332.4829406738281,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6786976456642151,
        0.7344177961349487,
        -0.0
      ],
      "plane_d": 1770.64697265625,
      "bbox_min": [
        -351.123291015625,
        -2091.495361328125,
        662.3568725585938
      ],
      "bbox_max": [
        -345.68505859375,
        -2086.4697265625,
        671.9999389648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -218.78538513183594,
        -2163.4716796875,
        622.4384765625
      ],
      "bbox_max": [
        -70.35123443603516,
        -2082.166748046875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -109.34033203125,
        -2157.47216796875,
        628.6243896484375
      ],
      "bbox_max": [
        -98.66931915283203,
        -2138.74755859375,
        644.7898559570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -100.88525390625,
        -2139.665283203125,
        628.6243896484375
      ],
      "bbox_max": [
        -98.66931915283203,
        -2138.74755859375,
        629.813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        631.2246704101562
      ],
      "bbox_max": [
        -105.278564453125,
        -2140.8193359375,
        639.105712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        631.2246704101562
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        636.025634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -109.34033203125,
        -2158.017822265625,
        622.4384765625
      ],
      "bbox_max": [
        -90.278564453125,
        -2127.946044921875,
        646.7431030273438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -92.2044448852539,
        -2136.06982421875,
        625.143310546875
      ],
      "bbox_max": [
        -90.278564453125,
        -2135.27197265625,
        635.6824340820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -109.34033203125,
        -2158.017822265625,
        625.9423217773438
      ],
      "bbox_max": [
        -92.20443725585938,
        -2136.069580078125,
        646.7431030273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2150.27197265625,
        633.6602172851562
      ],
      "bbox_max": [
        -105.278564453125,
        -2142.635498046875,
        643.8660888671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        633.6602172851562
      ],
      "bbox_max": [
        -108.05611419677734,
        -2142.635498046875,
        642.92138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -108.05611419677734,
        -2142.635498046875,
        632.042724609375
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        641.6494750976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8734391927719116,
        -0.19791147112846375,
        -0.44489893317222595
      ],
      "plane_d": -14.895965576171875,
      "bbox_min": [
        121.512451171875,
        -2113.157470703125,
        587.62353515625
      ],
      "bbox_max": [
        162.44873046875,
        -2044.892578125,
        637.62353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0863649919629097,
        0.9781539440155029,
        0.18909214437007904
      ],
      "plane_d": 2005.18701171875,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        126.47466278076172,
        -2015.640380859375,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -601.5318603515625,
        -2187.80908203125,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2021.0675048828125,
        817.3342895507812
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.08373019099235535,
        0.9710349440574646,
        0.22378645837306976
      ],
      "plane_d": 1966.399658203125,
      "bbox_min": [
        -163.181640625,
        -2164.698486328125,
        657.4826049804688
      ],
      "bbox_max": [
        -138.9290771484375,
        -2163.4716796875,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9607705473899841,
        -0.2770630121231079,
        -0.012491104193031788
      ],
      "plane_d": -484.89111328125,
      "bbox_min": [
        -601.5318603515625,
        -2166.092529296875,
        623.1181030273438
      ],
      "bbox_max": [
        -64.5244140625,
        -2021.0675048828125,
        817.3342895507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -290.1921691894531,
        -2059.573974609375,
        657.69921875
      ],
      "bbox_max": [
        -80.68840026855469,
        -2022.8271484375,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532700657844543,
        0.2706069350242615,
        0.7071138620376587
      ],
      "plane_d": 144.97592163085938,
      "bbox_min": [
        -80.69474792480469,
        -2059.573974609375,
        657.69921875
      ],
      "bbox_max": [
        -80.68840026855469,
        -2059.564208984375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -290.1921691894531,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -258.4635009765625,
        -2031.807861328125,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -290.1921691894531,
        -2032.0,
        769.1334838867188
      ],
      "bbox_max": [
        -290.0,
        -2031.807861328125,
        769.5896606445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14177995920181274,
        -0.0205705426633358,
        0.989684522151947
      ],
      "plane_d": -646.7444458007812,
      "bbox_min": [
        -601.5318603515625,
        -2164.591064453125,
        623.1181030273438
      ],
      "bbox_max": [
        -80.690673828125,
        -2045.0108642578125,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -601.5318603515625,
        -2164.591064453125,
        623.1181030273438
      ],
      "bbox_max": [
        -80.690673828125,
        -2045.0108642578125,
        817.3342895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16232021152973175,
        0.6113415360450745,
        0.7745409607887268
      ],
      "plane_d": 836.6258544921875,
      "bbox_min": [
        -163.181640625,
        -2164.591064453125,
        623.1181030273438
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        661.6588745117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -109.34033203125,
        -2148.763427734375,
        623.1181030273438
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        -0.9238834381103516,
        -0.0
      ],
      "plane_d": -1951.2117919921875,
      "bbox_min": [
        -107.14860534667969,
        -2075.28662109375,
        627.2299194335938
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2705896496772766,
        -0.6532796025276184,
        0.7071117758750916
      ],
      "plane_d": -1841.240234375,
      "bbox_min": [
        -106.26387786865234,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -106.26387786865234,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532886624336243,
        -0.2705933749675751,
        0.7071020007133484
      ],
      "plane_d": -1087.6129150390625,
      "bbox_min": [
        -106.26387786865234,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -106.26387786865234,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        -0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": -1098.954833984375,
      "bbox_min": [
        -105.54733276367188,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -80.690673828125,
        -2059.573974609375,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        630.4844970703125
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2074.573974609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2071.60009765625,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18038633465766907,
        -0.9835958480834961,
        0.0
      ],
      "plane_d": -2054.41943359375,
      "bbox_min": [
        -107.14860534667969,
        -2075.28662109375,
        627.2299194335938
      ],
      "bbox_max": [
        -90.27850341796875,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        -0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": -1186.8843994140625,
      "bbox_min": [
        -107.14860534667969,
        -2070.1806640625,
        644.3267211914062
      ],
      "bbox_max": [
        -100.88525390625,
        -2067.95263671875,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -92.20443725585938,
        -2075.28662109375,
        627.2299194335938
      ],
      "bbox_max": [
        -90.27850341796875,
        -2073.776123046875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.20443725585938,
        -2075.28662109375,
        651.2399291992188
      ],
      "bbox_max": [
        -90.27850341796875,
        -2073.776123046875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2081.89990234375,
      "bbox_min": [
        -109.34033203125,
        -2148.763427734375,
        623.1181030273438
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        -0.1345849335193634,
        0.0
      ],
      "plane_d": -370.464599609375,
      "bbox_min": [
        -91.9992904663086,
        -2081.89990234375,
        623.3673095703125
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -91.9992904663086,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -88.2706298828125,
        -2073.7421875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9126664400100708,
        0.4087052345275879
      ],
      "plane_d": -2160.234130859375,
      "bbox_min": [
        -91.385986328125,
        -2081.89990234375,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2079.802001953125,
      "bbox_min": [
        -91.385986328125,
        -2079.802001953125,
        641.2166748046875
      ],
      "bbox_max": [
        -89.0361328125,
        -2079.802001953125,
        645.4983520507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": 238.0029296875,
      "bbox_min": [
        -109.34033203125,
        -2148.763427734375,
        640.7797241210938
      ],
      "bbox_max": [
        -104.07628631591797,
        -2140.25048828125,
        650.1549682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -109.34033203125,
        -2148.763427734375,
        640.7797241210938
      ],
      "bbox_max": [
        -104.07628631591797,
        -2140.25048828125,
        650.1549682617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9002761244773865,
        0.4353194236755371,
        0.0
      ],
      "plane_d": 835.450439453125,
      "bbox_min": [
        -109.34033203125,
        -2145.291259765625,
        640.7797241210938
      ],
      "bbox_max": [
        -107.177978515625,
        -2140.8193359375,
        644.2874145507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -677.7044067382812,
      "bbox_min": [
        -106.57212829589844,
        -2166.092529296875,
        628.041259765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.56591796875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11984175443649292,
        -0.9927930235862732,
        -0.0
      ],
      "plane_d": -2064.80908203125,
      "bbox_min": [
        -106.57212829589844,
        -2166.092529296875,
        628.041259765625
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.56591796875,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4983988106250763,
        -0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -937.260986328125,
      "bbox_min": [
        -83.65042114257812,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.56591796875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -83.65042114257812,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2069.01708984375,
        655.2236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48884037137031555,
        -0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -959.4097900390625,
      "bbox_min": [
        -83.44608306884766,
        -2071.8154296875,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2059.56591796875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6532716155052185,
        -0.270601361989975,
        0.7071146368980408
      ],
      "plane_d": -969.6830444335938,
      "bbox_min": [
        -83.44608306884766,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -76.02014923095703,
        -2059.56591796875,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -83.44608306884766,
        -2070.1806640625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2067.00732421875,
        656.8504028320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.999999463558197,
        0.0010735620744526386,
        0.0
      ],
      "plane_d": -97.55819702148438,
      "bbox_min": [
        -106.57212829589844,
        -2166.092529296875,
        631.8021850585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2069.70068359375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826817274093628,
        -0.9238802790641785,
        0.0
      ],
      "plane_d": -1882.1099853515625,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        631.8021850585938
      ],
      "bbox_max": [
        -64.5244140625,
        -2069.70068359375,
        677.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2705991268157959,
        -0.6532875299453735,
        0.7071007490158081
      ],
      "plane_d": -1792.391845703125,
      "bbox_min": [
        -84.37628936767578,
        -2072.129150390625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2069.70068359375,
        654.6702270507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826916813850403,
        0.9238762259483337,
        0.0
      ],
      "plane_d": 1943.1781005859375,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        632.4207763671875
      ],
      "bbox_max": [
        -64.5244140625,
        -2127.946044921875,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9238762259483337,
        0.3826916813850403,
        0.0
      ],
      "plane_d": 730.626708984375,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2137.977783203125,
        677.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4983988106250763,
        0.20644919574260712,
        0.8420079350471497
      ],
      "plane_d": -68.14163208007812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2137.977783203125,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2137.977783203125,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -88.83558654785156,
        -2141.464599609375,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2137.977783203125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2010255753993988,
        -0.4735967814922333,
        0.8574933409690857
      ],
      "plane_d": -1563.80419921875,
      "bbox_min": [
        -96.65662384033203,
        -2148.014892578125,
        656.5999755859375
      ],
      "bbox_max": [
        -85.5081787109375,
        -2140.086181640625,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -96.65662384033203,
        -2145.713623046875,
        656.5999755859375
      ],
      "bbox_max": [
        -85.5081787109375,
        -2140.086181640625,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -95.74359130859375,
        -2145.476806640625,
        656.5999755859375
      ],
      "bbox_max": [
        -85.5081787109375,
        -2140.086181640625,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        0.9205079078674316,
        0.0
      ],
      "plane_d": 1937.51904296875,
      "bbox_min": [
        -95.74359130859375,
        -2145.476806640625,
        656.5999755859375
      ],
      "bbox_max": [
        -93.44232940673828,
        -2144.5,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3907240033149719,
        0.9205079078674316,
        0.0
      ],
      "plane_d": 1937.51904296875,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        659.7044067382812
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33503803610801697,
        0.7893171906471252,
        0.5145173072814941
      ],
      "plane_d": 1321.4937744140625,
      "bbox_min": [
        -95.74359130859375,
        -2145.713623046875,
        660.5999755859375
      ],
      "bbox_max": [
        -93.34178161621094,
        -2144.5,
        661.0287475585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -99.86669921875,
        -2150.65478515625,
        659.7044067382812
      ],
      "bbox_max": [
        -96.29560089111328,
        -2143.32568359375,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.48884037137031555,
        0.2158251702785492,
        0.8452541828155518
      ],
      "plane_d": -50.819091796875,
      "bbox_min": [
        -90.95934295654297,
        -2150.65478515625,
        644.2874145507812
      ],
      "bbox_max": [
        -64.5244140625,
        -2138.030517578125,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -90.95934295654297,
        -2150.65478515625,
        652.7044067382812
      ],
      "bbox_max": [
        -79.672119140625,
        -2139.665283203125,
        659.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -656.5999755859375,
      "bbox_min": [
        -84.4102783203125,
        -2150.65478515625,
        656.5999755859375
      ],
      "bbox_max": [
        -81.60009765625,
        -2144.114501953125,
        656.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -659.7044067382812,
      "bbox_min": [
        -90.95934295654297,
        -2144.19921875,
        659.7044067382812
      ],
      "bbox_max": [
        -83.4990234375,
        -2140.683837890625,
        659.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86669921875,
        -2150.27197265625,
        655.5597534179688
      ],
      "bbox_max": [
        -97.058349609375,
        -2143.4921875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -99.86067199707031,
        -2144.653076171875,
        632.4207763671875
      ],
      "bbox_max": [
        -83.74588775634766,
        -2127.946044921875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.270608514547348,
        0.6532667875289917,
        0.707116425037384
      ],
      "plane_d": 957.794189453125,
      "bbox_min": [
        -99.86067199707031,
        -2144.653076171875,
        635.6824951171875
      ],
      "bbox_max": [
        -83.74588775634766,
        -2134.52294921875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909016489982605,
        0.13458801805973053,
        0.0
      ],
      "plane_d": 196.12387084960938,
      "bbox_min": [
        -99.86067199707031,
        -2144.653076171875,
        635.6824951171875
      ],
      "bbox_max": [
        -88.0,
        -2134.52294921875,
        657.7044067382812
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -651.2399291992188,
      "bbox_min": [
        -92.5,
        -2138.245849609375,
        651.2399291992188
      ],
      "bbox_max": [
        -88.0,
        -2134.52294921875,
        651.2399291992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -99.86067199707031,
        -2144.653076171875,
        654.0486450195312
      ],
      "bbox_max": [
        -97.058349609375,
        -2140.694091796875,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9909021258354187,
        0.1345849335193634,
        0.0
      ],
      "plane_d": 196.11721801757812,
      "bbox_min": [
        -92.2044448852539,
        -2136.069580078125,
        632.4207763671875
      ],
      "bbox_max": [
        -88.47034454345703,
        -2127.946044921875,
        651.2399291992188
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.912666380405426,
        0.4087052345275879
      ],
      "plane_d": 1681.950927734375,
      "bbox_min": [
        -91.385986328125,
        -2130.0439453125,
        636.5319213867188
      ],
      "bbox_max": [
        -89.0361328125,
        -2127.946044921875,
        641.2166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6532719135284424,
        0.2706008851528168,
        0.7071145176887512
      ],
      "plane_d": 51.553009033203125,
      "bbox_min": [
        -106.57212829589844,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38267427682876587,
        0.9238834381103516,
        0.0
      ],
      "plane_d": 1938.195068359375,
      "bbox_min": [
        -106.57212829589844,
        -2160.506591796875,
        638.5621948242188
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6786047220230103,
        0.0007285246392711997,
        0.7345033884048462
      ],
      "plane_d": -549.2896118164062,
      "bbox_min": [
        -106.57212829589844,
        -2160.506591796875,
        643.5652465820312
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        657.7044067382812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7667246460914612,
        0.3175787925720215,
        0.5579220652580261
      ],
      "plane_d": 238.0029296875,
      "bbox_min": [
        -106.57212829589844,
        -2159.682861328125,
        643.5652465820312
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999997615814209,
        0.0006946580833755434,
        0.0
      ],
      "plane_d": -103.78483581542969,
      "bbox_min": [
        -106.57212829589844,
        -2159.682861328125,
        643.5652465820312
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27060675621032715,
        0.6532860994338989,
        0.707099199295044
      ],
      "plane_d": 908.98681640625,
      "bbox_min": [
        -100.88525390625,
        -2140.694091796875,
        652.7044067382812
      ],
      "bbox_max": [
        -99.8548583984375,
        -2139.238525390625,
        654.0486450195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7749752402305603,
        -0.6319916248321533,
        0.0
      ],
      "plane_d": -1440.5421142578125,
      "bbox_min": [
        -106.57212829589844,
        -2150.27197265625,
        643.5652465820312
      ],
      "bbox_max": [
        -105.278564453125,
        -2148.685791015625,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7674137353897095,
        0.37107518315315247,
        0.5228569507598877
      ],
      "plane_d": 375.2848815917969,
      "bbox_min": [
        -104.31387329101562,
        -2141.08544921875,
        648.4361572265625
      ],
      "bbox_max": [
        -100.88525390625,
        -2139.665283203125,
        652.7044067382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8509166240692139,
        0.5241855978965759,
        0.03420881927013397
      ],
      "plane_d": 1648.3133544921875,
      "bbox_min": [
        -919.112548828125,
        -3527.64501953125,
        711.775390625
      ],
      "bbox_max": [
        196.0666046142578,
        -1865.0,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8467844724655151,
        0.531133234500885,
        0.029217718169093132
      ],
      "plane_d": 1677.308349609375,
      "bbox_min": [
        -919.112548828125,
        -3463.04833984375,
        850.4774169921875
      ],
      "bbox_max": [
        161.8573760986328,
        -2148.940673828125,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9373313784599304,
        0.34786927700042725,
        0.019921978935599327
      ],
      "plane_d": 1415.8299560546875,
      "bbox_min": [
        -919.112548828125,
        -3178.84619140625,
        863.9058837890625
      ],
      "bbox_max": [
        -40.82177734375,
        -2148.940673828125,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9347556829452515,
        0.3548664450645447,
        0.017366504296660423
      ],
      "plane_d": 1435.5382080078125,
      "bbox_min": [
        -919.112548828125,
        -2813.591064453125,
        863.9058837890625
      ],
      "bbox_max": [
        -498.223876953125,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8313450217247009,
        0.5555300712585449,
        0.01586890034377575
      ],
      "plane_d": 1886.90283203125,
      "bbox_min": [
        -919.112548828125,
        -2813.591064453125,
        863.9058837890625
      ],
      "bbox_max": [
        -498.223876953125,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8306585550308228,
        0.5565486550331116,
        0.01612250879406929
      ],
      "plane_d": 1888.747802734375,
      "bbox_min": [
        -919.112548828125,
        -2813.591064453125,
        864.1474609375
      ],
      "bbox_max": [
        -498.223876953125,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.637331485748291,
        0.7695214152336121,
        0.04056220501661301
      ],
      "plane_d": 2238.30517578125,
      "bbox_min": [
        -919.112548828125,
        -2813.591064453125,
        864.1893920898438
      ],
      "bbox_max": [
        -498.223876953125,
        -2148.940673828125,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8067802786827087,
        0.5906376242637634,
        0.01590188778936863
      ],
      "plane_d": 1954.7420654296875,
      "bbox_min": [
        -703.939208984375,
        -2813.591064453125,
        865.4462890625
      ],
      "bbox_max": [
        -498.223876953125,
        -2371.302734375,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9314306974411011,
        0.3556700348854065,
        0.0770426094532013
      ],
      "plane_d": 1355.5810546875,
      "bbox_min": [
        -698.2745361328125,
        -2813.591064453125,
        1258.9176025390625
      ],
      "bbox_max": [
        -498.223876953125,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9321791529655457,
        0.32900404930114746,
        0.1509908139705658
      ],
      "plane_d": 1178.5645751953125,
      "bbox_min": [
        -698.2745361328125,
        -2813.591064453125,
        1258.9176025390625
      ],
      "bbox_max": [
        -498.223876953125,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8198854923248291,
        0.5702467560768127,
        0.05105101317167282
      ],
      "plane_d": 1870.3758544921875,
      "bbox_min": [
        -698.2745361328125,
        -2549.36376953125,
        1258.9176025390625
      ],
      "bbox_max": [
        -594.252197265625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8297061324119568,
        0.5531379580497742,
        0.07500854879617691
      ],
      "plane_d": 1800.5321044921875,
      "bbox_min": [
        -697.61474609375,
        -2549.36376953125,
        1341.0208740234375
      ],
      "bbox_max": [
        -594.252197265625,
        -2409.47900390625,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -698.2745361328125,
        -2409.47900390625,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2407.66796875,
        1480.5965576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -919.112548828125,
        -2408.3671875,
        864.1893920898438
      ],
      "bbox_max": [
        -685.0712890625,
        -2148.940673828125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -919.112548828125,
        -2264.956787109375,
        864.4647827148438
      ],
      "bbox_max": [
        -781.6624145507812,
        -2148.940673828125,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.32164719700813293,
        0.9467006325721741,
        0.01735524646937847
      ],
      "plane_d": 2314.876953125,
      "bbox_min": [
        -919.112548828125,
        -2253.35400390625,
        864.4647827148438
      ],
      "bbox_max": [
        -783.6491088867188,
        -2148.940673828125,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -860.804443359375,
        -2253.35400390625,
        864.4647827148438
      ],
      "bbox_max": [
        -783.6491088867188,
        -2170.466796875,
        1131.8846435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -808.619384765625,
        -2248.078369140625,
        864.4647827148438
      ],
      "bbox_max": [
        -787.02587890625,
        -2222.050537109375,
        929.3057861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -786.48876953125,
        -2408.3671875,
        864.8950805664062
      ],
      "bbox_max": [
        -685.0712890625,
        -2256.458740234375,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -767.986572265625,
        -2408.3671875,
        865.7200927734375
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -761.962646484375,
        -2408.3671875,
        865.7200927734375
      ],
      "bbox_max": [
        -685.0712890625,
        -2310.554931640625,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1178.7674560546875
      ],
      "bbox_max": [
        -685.0712890625,
        -2333.14013671875,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.838594913482666,
        0.5422794818878174,
        0.05188118666410446
      ],
      "plane_d": 1814.8121337890625,
      "bbox_min": [
        -738.92578125,
        -2408.3671875,
        1258.9176025390625
      ],
      "bbox_max": [
        -685.0712890625,
        -2339.8720703125,
        1479.6412353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7176309823989868,
        0.6963256597518921,
        0.011679554358124733
      ],
      "plane_d": 2144.92041015625,
      "bbox_min": [
        -761.962646484375,
        -2328.31640625,
        866.7424926757812
      ],
      "bbox_max": [
        -743.80419921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -761.962646484375,
        -2314.733154296875,
        866.9813842773438
      ],
      "bbox_max": [
        -756.9921875,
        -2310.554931640625,
        1051.602294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -786.48876953125,
        -2312.703125,
        864.8950805664062
      ],
      "bbox_max": [
        -758.3310546875,
        -2261.742919921875,
        1371.9813232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -773.9362182617188,
        -2280.178466796875,
        864.8950805664062
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4227905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -773.9362182617188,
        -2280.178466796875,
        865.194580078125
      ],
      "bbox_max": [
        -768.0648193359375,
        -2268.5849609375,
        910.4227905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -792.2825317382812,
        -2273.9755859375,
        864.1893920898438
      ],
      "bbox_max": [
        -770.2017211914062,
        -2239.863525390625,
        1025.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -777.7197875976562,
        -2273.9755859375,
        864.3221435546875
      ],
      "bbox_max": [
        -770.2017211914062,
        -2262.62646484375,
        1025.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.706787109375,
        -2273.9755859375,
        864.7988891601562
      ],
      "bbox_max": [
        -770.2017211914062,
        -2263.27197265625,
        944.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.706787109375,
        -2271.985595703125,
        903.440185546875
      ],
      "bbox_max": [
        -771.7662963867188,
        -2263.27197265625,
        944.060791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -777.7197875976562,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.62646484375,
        1025.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -777.7197875976562,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2262.62646484375,
        1025.492919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.0944213867188,
        -2272.616455078125,
        902.14453125
      ],
      "bbox_max": [
        -771.3636474609375,
        -2264.15380859375,
        942.9473266601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -787.02587890625,
        -2259.135009765625,
        929.3057861328125
      ],
      "bbox_max": [
        -779.9500732421875,
        -2248.078369140625,
        1019.874267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -787.02587890625,
        -2256.06494140625,
        929.3057861328125
      ],
      "bbox_max": [
        -781.0300903320312,
        -2248.078369140625,
        974.8685302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -779.9500732421875,
        -2407.66796875,
        1019.874267578125
      ],
      "bbox_max": [
        -685.0712890625,
        -2259.135009765625,
        1258.9176025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.7513427734375,
        -2333.14013671875,
        1156.9886474609375
      ],
      "bbox_max": [
        -733.1165161132812,
        -2332.134033203125,
        1178.7674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.7513427734375,
        -2332.5322265625,
        1156.9886474609375
      ],
      "bbox_max": [
        -733.1771850585938,
        -2332.134033203125,
        1165.042236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -783.2196044921875,
        -2266.23828125,
        864.1474609375
      ],
      "bbox_max": [
        -772.1714477539062,
        -2249.745361328125,
        1038.20263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9640350341796875,
        0.26420632004737854,
        0.028835227712988853
      ],
      "plane_d": 1318.2318115234375,
      "bbox_min": [
        -778.34228515625,
        -2266.23828125,
        864.2648315429688
      ],
      "bbox_max": [
        -772.1714477539062,
        -2261.486328125,
        1036.420654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8598021268844604,
        -0.49546441435813904,
        0.12351233512163162
      ],
      "plane_d": -571.0194702148438,
      "bbox_min": [
        -775.980712890625,
        -2264.4326171875,
        932.4190063476562
      ],
      "bbox_max": [
        -774.7032470703125,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.980712890625,
        -2264.15380859375,
        942.9473266601562
      ],
      "bbox_max": [
        -775.0944213867188,
        -2262.449951171875,
        949.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.34228515625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2261.486328125,
        1036.420654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -775.5611572265625,
        -2264.304931640625,
        942.7564086914062
      ],
      "bbox_max": [
        -774.9893798828125,
        -2263.055419921875,
        948.4863891601562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -781.3290405273438,
        -2261.6484375,
        946.2813720703125
      ],
      "bbox_max": [
        -778.0450439453125,
        -2254.945068359375,
        1038.20263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.4437866210938,
        -2261.6484375,
        1023.680419921875
      ],
      "bbox_max": [
        -778.0450439453125,
        -2261.3818359375,
        1038.20263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.737096905708313,
        0.6752943992614746,
        0.0257981326431036
      ],
      "plane_d": 2074.254638671875,
      "bbox_min": [
        -781.840576171875,
        -2355.997802734375,
        863.9058837890625
      ],
      "bbox_max": [
        -718.0741577148438,
        -2251.2490234375,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.055419921875,
        948.4863891601562
      ],
      "bbox_max": [
        -775.5611572265625,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -778.0450439453125,
        -2355.997802734375,
        948.3524169921875
      ],
      "bbox_max": [
        -718.0741577148438,
        -2260.681396484375,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9516843557357788,
        0.3062683343887329,
        0.022283848375082016
      ],
      "plane_d": 1410.0218505859375,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        964.4517822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7855923175811768,
        0.6162072420120239,
        -0.05597550794482231
      ],
      "plane_d": 2056.8779296875,
      "bbox_min": [
        -776.570068359375,
        -2263.15966796875,
        948.3524169921875
      ],
      "bbox_max": [
        -775.4889526367188,
        -2260.681396484375,
        960.462158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8428515195846558,
        0.5381461977958679,
        -0.00015169712423812598
      ],
      "plane_d": 1873.28173828125,
      "bbox_min": [
        -733.18798828125,
        -2355.997802734375,
        1154.580322265625
      ],
      "bbox_max": [
        -718.0741577148438,
        -2332.494384765625,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8209625482559204,
        0.5699431300163269,
        0.03442801535129547
      ],
      "plane_d": 1891.3095703125,
      "bbox_min": [
        -733.18798828125,
        -2355.997802734375,
        1154.580322265625
      ],
      "bbox_max": [
        -718.07421875,
        -2332.494384765625,
        1190.5146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5915436148643494,
        0.8062112331390381,
        -0.0099867582321167
      ],
      "plane_d": 2325.763427734375,
      "bbox_min": [
        -733.18798828125,
        -2332.730224609375,
        1154.580322265625
      ],
      "bbox_max": [
        -732.9429321289062,
        -2332.494384765625,
        1164.02734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6053767204284668,
        0.7951329946517944,
        0.035813964903354645
      ],
      "plane_d": 2256.9541015625,
      "bbox_min": [
        -733.18798828125,
        -2332.730224609375,
        1158.943359375
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494384765625,
        1164.02734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.514473021030426,
        0.8572710752487183,
        0.020095380023121834
      ],
      "plane_d": 2353.490478515625,
      "bbox_min": [
        -733.18798828125,
        -2332.605712890625,
        1158.943359375
      ],
      "bbox_max": [
        -733.01513671875,
        -2332.494384765625,
        1160.837646484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9495837092399597,
        0.31242266297340393,
        0.026133330538868904
      ],
      "plane_d": 1418.6063232421875,
      "bbox_min": [
        -779.7763061523438,
        -2261.486328125,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7429448366165161,
        0.6688910722732544,
        0.024856239557266235
      ],
      "plane_d": 2065.224853515625,
      "bbox_min": [
        -779.7763061523438,
        -2261.3818359375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        1027.882080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7410170435905457,
        0.6710995435714722,
        0.02278570458292961
      ],
      "plane_d": 2070.708984375,
      "bbox_min": [
        -779.7763061523438,
        -2260.681396484375,
        950.9082641601562
      ],
      "bbox_max": [
        -776.570068359375,
        -2256.816650390625,
        966.5499267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5382782816886902,
        0.8385637402534485,
        0.08406741917133331
      ],
      "plane_d": 2561.375,
      "bbox_min": [
        -262.4169921875,
        -3178.84619140625,
        1428.406005859375
      ],
      "bbox_max": [
        -40.82177734375,
        -3031.18994140625,
        1577.280517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.440481036901474,
        -0.8977619409561157,
        0.0
      ],
      "plane_d": -1797.645263671875,
      "bbox_min": [
        -601.920166015625,
        -2373.0,
        711.775390625
      ],
      "bbox_max": [
        138.8248291015625,
        -1865.0,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9607705473899841,
        -0.2770630121231079,
        -0.012491104193031788
      ],
      "plane_d": -484.89111328125,
      "bbox_min": [
        -150.0,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -150.0,
        -1977.1312255859375,
        822.0950927734375
      ],
      "bbox_max": [
        -51.42585754394531,
        -1865.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -150.0,
        -1943.7169189453125,
        822.0950927734375
      ],
      "bbox_max": [
        -119.52893829345703,
        -1865.0,
        1010.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.45699819922447205,
        -0.8811807036399841,
        -0.1211327537894249
      ],
      "plane_d": -1669.15185546875,
      "bbox_min": [
        -51.42585754394531,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -51.42585754394531,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -1977.1312255859375,
        797.1386108398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        126.47466278076172,
        -2067.07470703125,
        711.775390625
      ],
      "bbox_max": [
        131.89161682128906,
        -2057.659423828125,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9814715385437012,
        0.1916080117225647
      ],
      "plane_d": -2147.4345703125,
      "bbox_min": [
        -601.920166015625,
        -2373.0,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1894.5,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3700557053089142,
        -0.9290096163749695,
        0.0
      ],
      "plane_d": -1855.8043212890625,
      "bbox_min": [
        -601.920166015625,
        -2043.592041015625,
        725.9998168945312
      ],
      "bbox_max": [
        -17.90656280517578,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9607705473899841,
        -0.2770630121231079,
        -0.012491104193031788
      ],
      "plane_d": -484.89111328125,
      "bbox_min": [
        -180.0,
        -1977.1312255859375,
        752.2013549804688
      ],
      "bbox_max": [
        -51.42585754394531,
        -1920.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7947517037391663,
        -0.5720362663269043,
        0.20284056663513184
      ],
      "plane_d": -1390.929443359375,
      "bbox_min": [
        -180.0,
        -1977.1312255859375,
        752.2013549804688
      ],
      "bbox_max": [
        -51.42585754394531,
        -1920.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9655746221542358,
        0.1437494307756424,
        -0.21679900586605072
      ],
      "plane_d": 342.2235107421875,
      "bbox_min": [
        -171.66697692871094,
        -1975.87353515625,
        752.2013549804688
      ],
      "bbox_max": [
        -54.50433349609375,
        -1920.0,
        877.8367919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -61.8051872253418,
        -1975.87353515625,
        752.2013549804688
      ],
      "bbox_max": [
        -54.50433349609375,
        -1972.1915283203125,
        809.710205078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -171.66697692871094,
        -1924.0889892578125,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -171.66697692871094,
        -1922.31591796875,
        770.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -180.0,
        -1929.899169921875,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1929.899169921875,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1922.31591796875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9607705473899841,
        -0.2770630121231079,
        -0.012491104193031788
      ],
      "plane_d": -484.89111328125,
      "bbox_min": [
        -601.920166015625,
        -2043.592041015625,
        725.9998168945312
      ],
      "bbox_max": [
        -17.90656280517578,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -118.56554412841797,
        -2016.555419921875,
        730.3460083007812
      ],
      "bbox_max": [
        -54.583187103271484,
        -1950.38720703125,
        813.3817138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -87.22331237792969,
        -1980.856689453125,
        730.3460083007812
      ],
      "bbox_max": [
        -55.010292053222656,
        -1971.048828125,
        798.2388305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -63.7107048034668,
        -1977.9193115234375,
        740.4506225585938
      ],
      "bbox_max": [
        -55.97739028930664,
        -1972.9967041015625,
        798.2388305664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -64.19151306152344,
        -1979.161376953125,
        737.4856567382812
      ],
      "bbox_max": [
        -57.608158111572266,
        -1976.0811767578125,
        786.1773681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9888145923614502,
        -0.07494720071554184,
        -0.1289515197277069
      ],
      "plane_d": 10.24078369140625,
      "bbox_min": [
        -67.27250671386719,
        -2016.555419921875,
        731.603759765625
      ],
      "bbox_max": [
        -54.583187103271484,
        -1975.318115234375,
        809.2525024414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -156.7864990234375,
        -1964.927001953125,
        735.3753662109375
      ],
      "bbox_max": [
        -103.21553802490234,
        -1940.0272216796875,
        819.6739501953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1926385760307312,
        -0.9812697768211365,
        0.0
      ],
      "plane_d": -1914.5927734375,
      "bbox_min": [
        -601.920166015625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -601.920166015625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5634797811508179,
        -0.8261274099349976,
        -0.002011953853070736
      ],
      "plane_d": -1353.20361328125,
      "bbox_min": [
        -528.131103515625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1894.5,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -494.2233581542969,
        -1977.7279052734375,
        880.78662109375
      ],
      "bbox_max": [
        -421.84124755859375,
        -1928.0,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246255874634,
        -0.7371541261672974,
        0.0
      ],
      "plane_d": -1719.9033203125,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        892.0023193359375
      ],
      "bbox_max": [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -442.0,
        -1935.8033447265625,
        912.0
      ],
      "bbox_max": [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      "bbox_max": [
        -422.1824951171875,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015326142311096,
        -0.8651387691497803,
        0.0
      ],
      "plane_d": -1457.5679931640625,
      "bbox_min": [
        -435.970703125,
        -1937.517578125,
        880.78662109375
      ],
      "bbox_max": [
        -421.84124755859375,
        -1928.0,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.4873352050781,
        -1935.858642578125,
        912.0
      ],
      "bbox_max": [
        -421.84124755859375,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.4873352050781,
        -1935.858642578125,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.3961181640625,
        921.1699829101562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.160947784781456,
        -0.9869629144668579,
        0.0
      ],
      "plane_d": -1824.285400390625,
      "bbox_min": [
        -528.131103515625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1894.5,
        1080.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        766.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8320502638816833,
        -0.0,
        0.5547001957893372
      ],
      "plane_d": -216.33306884765625,
      "bbox_min": [
        -360.0,
        -1907.0894775390625,
        912.0
      ],
      "bbox_max": [
        -348.0,
        -1894.5,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5015454292297363,
        -0.8651313185691833,
        0.0
      ],
      "plane_d": -1457.548095703125,
      "bbox_min": [
        -528.131103515625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1895.00830078125,
        1080.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.4269714355469,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -419.55340576171875,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.4269714355469,
        -1935.9715576171875,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1933.5428466796875,
        920.929931640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20517180860042572,
        -0.898783266544342,
        0.3874184191226959
      ],
      "plane_d": -1978.56298828125,
      "bbox_min": [
        -528.131103515625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        766.0
      ],
      "bbox_max": [
        -290.0,
        -1905.1326904296875,
        871.5677490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1947.25,
        769.9519653320312
      ],
      "bbox_max": [
        -360.0,
        -1939.0,
        804.1193237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1947.25,
        771.2595825195312
      ],
      "bbox_max": [
        -369.0,
        -1939.0,
        804.1193237304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -369.0,
        -1950.0,
        772.1289672851562
      ],
      "bbox_max": [
        -369.0,
        -1947.25,
        784.97998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -300.0,
        -1937.9559326171875,
        770.0
      ],
      "bbox_max": [
        -290.0,
        -1920.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.476491779088974,
        -0.7905871868133545,
        0.3846135139465332
      ],
      "plane_d": -1664.8924560546875,
      "bbox_min": [
        -528.131103515625,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4577594995498657,
        -0.8173955082893372,
        0.3497438430786133
      ],
      "plane_d": -1698.0321044921875,
      "bbox_min": [
        -528.131103515625,
        -2022.4786376953125,
        780.3657836914062
      ],
      "bbox_max": [
        -379.35943603515625,
        -1912.418212890625,
        880.78662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47970375418663025,
        -0.768060028553009,
        0.42422646284103394
      ],
      "plane_d": -1652.64599609375,
      "bbox_min": [
        -528.131103515625,
        -2022.4786376953125,
        780.42041015625
      ],
      "bbox_max": [
        -379.35943603515625,
        -1912.418212890625,
        880.78662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -528.131103515625,
        -2022.4786376953125,
        780.42041015625
      ],
      "bbox_max": [
        -408.11614990234375,
        -1972.0,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -414.0,
        -1972.0,
        780.42041015625
      ],
      "bbox_max": [
        -408.11614990234375,
        -1972.0,
        788.1212768554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -392.676025390625,
        -1927.9451904296875,
        839.7252807617188
      ],
      "bbox_max": [
        -379.35943603515625,
        -1912.418212890625,
        878.3258666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -418.30963134765625,
        -1976.85595703125,
        780.3657836914062
      ],
      "bbox_max": [
        -407.739990234375,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -418.30963134765625,
        -1976.85595703125,
        781.6095581054688
      ],
      "bbox_max": [
        -414.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06079954281449318,
        -0.8831871151924133,
        0.4650632441043854
      ],
      "plane_d": -2091.9970703125,
      "bbox_min": [
        -433.3038635253906,
        -2032.0,
        741.6661376953125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1895.00830078125,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.02143726870417595,
        -0.8702447414398193,
        0.49215301871299744
      ],
      "plane_d": -2067.314453125,
      "bbox_min": [
        -300.0,
        -1956.10107421875,
        741.6661376953125
      ],
      "bbox_max": [
        -150.88075256347656,
        -1895.00830078125,
        862.176513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06842510402202606,
        -0.866873025894165,
        0.4938108026981354
      ],
      "plane_d": -2051.470947265625,
      "bbox_min": [
        -300.0,
        -1956.10107421875,
        741.6661376953125
      ],
      "bbox_max": [
        -152.91407775878906,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -300.0,
        -1946.1907958984375,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1925.915771484375,
        770.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1944.1578369140625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1929.899169921875,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -230.068359375,
        -1947.109375,
        765.0
      ],
      "bbox_max": [
        -155.18882751464844,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -224.7366180419922,
        -1947.109375,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1947.109375,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1941.3095703125,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -247.4969940185547,
        -1954.1588134765625,
        765.0
      ],
      "bbox_max": [
        -150.88075256347656,
        -1905.971923828125,
        840.3576049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -247.4969940185547,
        -1954.1588134765625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1944.2816162109375,
        770.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1954.1588134765625,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1944.2816162109375,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -1972.0,
      "bbox_min": [
        -433.3038635253906,
        -2032.0,
        749.0316772460938
      ],
      "bbox_max": [
        -144.57388305664062,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 369.0,
      "bbox_min": [
        -433.3038635253906,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -144.57388305664062,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -433.3038635253906,
        -1969.27099609375,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.01708984375,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -433.3038635253906,
        -1969.27099609375,
        773.1744384765625
      ],
      "bbox_max": [
        -369.0,
        -1926.01708984375,
        920.0897216796875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3979502022266388,
        -0.8249621391296387,
        0.40133896470069885
      ],
      "plane_d": -1778.3778076171875,
      "bbox_min": [
        -398.94171142578125,
        -1969.27099609375,
        773.8579711914062
      ],
      "bbox_max": [
        -372.4520263671875,
        -1957.908935546875,
        778.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -1938.9998779296875,
      "bbox_min": [
        -433.3038635253906,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6160964369773865,
        -0.6721051335334778,
        0.4107309579849243
      ],
      "plane_d": -1942.7200927734375,
      "bbox_min": [
        -433.3038330078125,
        -1939.0,
        912.0
      ],
      "bbox_max": [
        -430.0,
        -1934.0562744140625,
        920.0897216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -372.5,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        788.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -371.0,
        -1968.0,
        780.0
      ],
      "bbox_max": [
        -369.0,
        -1962.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1939.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -144.57388305664062,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1186.0810546875,
      "bbox_min": [
        -369.0,
        -1939.0,
        795.7946166992188
      ],
      "bbox_max": [
        -147.15267944335938,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 348.0,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8728637695312
      ],
      "bbox_max": [
        -348.0,
        -1905.1326904296875,
        930.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6160963773727417,
        -0.6721051335334778,
        0.41073092818260193
      ],
      "plane_d": -1456.00390625,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8728637695312
      ],
      "bbox_max": [
        -348.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8532817959785461,
        0.5214499831199646
      ],
      "plane_d": -2130.07568359375,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8728637695312
      ],
      "bbox_max": [
        -360.0,
        -1928.0,
        930.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1939.0,
        802.8728637695312
      ],
      "bbox_max": [
        -366.6459655761719,
        -1936.5960693359375,
        809.6964721679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -208.44375610351562,
        -1939.0,
        795.7946166992188
      ],
      "bbox_max": [
        -147.15267944335938,
        -1914.585693359375,
        835.1259765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -144.57388305664062,
        -1939.0,
        820.2978515625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -170.0,
        -1972.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -1951.5257568359375,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4703574776649475,
        -0.7688682079315186,
        0.433134526014328
      ],
      "plane_d": -1666.1326904296875,
      "bbox_min": [
        -369.0,
        -1972.0,
        770.4967651367188
      ],
      "bbox_max": [
        -144.57388305664062,
        -1939.0,
        820.2978515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -144.57388305664062,
        -1939.0,
        820.2978515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -369.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -355.0,
        -1972.0,
        778.7999267578125
      ],
      "bbox_max": [
        -349.0,
        -1960.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1962.0,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1962.0,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1962.0,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1960.5,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1969.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 367.5,
      "bbox_min": [
        -369.0,
        -1969.5,
        780.0
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.800000011920929,
        -0.0,
        0.6000000238418579
      ],
      "plane_d": -179.10000610351562,
      "bbox_min": [
        -369.0,
        -1969.5,
        788.5
      ],
      "bbox_max": [
        -367.5,
        -1968.0,
        790.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        -414.00189208984375,
        -2032.0,
        749.0316772460938
      ],
      "bbox_max": [
        -170.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2032.0,
      "bbox_min": [
        -325.0,
        -2032.0,
        749.0316772460938
      ],
      "bbox_max": [
        -170.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        -325.0,
        -2032.0,
        749.0316772460938
      ],
      "bbox_max": [
        -170.0,
        -1972.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1992.0,
      "bbox_min": [
        -325.0,
        -2032.0,
        749.0316772460938
      ],
      "bbox_max": [
        -170.0,
        -1979.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 187.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        749.0316772460938
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -325.0,
        -1992.0,
        749.8746948242188
      ],
      "bbox_max": [
        -187.0,
        -1979.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.0,
      "bbox_min": [
        -195.0,
        -1987.0,
        750.1939697265625
      ],
      "bbox_max": [
        -195.0,
        -1979.0,
        754.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1634.8309326171875,
      "bbox_min": [
        -325.0,
        -1992.0,
        769.7255249023438
      ],
      "bbox_max": [
        -320.0,
        -1987.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1309.5618896484375,
      "bbox_min": [
        -300.0,
        -2032.0,
        765.0
      ],
      "bbox_max": [
        -170.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1641.902099609375,
      "bbox_min": [
        -300.0,
        -2032.0,
        769.5819702148438
      ],
      "bbox_max": [
        -290.0,
        -2022.0,
        770.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1987.0,
      "bbox_min": [
        -414.00189208984375,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        -414.00189208984375,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        788.12158203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        -0.5547002553939819,
        0.0
      ],
      "plane_d": -1398.3994140625,
      "bbox_min": [
        -366.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -349.0,
        -1987.0,
        770.0
      ],
      "bbox_max": [
        -300.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1978.400146484375,
      "bbox_min": [
        -349.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -349.0,
        -1978.400146484375,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.44721364974975586,
        0.0
      ],
      "plane_d": 1194.0604248046875,
      "bbox_min": [
        -349.0,
        -1977.0,
        778.7999267578125
      ],
      "bbox_max": [
        -346.5,
        -1972.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -1986.60009765625,
      "bbox_min": [
        -324.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 323.0,
      "bbox_min": [
        -323.0,
        -1986.60009765625,
        770.0
      ],
      "bbox_max": [
        -323.0,
        -1985.60009765625,
        778.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39794647693634033,
        -0.8249639868736267,
        0.40133899450302124
      ],
      "plane_d": -1778.383056640625,
      "bbox_min": [
        -414.00189208984375,
        -1975.1689453125,
        780.0999145507812
      ],
      "bbox_max": [
        -405.90997314453125,
        -1972.0,
        788.12158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -552.2520141601562,
        -2030.8807373046875,
        801.177978515625
      ],
      "bbox_max": [
        -514.3709106445312,
        -2000.3544921875,
        871.233154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.30027011036872864,
        -0.9506359696388245,
        0.07828837633132935
      ],
      "plane_d": -1957.38037109375,
      "bbox_min": [
        -57.04606246948242,
        -1993.5772705078125,
        725.9998168945312
      ],
      "bbox_max": [
        -17.90656280517578,
        -1975.821044921875,
        797.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34579914808273315,
        -0.9323322772979736,
        0.10573337972164154
      ],
      "plane_d": -1945.410400390625,
      "bbox_min": [
        -55.01028823852539,
        -1977.1312255859375,
        790.7861328125
      ],
      "bbox_max": [
        -51.42585754394531,
        -1975.821044921875,
        797.9343872070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2366829514503479,
        0.9335814118385315,
        0.2690852880477905
      ],
      "plane_d": 1812.3699951171875,
      "bbox_min": [
        -597.4422607421875,
        -2373.0,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1977.131103515625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -327.5,
        -2373.0,
        717.754638671875
      ],
      "bbox_max": [
        127.53099060058594,
        -2115.85498046875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2297.300048828125,
      "bbox_min": [
        -327.5,
        -2373.0,
        790.4696655273438
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        861.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -327.5,
        -2373.0,
        790.4696655273438
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2373.0,
        790.4696655273438
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -199.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        792.1373901367188
      ],
      "bbox_max": [
        -199.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2373.0,
        793.2997436523438
      ],
      "bbox_max": [
        -207.0,
        -2371.5,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        790.4696655273438
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        790.4696655273438
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 210.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        792.6490478515625
      ],
      "bbox_max": [
        -210.5,
        -2360.5,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 228.0,
      "bbox_min": [
        -327.5,
        -2371.5,
        824.9999389648438
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 851.5,
      "bbox_min": [
        -327.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2312.0,
      "bbox_min": [
        -327.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -241.0,
      "bbox_min": [
        -327.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 233.800048828125,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469529032707214,
        0.0,
        0.8371633887290955
      ],
      "plane_d": -564.4230346679688,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5469409227371216,
        0.0,
        -0.837171196937561
      ],
      "plane_d": 825.1044921875,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2311.300048828125,
      "bbox_min": [
        -233.800048828125,
        -2311.300048828125,
        825.0
      ],
      "bbox_max": [
        -228.0,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2299.5,
      "bbox_min": [
        -327.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -241.0,
        -2297.300048828125,
        851.5000610351562
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2299.5,
        825.0
      ],
      "bbox_max": [
        -251.5,
        -2297.300048828125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 258.5,
      "bbox_min": [
        -258.5,
        -2299.5,
        825.0
      ],
      "bbox_max": [
        -251.5,
        -2297.300048828125,
        834.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -251.5,
      "bbox_min": [
        -258.5,
        -2299.5,
        825.0
      ],
      "bbox_max": [
        -251.5,
        -2297.300048828125,
        834.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.0,
      "bbox_min": [
        -258.5,
        -2299.5,
        834.0
      ],
      "bbox_max": [
        -251.5,
        -2297.300048828125,
        834.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2299.5,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2297.300048828125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812390860636e-06,
        0.0,
        1.0
      ],
      "plane_d": -838.5015258789062,
      "bbox_min": [
        -327.5,
        -2299.5,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2297.300048828125,
        838.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -327.5,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -241.0,
        -2299.5,
        851.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2308.0,
      "bbox_min": [
        -327.5,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -241.0,
        -2299.5,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7926213145256042,
        -0.6097143888473511
      ],
      "plane_d": 2339.94482421875,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -241.0,
        -2308.0,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950763612985611,
        0.9807881116867065,
        -0.0
      ],
      "plane_d": 2329.031005859375,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -273.0,
        -2308.0,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -273.0,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -273.0,
        -2308.0,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        0.8314722776412964,
        -0.0
      ],
      "plane_d": 2099.23388671875,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 1551.6982421875,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.711794746181113e-07,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -835.5115356445312,
      "bbox_min": [
        -324.0652770996094,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        837.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2312.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2309.461669921875,
        835.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7658641101879766e-06,
        -4.13945099353441e-06,
        1.0
      ],
      "plane_d": -836.5103759765625,
      "bbox_min": [
        -324.0652770996094,
        -2311.048583984375,
        835.4999389648438
      ],
      "bbox_max": [
        -318.8074951171875,
        -2308.0,
        837.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -588.9365234375,
      "bbox_min": [
        -319.783447265625,
        -2311.048583984375,
        835.4999389648438
      ],
      "bbox_max": [
        -318.8074951171875,
        -2308.6923828125,
        836.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1403.2535400390625,
      "bbox_min": [
        -324.0652770996094,
        -2308.3388671875,
        836.9595336914062
      ],
      "bbox_max": [
        -323.5,
        -2308.0,
        837.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.13945099353441e-06,
        -2.765863882814301e-06,
        1.0
      ],
      "plane_d": -837.5076904296875,
      "bbox_min": [
        -324.0652770996094,
        -2308.3388671875,
        837.4999389648438
      ],
      "bbox_max": [
        -323.5,
        -2308.0,
        837.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7658641101879766e-06,
        -4.13945099353441e-06,
        1.0
      ],
      "plane_d": -836.5103759765625,
      "bbox_min": [
        -323.8388671875,
        -2310.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        837.3998413085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.711794746181113e-07,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -835.5115356445312,
      "bbox_min": [
        -319.1261291503906,
        -2310.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        836.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2310.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2308.0,
        835.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -588.9365234375,
      "bbox_min": [
        -319.1261291503906,
        -2309.461669921875,
        835.4999389648438
      ],
      "bbox_max": [
        -318.5207214355469,
        -2308.0,
        836.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1403.2535400390625,
      "bbox_min": [
        -323.8388671875,
        -2308.6923828125,
        836.4999389648438
      ],
      "bbox_max": [
        -323.3096923828125,
        -2308.0,
        837.3998413085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        0.8314722776412964,
        -0.0
      ],
      "plane_d": 2099.23388671875,
      "bbox_min": [
        -323.8388671875,
        -2308.6923828125,
        836.4999389648438
      ],
      "bbox_max": [
        -323.3096923828125,
        -2308.3388671875,
        836.9595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2303.5,
      "bbox_min": [
        -327.5,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -241.0,
        -2299.5,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7926213145256042,
        -0.6097143888473511
      ],
      "plane_d": -1315.228271484375,
      "bbox_min": [
        -327.5,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -241.0,
        -2299.5,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -273.0,
      "bbox_min": [
        -327.5,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -273.0,
        -2299.5,
        851.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807881116867065,
        0.1950763612985611,
        0.0
      ],
      "plane_d": 769.7861938476562,
      "bbox_min": [
        -327.5,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812845607987e-06,
        -9.711794746181113e-07,
        1.0
      ],
      "plane_d": -838.5037841796875,
      "bbox_min": [
        -327.5,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        838.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826743960380554,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -2003.92724609375,
      "bbox_min": [
        -324.6571350097656,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        838.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.13945099353441e-06,
        -2.765863882814301e-06,
        1.0
      ],
      "plane_d": -837.5076904296875,
      "bbox_min": [
        -324.6571350097656,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        837.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1403.2535400390625,
      "bbox_min": [
        -319.0,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        837.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -588.9365234375,
      "bbox_min": [
        -316.3699951171875,
        -2302.8076171875,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.711794746181113e-07,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -835.5115356445312,
      "bbox_min": [
        -316.0513610839844,
        -2302.038330078125,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        835.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2302.038330078125,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        835.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7658641101879766e-06,
        -4.13945099353441e-06,
        1.0
      ],
      "plane_d": -836.5103759765625,
      "bbox_min": [
        -319.0,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2301.499755859375,
        837.4002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.711794746181113e-07,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -835.5115356445312,
      "bbox_min": [
        -316.65679931640625,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2301.499755859375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2303.5,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2301.499755859375,
        835.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -588.9365234375,
      "bbox_min": [
        -316.65679931640625,
        -2303.5,
        835.5
      ],
      "bbox_max": [
        -316.0513610839844,
        -2302.038330078125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1403.2535400390625,
      "bbox_min": [
        -319.0,
        -2303.5,
        836.5
      ],
      "bbox_max": [
        -318.3075866699219,
        -2302.8076171875,
        837.4002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        0.5555662512779236,
        -0.0
      ],
      "plane_d": 1551.6982421875,
      "bbox_min": [
        -326.70440673828125,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807881116867065,
        0.1950763612985611,
        0.0
      ],
      "plane_d": 769.7861938476562,
      "bbox_min": [
        -326.70440673828125,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.13945099353441e-06,
        -2.765863882814301e-06,
        1.0
      ],
      "plane_d": -837.5076904296875,
      "bbox_min": [
        -326.70440673828125,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        838.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.7658641101879766e-06,
        -4.13945099353441e-06,
        1.0
      ],
      "plane_d": -836.5103759765625,
      "bbox_min": [
        -323.5,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        837.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.711794746181113e-07,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -835.5115356445312,
      "bbox_min": [
        -318.5207214355469,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2308.0,
        834.7999877929688
      ],
      "bbox_max": [
        -315.0,
        -2303.5,
        835.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -588.9365234375,
      "bbox_min": [
        -318.5207214355469,
        -2308.0,
        835.4999389648438
      ],
      "bbox_max": [
        -316.65679931640625,
        -2303.5,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1403.2535400390625,
      "bbox_min": [
        -323.5,
        -2308.0,
        836.4999389648438
      ],
      "bbox_max": [
        -319.0,
        -2303.5,
        837.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826743960380554,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -2003.92724609375,
      "bbox_min": [
        -326.70440673828125,
        -2304.283447265625,
        837.4999389648438
      ],
      "bbox_max": [
        -324.6571350097656,
        -2303.5,
        838.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812845607987e-06,
        -9.711794746181113e-07,
        1.0
      ],
      "plane_d": -838.5037841796875,
      "bbox_min": [
        -326.70440673828125,
        -2304.283447265625,
        838.4999389648438
      ],
      "bbox_max": [
        -324.6571350097656,
        -2303.5,
        838.4999389648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -834.51123046875,
      "bbox_min": [
        -315.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -2299.5,
        834.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -829.51123046875,
      "bbox_min": [
        -293.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -2299.5,
        834.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -826.51123046875,
      "bbox_min": [
        -283.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -2299.5,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -825.51123046875,
      "bbox_min": [
        -277.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -2299.5,
        826.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 275.0,
      "bbox_min": [
        -275.0,
        -2312.0,
        824.9999389648438
      ],
      "bbox_max": [
        -275.0,
        -2299.5,
        825.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 277.0,
      "bbox_min": [
        -277.0,
        -2312.0,
        825.4999389648438
      ],
      "bbox_max": [
        -277.0,
        -2299.5,
        826.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -827.51123046875,
      "bbox_min": [
        -283.0,
        -2312.0,
        826.4999389648438
      ],
      "bbox_max": [
        -279.0,
        -2299.5,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.0,
      "bbox_min": [
        -279.0,
        -2312.0,
        826.4999389648438
      ],
      "bbox_max": [
        -279.0,
        -2299.5,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -828.51123046875,
      "bbox_min": [
        -283.0,
        -2312.0,
        827.4999389648438
      ],
      "bbox_max": [
        -281.0,
        -2299.5,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 281.0,
      "bbox_min": [
        -281.0,
        -2312.0,
        827.4999389648438
      ],
      "bbox_max": [
        -281.0,
        -2299.5,
        828.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 283.0,
      "bbox_min": [
        -283.0,
        -2312.0,
        828.4999389648438
      ],
      "bbox_max": [
        -283.0,
        -2299.5,
        829.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -831.51123046875,
      "bbox_min": [
        -293.0,
        -2312.0,
        829.4999389648438
      ],
      "bbox_max": [
        -285.0,
        -2299.5,
        834.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -830.51123046875,
      "bbox_min": [
        -287.0,
        -2312.0,
        829.4999389648438
      ],
      "bbox_max": [
        -285.0,
        -2299.5,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 285.0,
      "bbox_min": [
        -285.0,
        -2312.0,
        829.4999389648438
      ],
      "bbox_max": [
        -285.0,
        -2299.5,
        830.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 287.0,
      "bbox_min": [
        -287.0,
        -2312.0,
        830.4999389648438
      ],
      "bbox_max": [
        -287.0,
        -2299.5,
        831.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -832.51123046875,
      "bbox_min": [
        -293.0,
        -2312.0,
        831.4999389648438
      ],
      "bbox_max": [
        -289.0,
        -2299.5,
        834.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 289.0,
      "bbox_min": [
        -289.0,
        -2312.0,
        831.4999389648438
      ],
      "bbox_max": [
        -289.0,
        -2299.5,
        832.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -4.882812390860636e-06,
        1.0
      ],
      "plane_d": -833.51123046875,
      "bbox_min": [
        -293.0,
        -2312.0,
        832.4999389648438
      ],
      "bbox_max": [
        -291.0,
        -2299.5,
        834.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 291.0,
      "bbox_min": [
        -291.0,
        -2312.0,
        832.4999389648438
      ],
      "bbox_max": [
        -291.0,
        -2299.5,
        833.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 293.0,
      "bbox_min": [
        -293.0,
        -2312.0,
        833.4999389648438
      ],
      "bbox_max": [
        -293.0,
        -2299.5,
        834.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 315.0,
      "bbox_min": [
        -315.0,
        -2312.0,
        834.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2299.5,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 848.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.857492983341217,
        0.0,
        -0.5144957900047302
      ],
      "plane_d": 626.6558837890625,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -198.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2299.34033203125,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -195.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -198.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -198.0,
        -2371.5,
        838.0
      ],
      "bbox_max": [
        -195.5,
        -2360.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -115.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 115.5,
      "bbox_min": [
        -115.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        -0.9578263163566589
      ],
      "plane_d": 773.780029296875,
      "bbox_min": [
        -95.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -85.5,
        -2299.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2297.300048828125,
        833.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8384436964988708,
        -0.0,
        -0.5449883937835693
      ],
      "plane_d": 290.68841552734375,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2359.0,
      "bbox_min": [
        -228.0,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2371.5,
      "bbox_min": [
        -210.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 838.0,
      "bbox_min": [
        -210.5,
        -2371.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2360.5,
      "bbox_min": [
        -210.5,
        -2360.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2359.0,
        838.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 207.0,
      "bbox_min": [
        -207.0,
        -2360.5,
        825.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.0,
      "bbox_min": [
        -207.0,
        -2360.5,
        836.0
      ],
      "bbox_max": [
        -199.0,
        -2359.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 834.7999877929688,
      "bbox_min": [
        -228.0,
        -2345.5,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        848.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.199951171875,
      "bbox_min": [
        -228.0,
        -2345.5,
        834.7999877929688
      ],
      "bbox_max": [
        -198.0,
        -2313.199951171875,
        848.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": 2458.78076171875,
      "bbox_min": [
        -220.5,
        -2328.0,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2325.0,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -220.5,
      "bbox_min": [
        -220.5,
        -2328.0,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2325.0,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 206.0,
      "bbox_min": [
        -206.0,
        -2328.0,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2325.0,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 847.0,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": -1718.6422119140625,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272994995117,
        -0.44721364974975586
      ],
      "plane_d": 2474.43310546875,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -220.5,
      "bbox_min": [
        -220.5,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 206.0,
      "bbox_min": [
        -206.0,
        -2345.5,
        847.0
      ],
      "bbox_max": [
        -206.0,
        -2342.5,
        848.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2313.199951171875,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -198.0,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5469409227371216,
        -0.0,
        -0.837171196937561
      ],
      "plane_d": 588.169677734375,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2297.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2311.300048828125,
      "bbox_min": [
        -228.0,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -199.39990234375,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 223.199951171875,
      "bbox_min": [
        -223.199951171875,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -208.60009765625,
      "bbox_min": [
        -208.60009765625,
        -2313.199951171875,
        825.0
      ],
      "bbox_max": [
        -208.60009765625,
        -2311.300048828125,
        834.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2294.34033203125,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        861.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.9927338361740112,
        0.0,
        -0.12033137679100037
      ],
      "plane_d": 375.32861328125,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2294.34033203125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2294.34033203125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 851.5,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2294.34033203125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812390860636e-06,
        0.0,
        1.0
      ],
      "plane_d": -838.5015258789062,
      "bbox_min": [
        -327.5,
        -2297.300048828125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2294.34033203125,
        838.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9927338361740112,
        -0.0,
        -0.12033137679100037
      ],
      "plane_d": -16.80126953125,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688879013062,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688879013062,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 439.70721435546875,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.5,
      "bbox_min": [
        -118.5,
        -2297.300048828125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2294.34033203125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9444968700408936,
        0.0,
        0.32852062582969666
      ],
      "plane_d": -386.7303771972656,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 115.5,
      "bbox_min": [
        -115.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2873478829860687,
        0.0,
        -0.9578263163566589
      ],
      "plane_d": 773.780029296875,
      "bbox_min": [
        -95.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -85.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.34033203125,
        833.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9444968700408936,
        -0.0,
        0.32852062582969666
      ],
      "plane_d": -13.65411376953125,
      "bbox_min": [
        -276.5,
        -2297.300048828125,
        825.0
      ],
      "bbox_max": [
        -272.5,
        -2294.34033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -803.5,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.0,
        0.9847835898399353
      ],
      "plane_d": -771.114501953125,
      "bbox_min": [
        -116.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -800.5,
      "bbox_min": [
        -116.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -116.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -116.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2260.0,
      "bbox_min": [
        -116.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1657.4583740234375,
      "bbox_min": [
        -84.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1554.9278564453125,
      "bbox_min": [
        -84.0,
        -2283.0,
        800.5
      ],
      "bbox_max": [
        -82.0,
        -2281.0,
        803.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 158.0,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2248.1826171875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.39391934871673584,
        0.0,
        0.9191451072692871
      ],
      "plane_d": -865.6377563476562,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2248.1826171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -860.851806640625,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        820.0
      ],
      "bbox_max": [
        -279.5,
        -2249.092529296875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2260.431640625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -304.0,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -293.0,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -293.0,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -292.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -304.0,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -304.0,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -303.0,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -315.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -315.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -315.5,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -315.5,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -314.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2286.340087890625,
      "bbox_min": [
        -326.5,
        -2286.340087890625,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -326.5,
        -2286.340087890625,
        823.2999877929688
      ],
      "bbox_max": [
        -325.5,
        -2284.537109375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -124.5,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.1549677848815918,
        0.0,
        -0.9879196286201477
      ],
      "plane_d": 827.4117431640625,
      "bbox_min": [
        -124.5,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2209.897216796875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -121.76891326904297,
        -2281.0,
        818.7039794921875
      ],
      "bbox_max": [
        -87.0,
        -2209.897216796875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -121.76891326904297,
        -2219.5,
        818.7039794921875
      ],
      "bbox_max": [
        -117.70906066894531,
        -2209.897216796875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2262.0,
      "bbox_min": [
        -94.0,
        -2262.0,
        822.7843017578125
      ],
      "bbox_max": [
        -87.0,
        -2262.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2260.0,
      "bbox_min": [
        -124.5,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2219.434326171875,
        823.8823852539062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -120.01209259033203,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -119.99773406982422,
        -2219.434326171875,
        818.7062377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -124.5,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        823.8823852539062
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -82.0,
      "bbox_min": [
        -124.5,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17378532886505127,
        -0.0,
        0.9847835898399353
      ],
      "plane_d": -771.114501953125,
      "bbox_min": [
        -124.5,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 821.9999389648438,
      "bbox_min": [
        -99.0,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        823.8823852539062
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -87.0,
      "bbox_min": [
        -94.0,
        -2281.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 94.0,
      "bbox_min": [
        -94.0,
        -2281.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.0,
      "bbox_min": [
        -94.0,
        -2281.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2262.0,
      "bbox_min": [
        -94.0,
        -2262.0,
        822.0
      ],
      "bbox_max": [
        -87.0,
        -2262.0,
        823.8823852539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -1657.4583740234375,
      "bbox_min": [
        -84.0,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2260.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1554.9278564453125,
      "bbox_min": [
        -84.0,
        -2283.0,
        803.5
      ],
      "bbox_max": [
        -82.0,
        -2281.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39391931891441345,
        0.0,
        0.9191450476646423
      ],
      "plane_d": -788.9547119140625,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.0,
        0.8944271802902222
      ],
      "plane_d": -649.3541259765625,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2292.5,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2241.0,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.4594351351261139,
        0.8882113695144653
      ],
      "plane_d": -1744.604248046875,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.48564964532852173,
        0.8741535544395447
      ],
      "plane_d": 409.65814208984375,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.637175977230072,
        -0.7707184553146362,
        -0.0
      ],
      "plane_d": -1808.738525390625,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6050354242324829,
        0.7961986660957336,
        0.0
      ],
      "plane_d": 1747.8408203125,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6942223310470581,
        -0.7197607159614563,
        0.0
      ],
      "plane_d": -1505.3792724609375,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6633881330490112,
        0.7482755184173584,
        0.0
      ],
      "plane_d": 1818.246826171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3550778925418854,
        -0.4294968247413635,
        0.8303325772285461
      ],
      "plane_d": -1676.3701171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3462229073047638,
        0.4556133449077606,
        0.8200891613960266
      ],
      "plane_d": 340.00537109375,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -124.5,
        -2241.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40513741970062256,
        -0.4200412333011627,
        0.8120523691177368
      ],
      "plane_d": -1532.21826171875,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -155.0,
        -2241.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3954584002494812,
        0.446061372756958,
        0.8028959631919861
      ],
      "plane_d": 437.56048583984375,
      "bbox_min": [
        -158.0,
        -2292.5,
        803.5
      ],
      "bbox_max": [
        -155.0,
        -2289.800048828125,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 841.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2210.213623046875,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -16.80126953125,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -118.0,
        -2215.072021484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2292.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2287.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2269.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2244.300048828125,
      "bbox_min": [
        -120.56061553955078,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.3484878540039,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -118.0,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 439.70721435546875,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -118.92424011230469,
        -2215.072021484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -122.5,
      "bbox_min": [
        -125.6351547241211,
        -2294.34033203125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2221.302001953125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2264.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2292.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2292.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2269.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2292.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2292.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2292.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2269.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2269.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2269.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.9000015258789,
        -2244.300048828125,
        854.5
      ],
      "bbox_max": [
        -120.50000762939453,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -125.6351547241211,
        -2239.39990234375,
        857.0
      ],
      "bbox_max": [
        -122.5,
        -2221.302001953125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -184.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -118.92424011230469,
        -2215.072021484375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 132.5,
      "bbox_min": [
        -184.0,
        -2292.300048828125,
        841.5
      ],
      "bbox_max": [
        -118.92424011230469,
        -2215.072021484375,
        860.9189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        858.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -145.5,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -145.5,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -145.5,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -132.5,
        -2291.0,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 171.0,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -184.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -171.0,
        -2291.0,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -125.82259368896484,
        -2292.300048828125,
        841.5
      ],
      "bbox_max": [
        -118.92424011230469,
        -2215.072021484375,
        860.9189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -119.36579895019531,
        -2239.39990234375,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -125.82259368896484,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2219.0439453125,
        860.9189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -125.82259368896484,
        -2239.39990234375,
        854.5001220703125
      ],
      "bbox_max": [
        -120.517333984375,
        -2220.219970703125,
        860.9189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -120.91727447509766,
        -2239.300048828125,
        854.5001220703125
      ],
      "bbox_max": [
        -120.517333984375,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -123.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2287.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2292.300048828125,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2287.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2292.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2287.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2269.300048828125,
      "bbox_min": [
        -123.0,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2269.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2264.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2244.300048828125,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2239.300048828125,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        855.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -123.0,
        -2244.300048828125,
        845.0
      ],
      "bbox_max": [
        -119.3484878540039,
        -2239.300048828125,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -222.0,
      "bbox_min": [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2291.0,
      "bbox_min": [
        -222.0,
        -2291.0,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -209.22642517089844,
        -2240.5,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        854.1991577148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 246.0,
      "bbox_min": [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      "bbox_max": [
        -246.0,
        -2249.82275390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.0,
      "bbox_min": [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      "bbox_max": [
        -259.0,
        -2253.11865234375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      "bbox_max": [
        -272.5,
        -2257.063720703125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 272.5,
      "bbox_min": [
        -272.5,
        -2294.34033203125,
        857.0
      ],
      "bbox_max": [
        -272.5,
        -2257.406005859375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927350282669067,
        0.0,
        -0.12032172083854675
      ],
      "plane_d": 375.3206787109375,
      "bbox_min": [
        -274.56060791015625,
        -2294.34033203125,
        854.0
      ],
      "bbox_max": [
        -274.5,
        -2257.063720703125,
        854.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.22845458984375,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -274.56060791015625,
        -2253.8447265625,
        854.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9927353858947754,
        0.0,
        -0.12031792104244232
      ],
      "plane_d": 375.3177490234375,
      "bbox_min": [
        -277.5625,
        -2294.34033203125,
        841.5
      ],
      "bbox_max": [
        -274.56060791015625,
        -2253.8447265625,
        854.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2290.5,
      "bbox_min": [
        -277.5625,
        -2290.5,
        845.0
      ],
      "bbox_max": [
        -275.04541015625,
        -2290.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1021.7693481445312,
      "bbox_min": [
        -277.5625,
        -2290.5,
        845.0
      ],
      "bbox_max": [
        -275.04541015625,
        -2290.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": 2220.3154296875,
      "bbox_min": [
        -277.0,
        -2290.5,
        849.5
      ],
      "bbox_max": [
        -275.04541015625,
        -2290.0,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -276.5,
        -2257.4111328125,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -276.5,
        -2258.642578125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.4974975585938
      ],
      "bbox_max": [
        -300.5,
        -2260.037109375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.5,
      "bbox_min": [
        -312.5,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -300.5,
        -2260.037109375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2274.5,
      "bbox_min": [
        -312.5,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -300.5,
        -2262.919189453125,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 312.5,
      "bbox_min": [
        -312.5,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -300.5,
        -2262.919189453125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 112.02700805664062,
      "bbox_min": [
        -312.5,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -300.5,
        -2262.919189453125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -309.75,
      "bbox_min": [
        -312.5,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -303.0999755859375,
        -2265.96142578125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 303.0999755859375,
      "bbox_min": [
        -309.75,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -303.0999755859375,
        -2271.5,
        852.2474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2271.5,
      "bbox_min": [
        -309.75,
        -2274.5,
        841.4974975585938
      ],
      "bbox_max": [
        -303.0999755859375,
        -2271.5,
        852.2474975585938
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        0.8320503830909729
      ],
      "plane_d": 552.552734375,
      "bbox_min": [
        -309.75,
        -2274.5,
        842.4974975585938
      ],
      "bbox_max": [
        -303.0999755859375,
        -2271.5,
        852.2474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -306.8125915527344,
      "bbox_min": [
        -309.3125915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2274.0,
      "bbox_min": [
        -306.0625915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -303.5625915527344,
      "bbox_min": [
        -306.0625915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 306.0625915527344,
      "bbox_min": [
        -306.0625915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 848.7474975585938,
      "bbox_min": [
        -306.0625915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -842.4974975585938,
      "bbox_min": [
        -306.0625915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -303.5625915527344,
        -2271.5,
        842.4974975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2274.0,
      "bbox_min": [
        -309.3125915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -306.8125915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 309.3125915527344,
      "bbox_min": [
        -309.3125915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -306.8125915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 848.7474975585938,
      "bbox_min": [
        -309.3125915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -306.8125915527344,
        -2271.5,
        848.7474975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -842.4974975585938,
      "bbox_min": [
        -309.3125915527344,
        -2274.0,
        842.4974975585938
      ],
      "bbox_max": [
        -306.8125915527344,
        -2271.5,
        842.4974975585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 660.3109130859375,
      "bbox_min": [
        -312.5,
        -2274.5,
        851.5
      ],
      "bbox_max": [
        -311.5,
        -2265.96142578125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 851.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.5
      ],
      "bbox_max": [
        -315.0,
        -2266.59521484375,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        841.5
      ],
      "bbox_max": [
        -327.5,
        -2266.882080078125,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2293.0,
      "bbox_min": [
        -295.0,
        -2293.0,
        841.5
      ],
      "bbox_max": [
        -276.5,
        -2261.39990234375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 294.0,
      "bbox_min": [
        -295.0,
        -2293.0,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 844.2000122070312,
      "bbox_min": [
        -295.0,
        -2288.0,
        844.2000122070312
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -852.0,
      "bbox_min": [
        -295.0,
        -2288.0,
        844.2000122070312
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2282.199951171875,
      "bbox_min": [
        -295.0,
        -2288.0,
        844.2000122070312
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2261.39990234375,
      "bbox_min": [
        -295.0,
        -2261.39990234375,
        844.2000122070312
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        851.946044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2283.60009765625,
      "bbox_min": [
        -295.0,
        -2288.0,
        846.0
      ],
      "bbox_max": [
        -294.0,
        -2283.60009765625,
        850.9047241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2288.0,
      "bbox_min": [
        -295.0,
        -2288.0,
        846.0
      ],
      "bbox_max": [
        -294.0,
        -2283.60009765625,
        850.9047241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 846.0,
      "bbox_min": [
        -295.0,
        -2288.0,
        846.0
      ],
      "bbox_max": [
        -294.0,
        -2283.60009765625,
        850.9047241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.9047241210938,
      "bbox_min": [
        -295.0,
        -2288.0,
        850.9047241210938
      ],
      "bbox_max": [
        -294.0,
        -2283.60009765625,
        850.9047241210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2291.5,
      "bbox_min": [
        -293.0,
        -2293.0,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        852.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -852.0,
      "bbox_min": [
        -293.0,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 845.0,
      "bbox_min": [
        -293.0,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.5,
      "bbox_min": [
        -293.0,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -279.5,
        -2291.5,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -293.0,
        -2293.0,
        845.0
      ],
      "bbox_max": [
        -293.0,
        -2291.5,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 279.0,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2281.60009765625,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2284.10009765625,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957900047302,
        0.0,
        0.857492983341217
      ],
      "plane_d": -869.0546875,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -281.5,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        841.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.0,
        0.5144957900047302
      ],
      "plane_d": -195.7656707763672,
      "bbox_min": [
        -279.25726318359375,
        -2284.10009765625,
        845.5
      ],
      "bbox_max": [
        -279.0,
        -2281.60009765625,
        845.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957900047302
      ],
      "plane_d": 192.8501739501953,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        844.0
      ],
      "bbox_max": [
        -281.5,
        -2281.60009765625,
        844.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -281.75726318359375,
      "bbox_min": [
        -281.75726318359375,
        -2284.10009765625,
        844.4287719726562
      ],
      "bbox_max": [
        -281.75726318359375,
        -2281.60009765625,
        845.228759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -95.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2210.213623046875,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28734785318374634,
        -0.0,
        -0.9578262567520142
      ],
      "plane_d": 773.7799682617188,
      "bbox_min": [
        -95.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -85.5,
      "bbox_min": [
        -95.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.4467592239379883,
        -0.8946542739868164,
        0.0
      ],
      "plane_d": -2046.1541748046875,
      "bbox_min": [
        -95.5,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -827.5,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2245.5,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -89.0,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2245.5,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2283.0,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2245.5,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2294.300048828125,
      "bbox_min": [
        -89.0,
        -2294.300048828125,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2294.300048828125,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2260.0,
      "bbox_min": [
        -89.0,
        -2260.0,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2245.5,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2245.5,
      "bbox_min": [
        -89.0,
        -2245.5,
        825.0
      ],
      "bbox_max": [
        -85.5,
        -2245.5,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 115.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -95.5,
        -2210.213623046875,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2210.213623046875,
        841.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -16.80126953125,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812390860636e-06,
        0.0,
        1.0
      ],
      "plane_d": -838.5015258789062,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2262.848388671875,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2262.848388671875,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2294.34033203125,
        838.4999389648438
      ],
      "bbox_max": [
        -327.5,
        -2266.017333984375,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927353858947754,
        0.0,
        -0.12031792104244232
      ],
      "plane_d": 375.3177490234375,
      "bbox_min": [
        -276.5,
        -2294.34033203125,
        836.5
      ],
      "bbox_max": [
        -118.5,
        -2213.58837890625,
        841.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -123.13863372802734,
        -2239.39990234375,
        838.0
      ],
      "bbox_max": [
        -118.5,
        -2214.002685546875,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2210.213623046875,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -119.62411499023438,
        -2219.5,
        825.0
      ],
      "bbox_max": [
        -115.5,
        -2210.213623046875,
        835.6416625976562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 116.5,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.3579343557357788,
        0.9337468147277832
      ],
      "plane_d": -1578.020751953125,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2247.8935546875,
        835.0315551757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2253.8935546875,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2253.8935546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3579343557357788,
        -0.9337468147277832
      ],
      "plane_d": -29.58843994140625,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2247.8935546875,
        835.0315551757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2253.8935546875,
      "bbox_min": [
        -117.45008087158203,
        -2253.8935546875,
        832.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2253.8935546875,
        835.0315551757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2247.8935546875,
      "bbox_min": [
        -118.0,
        -2247.8935546875,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2247.8935546875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -326.5,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2242.2861328125,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -304.0,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -293.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -293.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -303.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -304.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -303.0,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -304.0,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -303.0,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -315.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -315.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -315.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -315.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -314.5,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 325.5,
      "bbox_min": [
        -326.5,
        -2294.340087890625,
        825.0
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2282.840087890625,
      "bbox_min": [
        -326.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": 2167.48095703125,
      "bbox_min": [
        -326.5,
        -2284.537109375,
        825.0
      ],
      "bbox_max": [
        -325.5,
        -2282.840087890625,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -118.0,
      "bbox_min": [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2242.2861328125,
        836.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 116.5,
      "bbox_min": [
        -118.0,
        -2294.34033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2250.945068359375,
        836.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.3579343557357788,
        0.9337468147277832
      ],
      "plane_d": 44.75830078125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2252.099853515625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        825.0
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3579343557357788,
        -0.9337468147277832
      ],
      "plane_d": 1593.190673828125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2252.099853515625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2279.84033203125,
      "bbox_min": [
        -118.0,
        -2279.84033203125,
        832.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2279.84033203125,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2253.8935546875,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2252.099853515625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.3579343557357788,
        -0.9337468147277832
      ],
      "plane_d": -29.58843994140625,
      "bbox_min": [
        -118.0,
        -2253.8935546875,
        831.6123657226562
      ],
      "bbox_max": [
        -117.45008087158203,
        -2252.099853515625,
        832.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2285.84033203125,
      "bbox_min": [
        -118.0,
        -2285.84033203125,
        828.2999877929688
      ],
      "bbox_max": [
        -116.5,
        -2285.84033203125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.1960563212633133,
        -0.9805927276611328
      ],
      "plane_d": 386.1202697753906,
      "bbox_min": [
        -115.5,
        -2239.39990234375,
        825.0
      ],
      "bbox_max": [
        -95.5,
        -2211.447021484375,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -115.3874282836914,
        -2216.406982421875,
        835.921630859375
      ],
      "bbox_max": [
        -114.01850128173828,
        -2211.499267578125,
        836.9834594726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -115.5,
        -2219.5,
        831.0748291015625
      ],
      "bbox_max": [
        -113.39990234375,
        -2211.447021484375,
        836.9028930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.980592668056488,
        -0.1960563063621521,
        -0.0
      ],
      "plane_d": -532.695068359375,
      "bbox_min": [
        -111.5,
        -2239.39990234375,
        825.0
      ],
      "bbox_max": [
        -95.5,
        -2219.3935546875,
        841.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2219.3935546875,
      "bbox_min": [
        -111.5,
        -2219.3935546875,
        825.0
      ],
      "bbox_max": [
        -99.5,
        -2219.3935546875,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -129.6965789794922,
        -2211.978759765625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.629150390625,
        847.1928100585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -129.6965789794922,
        -2211.978759765625,
        819.28125
      ],
      "bbox_max": [
        -117.47943115234375,
        -2208.415771484375,
        830.7184448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        108.49942016601562,
        -2158.119384765625,
        724.793212890625
      ],
      "bbox_max": [
        113.528564453125,
        -2157.629150390625,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        -106.53463745117188,
        -2206.544921875,
        717.754638671875
      ],
      "bbox_max": [
        127.53099060058594,
        -2115.85498046875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        717.754638671875
      ],
      "bbox_max": [
        127.53099060058594,
        -2115.85498046875,
        739.994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10146033763885498,
        0.9581761956214905,
        0.2675895094871521
      ],
      "plane_d": 1884.0174560546875,
      "bbox_min": [
        113.528564453125,
        -2157.653076171875,
        723.8088989257812
      ],
      "bbox_max": [
        115.12509155273438,
        -2156.200927734375,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -106.53463745117188,
        -2204.010009765625,
        723.9014282226562
      ],
      "bbox_max": [
        114.55088806152344,
        -2156.28759765625,
        836.4596557617188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.36875930428504944,
        0.824822723865509,
        0.4285838007926941
      ],
      "plane_d": 1509.3642578125,
      "bbox_min": [
        109.38627624511719,
        -2157.653076171875,
        724.5084838867188
      ],
      "bbox_max": [
        113.528564453125,
        -2156.85595703125,
        728.4032592773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8642076253890991,
        0.49060776829719543,
        -0.11157596111297607
      ],
      "plane_d": 1246.207275390625,
      "bbox_min": [
        -597.4422607421875,
        -2303.484619140625,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1977.131103515625,
        1234.526123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9042837023735046,
        0.4269319474697113,
        0.0
      ],
      "plane_d": 999.3490600585938,
      "bbox_min": [
        -597.4422607421875,
        -2269.764404296875,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9630944132804871,
        0.2227189689874649,
        -0.15114662051200867
      ],
      "plane_d": 699.9846801757812,
      "bbox_min": [
        63.3701171875,
        -2206.544921875,
        711.9805908203125
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9362152218818665,
        0.2509586215019226,
        -0.2460101991891861
      ],
      "plane_d": 826.9634399414062,
      "bbox_min": [
        119.41747283935547,
        -2124.32177734375,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2079.12548828125,
        712.1194458007812
      ],
      "bbox_max": [
        138.8248291015625,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8661781549453735,
        -0.4989537298679352,
        -0.027941754087805748
      ],
      "plane_d": -897.239013671875,
      "bbox_min": [
        129.7200469970703,
        -2073.446044921875,
        711.9805908203125
      ],
      "bbox_max": [
        135.5572967529297,
        -2066.00927734375,
        760.272216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.24286268651485443,
        0.915098249912262,
        0.3218894898891449
      ],
      "plane_d": 1720.4425048828125,
      "bbox_min": [
        -597.4422607421875,
        -2269.764404296875,
        759.2772216796875
      ],
      "bbox_max": [
        63.3701171875,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.138129323720932,
        0.9765928387641907,
        0.16488416492938995
      ],
      "plane_d": 2002.7279052734375,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        759.2772216796875
      ],
      "bbox_max": [
        63.3701171875,
        -2185.397216796875,
        975.9653930664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        819.3709106445312
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.010009765625,
        872.276611328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -73.71690368652344,
        -2206.524169921875,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -89.64111328125,
        -2210.680419921875,
        861.0
      ],
      "bbox_max": [
        -86.32891845703125,
        -2208.580322265625,
        872.276611328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        819.3709106445312
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.010009765625,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        836.5
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.017578125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        836.5
      ],
      "bbox_max": [
        -114.96051025390625,
        -2208.34375,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -274.6212158203125,
        -2258.558837890625,
        853.5
      ],
      "bbox_max": [
        -123.9580307006836,
        -2213.42724609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -274.6212158203125,
        -2258.558837890625,
        853.5
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 246.0,
      "bbox_min": [
        -274.56060791015625,
        -2258.558837890625,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.0,
      "bbox_min": [
        -274.56060791015625,
        -2258.558837890625,
        854.0
      ],
      "bbox_max": [
        -259.0,
        -2249.198486328125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 272.5,
      "bbox_min": [
        -274.56060791015625,
        -2258.558837890625,
        854.0
      ],
      "bbox_max": [
        -272.5,
        -2253.328125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -274.56060791015625,
        -2257.406005859375,
        854.0
      ],
      "bbox_max": [
        -272.5,
        -2253.328125,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927350282669067,
        0.0,
        -0.12032172083854675
      ],
      "plane_d": 375.3206787109375,
      "bbox_min": [
        -274.56060791015625,
        -2257.1923828125,
        854.0
      ],
      "bbox_max": [
        -274.5,
        -2253.328125,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -222.0,
      "bbox_min": [
        -222.0,
        -2244.89111328125,
        854.0
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 209.0,
      "bbox_min": [
        -209.0,
        -2241.595703125,
        854.1991577148438
      ],
      "bbox_max": [
        -209.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927350282669067,
        0.0,
        -0.12032172083854675
      ],
      "plane_d": 375.3206787109375,
      "bbox_min": [
        -274.6212158203125,
        -2257.0634765625,
        853.5
      ],
      "bbox_max": [
        -274.56060791015625,
        -2253.16845703125,
        854.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -126.70217895507812,
        -2221.324462890625,
        853.5
      ],
      "bbox_max": [
        -123.9580307006836,
        -2213.42724609375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -126.70217895507812,
        -2220.219970703125,
        853.5
      ],
      "bbox_max": [
        -123.9580307006836,
        -2213.42724609375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -124.93572998046875,
        -2219.0439453125,
        853.5
      ],
      "bbox_max": [
        -123.9580307006836,
        -2213.42724609375,
        854.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        836.5
      ],
      "bbox_max": [
        -114.96051025390625,
        -2208.34375,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -115.82784271240234,
        -2211.697021484375,
        836.5
      ],
      "bbox_max": [
        -114.96051025390625,
        -2208.34375,
        837.039794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        853.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9927353858947754,
        0.0,
        -0.12031792104244232
      ],
      "plane_d": 375.3177490234375,
      "bbox_min": [
        -276.5,
        -2253.8447265625,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -276.5,
        -2252.943603515625,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -123.6874008178711,
        -2214.002685546875,
        836.5
      ],
      "bbox_max": [
        -122.89964294433594,
        -2209.455322265625,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        841.5
      ],
      "bbox_max": [
        -274.6212158203125,
        -2249.333251953125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.5,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.910400390625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 1804.5362548828125,
      "bbox_min": [
        -297.089599609375,
        -2257.0,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.910400390625,
        849.01708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 312.5,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        841.5
      ],
      "bbox_max": [
        -300.5,
        -2259.0,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 112.02700805664062,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        851.5
      ],
      "bbox_max": [
        -300.5,
        -2259.332763671875,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 660.3109130859375,
      "bbox_min": [
        -312.5,
        -2266.284423828125,
        851.5
      ],
      "bbox_max": [
        -311.5,
        -2262.517578125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.22845458984375,
      "bbox_min": [
        -295.0,
        -2261.6689453125,
        841.5
      ],
      "bbox_max": [
        -274.6212158203125,
        -2249.333251953125,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9927353858947754,
        0.0,
        -0.12031792104244232
      ],
      "plane_d": 375.3177490234375,
      "bbox_min": [
        -277.5625,
        -2256.934814453125,
        841.5
      ],
      "bbox_max": [
        -274.6212158203125,
        -2249.333251953125,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        -277.5625,
        -2256.51318359375,
        845.0
      ],
      "bbox_max": [
        -275.04541015625,
        -2250.451904296875,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        -276.9375,
        -2256.51318359375,
        850.0
      ],
      "bbox_max": [
        -275.04541015625,
        -2252.0498046875,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2261.39990234375,
      "bbox_min": [
        -295.0,
        -2261.6689453125,
        851.0663452148438
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -852.0,
      "bbox_min": [
        -295.0,
        -2261.6689453125,
        851.946044921875
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 294.0,
      "bbox_min": [
        -294.0,
        -2261.41552734375,
        851.946044921875
      ],
      "bbox_max": [
        -294.0,
        -2261.39990234375,
        852.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2258.6083984375,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.882812390860636e-06,
        0.0,
        1.0
      ],
      "plane_d": -838.5015258789062,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2258.6083984375,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 851.5,
      "bbox_min": [
        -327.5,
        -2269.764404296875,
        851.5
      ],
      "bbox_max": [
        -315.0,
        -2263.18115234375,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.17143665254116058,
        0.9780559539794922,
        0.11838870495557785
      ],
      "plane_d": 2043.5338134765625,
      "bbox_min": [
        -86.32891845703125,
        -2208.73486328125,
        847.1928100585938
      ],
      "bbox_max": [
        -65.38194274902344,
        -2204.348876953125,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -326.5,
        -2265.1875,
        819.3709106445312
      ],
      "bbox_max": [
        -85.22423553466797,
        -2204.010009765625,
        836.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -326.5,
        -2261.872802734375,
        819.3709106445312
      ],
      "bbox_max": [
        -119.77857971191406,
        -2206.40380859375,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -122.41243743896484,
        -2208.532958984375,
        819.3709106445312
      ],
      "bbox_max": [
        -121.78887939453125,
        -2206.40380859375,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -860.851806640625,
      "bbox_min": [
        -326.5,
        -2261.872802734375,
        820.0
      ],
      "bbox_max": [
        -119.77857971191406,
        -2206.461669921875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -122.21601867675781,
        -2209.46435546875,
        820.0
      ],
      "bbox_max": [
        -119.77857971191406,
        -2206.461669921875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39391934871673584,
        0.0,
        0.9191451072692871
      ],
      "plane_d": -865.6377563476562,
      "bbox_min": [
        -326.5,
        -2261.872802734375,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2242.580322265625,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.5,
        -2261.872802734375,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2245.996826171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2249.202880859375,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2245.996826171875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -293.0,
        -2249.202880859375,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2246.26220703125,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -293.0,
        -2249.202880859375,
        823.2999877929688
      ],
      "bbox_max": [
        -292.0,
        -2247.39990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -326.5,
        -2265.1875,
        825.0
      ],
      "bbox_max": [
        -85.22423553466797,
        -2204.010009765625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -120.28021240234375,
        -2211.60693359375,
        825.0
      ],
      "bbox_max": [
        -85.22423553466797,
        -2204.010009765625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07854049652814865,
        0.9782763719558716,
        0.1918506622314453
      ],
      "plane_d": 2002.3502197265625,
      "bbox_min": [
        -85.24032592773438,
        -2204.018798828125,
        836.4596557617188
      ],
      "bbox_max": [
        -85.22423553466797,
        -2204.010009765625,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.5,
        -2265.1875,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2247.755615234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2247.755615234375,
        833.9390869140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2248.02099609375,
        833.1844482421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        825.0
      ],
      "bbox_max": [
        -292.0,
        -2249.202880859375,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -159.40509033203125,
        -2212.5654296875,
        759.2772216796875
      ],
      "bbox_max": [
        -85.23536682128906,
        -2185.397216796875,
        872.276611328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -124.59520721435547,
        -2211.625244140625,
        836.5
      ],
      "bbox_max": [
        -123.64452362060547,
        -2207.233642578125,
        848.5909423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -124.07225799560547,
        -2209.702880859375,
        836.5
      ],
      "bbox_max": [
        -123.64452362060547,
        -2207.233642578125,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.07853952795267105,
        0.978276252746582,
        0.19185161590576172
      ],
      "plane_d": 2002.348876953125,
      "bbox_min": [
        -128.04714965820312,
        -2210.680419921875,
        759.2772216796875
      ],
      "bbox_max": [
        -85.23536682128906,
        -2186.02587890625,
        872.276611328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.06041233614087105,
        -0.9981735348701477
      ],
      "plane_d": 951.2900390625,
      "bbox_min": [
        -597.4422607421875,
        -2266.49853515625,
        763.703125
      ],
      "bbox_max": [
        -89.64111328125,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 2181.499755859375,
      "bbox_min": [
        -582.3368530273438,
        -2266.49853515625,
        817.8739624023438
      ],
      "bbox_max": [
        -89.64111328125,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2187.44677734375,
      "bbox_min": [
        -354.65496826171875,
        -2266.49853515625,
        817.8739624023438
      ],
      "bbox_max": [
        -89.64111328125,
        -2181.5,
        937.2014770507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 857.0,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        820.6400756835938
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        862.2570190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9739730358123779,
        0.19274848699569702,
        0.11926708370447159
      ],
      "plane_d": 438.44525146484375,
      "bbox_min": [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      "bbox_max": [
        -122.31401824951172,
        -2181.5,
        862.2570190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739686846733093,
        0.19277054071426392,
        0.11926654726266861
      ],
      "plane_d": 54.74974822998047,
      "bbox_min": [
        -271.68597412109375,
        -2186.925537109375,
        857.0
      ],
      "bbox_max": [
        -270.0,
        -2181.5,
        862.2570190429688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        820.6400756835938
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        857.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9226222038269043,
        0.1902817040681839,
        -0.33550143241882324
      ],
      "plane_d": 807.71923828125,
      "bbox_min": [
        -270.4322814941406,
        -2187.44677734375,
        820.6400756835938
      ],
      "bbox_max": [
        -124.31903076171875,
        -2181.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -270.4322814941406,
        -2187.44677734375,
        820.6400756835938
      ],
      "bbox_max": [
        -268.0,
        -2181.5,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9739730358123779,
        0.19274848699569702,
        0.11926708370447159
      ],
      "plane_d": 438.44525146484375,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9739686846733093,
        0.19277054071426392,
        0.11926654726266861
      ],
      "plane_d": 54.74974822998047,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9927337765693665,
        -0.0,
        -0.12033136934041977
      ],
      "plane_d": -25.735870361328125,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9226222038269043,
        0.1902817040681839,
        -0.33550143241882324
      ],
      "plane_d": 807.71923828125,
      "bbox_min": [
        -125.54545593261719,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -119.810546875,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9927337765693665,
        0.0,
        -0.12033136934041977
      ],
      "plane_d": 366.3939514160156,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390894770622253,
        0.19267703592777252,
        -0.2845814824104309
      ],
      "plane_d": 402.2903747558594,
      "bbox_min": [
        -274.189453125,
        -2187.44677734375,
        825.0
      ],
      "bbox_max": [
        -269.2121276855469,
        -2181.5,
        837.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 432.67938232421875,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 741.12255859375,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -127.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -127.5,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 267.5,
      "bbox_min": [
        -267.5,
        -2187.44677734375,
        836.5
      ],
      "bbox_max": [
        -267.5,
        -2181.5,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 861.0,
      "bbox_min": [
        -354.65496826171875,
        -2266.49853515625,
        817.8739624023438
      ],
      "bbox_max": [
        -89.64111328125,
        -2187.44677734375,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.011260570026934147,
        0.8631108403205872,
        0.5048890709877014
      ],
      "plane_d": 1468.668701171875,
      "bbox_min": [
        -310.8897399902344,
        -2247.94970703125,
        861.0
      ],
      "bbox_max": [
        -89.64111328125,
        -2205.904052734375,
        937.2014770507812
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.08636504411697388,
        0.9781545996665955,
        0.18908940255641937
      ],
      "plane_d": 2005.19091796875,
      "bbox_min": [
        -310.8897399902344,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -89.64111328125,
        -2205.904052734375,
        873.7135009765625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -310.8897399902344,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -277.400146484375,
        -2218.526123046875,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -310.8897399902344,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -297.98779296875,
        -2230.50927734375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -306.7088928222656,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -291.0722351074219,
        -2224.105224609375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -306.7088928222656,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -297.98779296875,
        -2227.83984375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -305.518310546875,
        -2233.3134765625,
        861.0
      ],
      "bbox_max": [
        -297.98779296875,
        -2227.83984375,
        873.7135009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -354.65496826171875,
        -2266.49853515625,
        817.8739624023438
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -330.51251220703125,
        -2266.49853515625,
        818.7000122070312
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -330.51251220703125,
        -2266.49853515625,
        818.7000122070312
      ],
      "bbox_max": [
        -269.1110534667969,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2936282753944397,
        0.8429384827613831,
        0.4508185088634491
      ],
      "plane_d": 1401.1619873046875,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        818.7000122070312
      ],
      "bbox_max": [
        -269.19183349609375,
        -2187.879150390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        818.7000122070312
      ],
      "bbox_max": [
        -270.5449523925781,
        -2195.120849609375,
        853.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2241.5,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        836.5
      ],
      "bbox_max": [
        -277.80194091796875,
        -2206.37939453125,
        853.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -280.60009765625,
        -2219.5,
        836.5
      ],
      "bbox_max": [
        -277.80194091796875,
        -2206.37939453125,
        837.0676879882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        838.4999389648438
      ],
      "bbox_max": [
        -278.6029052734375,
        -2241.5,
        853.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 851.5,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        838.4999389648438
      ],
      "bbox_max": [
        -278.6029052734375,
        -2241.5,
        853.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5547001957893372,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": 873.79150390625,
      "bbox_min": [
        -312.5,
        -2262.955810546875,
        851.5
      ],
      "bbox_max": [
        -295.0,
        -2241.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2255.5,
      "bbox_min": [
        -312.5,
        -2262.955810546875,
        851.5
      ],
      "bbox_max": [
        -300.5,
        -2255.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 660.3109130859375,
      "bbox_min": [
        -312.5,
        -2262.955810546875,
        851.5
      ],
      "bbox_max": [
        -300.5,
        -2255.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        0.0,
        -0.44721364974975586
      ],
      "plane_d": 112.02700805664062,
      "bbox_min": [
        -301.5,
        -2260.302001953125,
        851.5
      ],
      "bbox_max": [
        -300.5,
        -2255.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 1804.5362548828125,
      "bbox_min": [
        -298.0,
        -2258.576904296875,
        851.5
      ],
      "bbox_max": [
        -295.0,
        -2254.0,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 327.5,
      "bbox_min": [
        -327.5,
        -2266.49853515625,
        838.4999389648438
      ],
      "bbox_max": [
        -278.6029052734375,
        -2241.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -327.5,
        -2263.18115234375,
        838.4999389648438
      ],
      "bbox_max": [
        -278.6029052734375,
        -2241.5,
        851.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -4.882812390860636e-06,
        0.0,
        1.0
      ],
      "plane_d": -838.5015258789062,
      "bbox_min": [
        -327.5,
        -2261.92578125,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2242.451416015625,
        841.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1816.5574951171875,
      "bbox_min": [
        -327.5,
        -2259.66357421875,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2242.451416015625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -840.5,
      "bbox_min": [
        -323.8388671875,
        -2254.0,
        840.5
      ],
      "bbox_max": [
        -315.0,
        -2242.451416015625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238833785057068,
        -0.3826743960380554,
        0.0
      ],
      "plane_d": -1153.5712890625,
      "bbox_min": [
        -323.8388671875,
        -2254.0,
        840.5
      ],
      "bbox_max": [
        -315.0,
        -2242.451416015625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        -0.8314722776412964,
        0.0
      ],
      "plane_d": -1686.875244140625,
      "bbox_min": [
        -323.8388671875,
        -2245.1611328125,
        840.5
      ],
      "bbox_max": [
        -319.783447265625,
        -2242.451416015625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3826743960380554,
        -0.9238833785057068,
        0.0
      ],
      "plane_d": -2202.9755859375,
      "bbox_min": [
        -327.5,
        -2259.66357421875,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2245.1611328125,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -839.5,
      "bbox_min": [
        -326.548583984375,
        -2254.0,
        839.5
      ],
      "bbox_max": [
        -315.0,
        -2245.1611328125,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -978.07275390625,
      "bbox_min": [
        -326.548583984375,
        -2249.216552734375,
        839.5
      ],
      "bbox_max": [
        -323.8388671875,
        -2245.1611328125,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -327.5,
        -2259.66357421875,
        838.4999389648438
      ],
      "bbox_max": [
        -315.0,
        -2249.216552734375,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807881116867065,
        -0.1950763612985611,
        0.0
      ],
      "plane_d": -118.4940185546875,
      "bbox_min": [
        -327.5,
        -2254.0,
        838.4999389648438
      ],
      "bbox_max": [
        -326.548583984375,
        -2249.216552734375,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2254.0,
      "bbox_min": [
        -327.5,
        -2263.18115234375,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2241.5,
        851.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.0,
      "bbox_min": [
        -315.0,
        -2263.18115234375,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -300.5,
      "bbox_min": [
        -312.5,
        -2259.332763671875,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 1804.5362548828125,
      "bbox_min": [
        -298.0,
        -2257.873291015625,
        841.5
      ],
      "bbox_max": [
        -295.0,
        -2254.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -295.0,
        -2257.873291015625,
        849.01708984375
      ],
      "bbox_max": [
        -295.0,
        -2257.0,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2255.5,
      "bbox_min": [
        -312.5,
        -2255.5,
        841.5
      ],
      "bbox_max": [
        -300.5,
        -2254.0,
        851.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.0,
      "bbox_min": [
        -309.0,
        -2255.5,
        841.5
      ],
      "bbox_max": [
        -304.0,
        -2254.0,
        849.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.0,
      "bbox_min": [
        -309.0,
        -2255.5,
        841.5
      ],
      "bbox_max": [
        -304.0,
        -2254.0,
        849.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 849.0,
      "bbox_min": [
        -309.0,
        -2255.5,
        849.0
      ],
      "bbox_max": [
        -304.0,
        -2254.0,
        849.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314722776412964,
        -0.5555662512779236,
        0.0
      ],
      "plane_d": -978.07275390625,
      "bbox_min": [
        -327.5,
        -2254.0,
        841.5
      ],
      "bbox_max": [
        -315.0,
        -2241.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555662512779236,
        -0.8314722776412964,
        0.0
      ],
      "plane_d": -1686.875244140625,
      "bbox_min": [
        -327.5,
        -2254.0,
        841.5
      ],
      "bbox_max": [
        -315.0,
        -2241.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807881116867065,
        -0.1950763612985611,
        0.0
      ],
      "plane_d": -118.4940185546875,
      "bbox_min": [
        -327.5,
        -2254.0,
        841.5
      ],
      "bbox_max": [
        -315.0,
        -2241.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950763612985611,
        -0.9807881116867065,
        0.0
      ],
      "plane_d": -2136.987548828125,
      "bbox_min": [
        -319.783447265625,
        -2242.451416015625,
        841.5
      ],
      "bbox_max": [
        -315.0,
        -2241.5,
        851.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2239.39990234375,
      "bbox_min": [
        -326.5,
        -2260.956787109375,
        818.7000122070312
      ],
      "bbox_max": [
        -270.5449523925781,
        -2195.120849609375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -280.4940490722656,
        -2219.5,
        818.7000122070312
      ],
      "bbox_max": [
        -270.5449523925781,
        -2195.120849609375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 326.5,
      "bbox_min": [
        -326.5,
        -2260.956787109375,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -304.0,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 303.0,
      "bbox_min": [
        -304.0,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2250.89990234375,
      "bbox_min": [
        -304.0,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2247.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -304.0,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2247.39990234375,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2247.39990234375,
      "bbox_min": [
        -304.0,
        -2247.39990234375,
        820.0
      ],
      "bbox_max": [
        -303.0,
        -2247.39990234375,
        823.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 292.0,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -293.0,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -292.0,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2250.89990234375,
      "bbox_min": [
        -293.0,
        -2250.89990234375,
        823.234375
      ],
      "bbox_max": [
        -292.0,
        -2247.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2247.39990234375,
      "bbox_min": [
        -293.0,
        -2247.434326171875,
        823.234375
      ],
      "bbox_max": [
        -292.9130554199219,
        -2247.39990234375,
        823.33251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -293.0,
        -2247.434326171875,
        823.2999877929688
      ],
      "bbox_max": [
        -292.9130554199219,
        -2247.39990234375,
        823.33251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -860.851806640625,
      "bbox_min": [
        -289.5,
        -2245.333251953125,
        820.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39391934871673584,
        0.0,
        0.9191451072692871
      ],
      "plane_d": -865.6377563476562,
      "bbox_min": [
        -279.5,
        -2243.3828125,
        822.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -315.5,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 314.5,
      "bbox_min": [
        -315.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2250.89990234375,
      "bbox_min": [
        -315.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2247.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -315.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2247.39990234375,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2247.39990234375,
      "bbox_min": [
        -315.5,
        -2247.39990234375,
        820.0
      ],
      "bbox_max": [
        -314.5,
        -2247.39990234375,
        823.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 325.5,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2250.89990234375,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2247.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6860114932060242,
        -0.7275906801223755
      ],
      "plane_d": -942.716796875,
      "bbox_min": [
        -326.5,
        -2250.89990234375,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2247.39990234375,
        826.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2247.39990234375,
      "bbox_min": [
        -326.5,
        -2247.39990234375,
        820.0
      ],
      "bbox_max": [
        -325.5,
        -2247.39990234375,
        823.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -286.6089782714844,
        -2206.77099609375,
        819.84765625
      ],
      "bbox_max": [
        -269.19183349609375,
        -2187.879150390625,
        837.1588134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -278.0542907714844,
        -2206.77099609375,
        820.1755981445312
      ],
      "bbox_max": [
        -270.5155944824219,
        -2194.963623046875,
        837.0676879882812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -278.0542907714844,
        -2206.77099609375,
        820.1851196289062
      ],
      "bbox_max": [
        -269.19183349609375,
        -2187.879150390625,
        837.1588134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -276.988525390625,
        -2201.442138671875,
        820.6138916015625
      ],
      "bbox_max": [
        -269.1110534667969,
        -2187.44677734375,
        837.2890014648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -825.0,
      "bbox_min": [
        -285.28863525390625,
        -2255.99951171875,
        819.8090209960938
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -272.9879150390625,
        -2242.63623046875,
        819.8090209960938
      ],
      "bbox_max": [
        -110.81917572021484,
        -2187.44677734375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39391934871673584,
        0.0,
        0.9191451072692871
      ],
      "plane_d": -865.6377563476562,
      "bbox_min": [
        -272.9879150390625,
        -2242.63623046875,
        824.7908935546875
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -124.044677734375,
        -2199.67138671875,
        819.97119140625
      ],
      "bbox_max": [
        -110.81917572021484,
        -2197.54248046875,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -285.28863525390625,
        -2255.99951171875,
        825.0
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -285.28863525390625,
        -2255.99951171875,
        841.5
      ],
      "bbox_max": [
        -276.86383056640625,
        -2214.285400390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -281.7077941894531,
        -2220.269775390625,
        853.5
      ],
      "bbox_max": [
        -277.4501953125,
        -2214.84228515625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2241.5,
      "bbox_min": [
        -282.7768249511719,
        -2250.413818359375,
        841.5
      ],
      "bbox_max": [
        -276.86383056640625,
        -2214.285400390625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3437800109386444,
        0.839401125907898,
        0.4209762513637543
      ],
      "plane_d": 1404.3909912109375,
      "bbox_min": [
        -278.1985168457031,
        -2215.071044921875,
        852.3663940429688
      ],
      "bbox_max": [
        -277.6394958496094,
        -2214.285400390625,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -280.1470947265625,
        -2250.413818359375,
        841.5
      ],
      "bbox_max": [
        -276.86383056640625,
        -2241.5,
        850.58935546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.22845458984375,
      "bbox_min": [
        -278.0,
        -2248.058837890625,
        841.5
      ],
      "bbox_max": [
        -276.86383056640625,
        -2241.5,
        850.58935546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2243.5,
      "bbox_min": [
        -277.5625,
        -2245.533203125,
        845.0
      ],
      "bbox_max": [
        -277.21026611328125,
        -2243.5,
        847.81787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        -277.5625,
        -2245.533203125,
        845.0
      ],
      "bbox_max": [
        -277.21026611328125,
        -2243.5,
        845.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -2184.2529296875,
      "bbox_min": [
        -277.5625,
        -2244.0,
        845.0
      ],
      "bbox_max": [
        -277.21026611328125,
        -2243.5,
        845.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -279.09063720703125,
        -2255.24365234375,
        825.0
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -279.09063720703125,
        -2254.3544921875,
        841.5
      ],
      "bbox_max": [
        -275.81634521484375,
        -2241.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.2284851074219,
      "bbox_min": [
        -278.32415771484375,
        -2250.465087890625,
        841.5
      ],
      "bbox_max": [
        -275.81634521484375,
        -2241.5,
        853.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -845.0,
      "bbox_min": [
        -277.5625,
        -2250.43115234375,
        845.0
      ],
      "bbox_max": [
        -275.81634521484375,
        -2243.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2243.5,
      "bbox_min": [
        -277.296875,
        -2244.0,
        845.0
      ],
      "bbox_max": [
        -275.81634521484375,
        -2243.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -985.7069091796875,
      "bbox_min": [
        -277.296875,
        -2244.0,
        845.0
      ],
      "bbox_max": [
        -275.81634521484375,
        -2243.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": -2184.2529296875,
      "bbox_min": [
        -277.296875,
        -2244.0,
        845.0
      ],
      "bbox_max": [
        -276.3011779785156,
        -2243.5,
        845.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2241.5,
      "bbox_min": [
        -278.32415771484375,
        -2249.929931640625,
        841.5
      ],
      "bbox_max": [
        -276.5,
        -2241.5,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -841.5,
      "bbox_min": [
        -278.32415771484375,
        -2249.929931640625,
        841.5
      ],
      "bbox_max": [
        -278.0,
        -2248.058837890625,
        841.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.086369089782238,
        0.9781539440155029,
        0.18909035623073578
      ],
      "plane_d": 2005.18896484375,
      "bbox_min": [
        -278.0047912597656,
        -2255.24365234375,
        825.0
      ],
      "bbox_max": [
        -94.69258880615234,
        -2187.44677734375,
        861.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 441.2032470703125,
      "bbox_min": [
        -278.0047912597656,
        -2255.24365234375,
        825.0
      ],
      "bbox_max": [
        -116.2279281616211,
        -2198.006591796875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -113.74404907226562,
      "bbox_min": [
        -272.5,
        -2255.24365234375,
        857.0
      ],
      "bbox_max": [
        -265.8015441894531,
        -2200.732666015625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 272.5,
      "bbox_min": [
        -272.5,
        -2255.24365234375,
        857.0
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -278.0047912597656,
        -2255.02685546875,
        825.0
      ],
      "bbox_max": [
        -116.2279281616211,
        -2198.006591796875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -122.00172424316406,
        -2205.35986328125,
        825.0
      ],
      "bbox_max": [
        -116.2279281616211,
        -2198.683837890625,
        837.1583251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 272.5,
      "bbox_min": [
        -278.0047912597656,
        -2255.02685546875,
        825.0
      ],
      "bbox_max": [
        -123.9848861694336,
        -2198.006591796875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7808688282966614,
        0.0,
        -0.6246950626373291
      ],
      "plane_d": 748.150390625,
      "bbox_min": [
        -278.0047912597656,
        -2253.83642578125,
        836.5
      ],
      "bbox_max": [
        -272.5,
        -2239.39990234375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.2284851074219,
      "bbox_min": [
        -277.12127685546875,
        -2253.831787109375,
        851.72216796875
      ],
      "bbox_max": [
        -276.5,
        -2250.245361328125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 853.5,
      "bbox_min": [
        -277.12127685546875,
        -2253.831787109375,
        853.5
      ],
      "bbox_max": [
        -276.5,
        -2250.245361328125,
        853.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927337169647217,
        2.1493124222615734e-05,
        -0.12033136188983917
      ],
      "plane_d": 375.3766784667969,
      "bbox_min": [
        -278.0047912597656,
        -2253.488037109375,
        836.5
      ],
      "bbox_max": [
        -274.5,
        -2239.39990234375,
        854.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        -278.0047912597656,
        -2253.1005859375,
        836.5
      ],
      "bbox_max": [
        -275.04541015625,
        -2240.449462890625,
        851.72216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.2284851074219,
      "bbox_min": [
        -276.9375,
        -2253.1005859375,
        850.0
      ],
      "bbox_max": [
        -276.72222900390625,
        -2250.2841796875,
        851.72216796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -278.0047912597656,
        -2250.958984375,
        836.5
      ],
      "bbox_max": [
        -275.04541015625,
        -2240.449462890625,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922778606414795,
        0.0,
        0.12403473258018494
      ],
      "plane_d": -380.22845458984375,
      "bbox_min": [
        -277.7562561035156,
        -2250.958984375,
        843.4498901367188
      ],
      "bbox_max": [
        -277.5625,
        -2250.43115234375,
        845.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071068286895752,
        -0.7071068286895752
      ],
      "plane_d": -985.7069091796875,
      "bbox_min": [
        -275.8423156738281,
        -2244.0,
        849.5
      ],
      "bbox_max": [
        -275.04541015625,
        -2243.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 276.5,
      "bbox_min": [
        -276.6817932128906,
        -2248.214599609375,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2239.39990234375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 836.5,
      "bbox_min": [
        -276.6817932128906,
        -2247.7353515625,
        836.5
      ],
      "bbox_max": [
        -276.5,
        -2239.39990234375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 854.0,
      "bbox_min": [
        -259.0,
        -2250.60546875,
        825.0
      ],
      "bbox_max": [
        -123.9848861694336,
        -2198.006591796875,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2240.5,
      "bbox_min": [
        -259.0,
        -2250.60546875,
        854.0
      ],
      "bbox_max": [
        -124.93572998046875,
        -2203.9775390625,
        861.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -259.0,
      "bbox_min": [
        -259.0,
        -2250.60546875,
        854.0
      ],
      "bbox_max": [
        -222.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 246.0,
      "bbox_min": [
        -246.0,
        -2247.1552734375,
        854.0
      ],
      "bbox_max": [
        -222.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -222.0,
      "bbox_min": [
        -222.0,
        -2240.785888671875,
        857.1873168945312
      ],
      "bbox_max": [
        -222.0,
        -2240.5,
        858.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -128.5823974609375,
        -2216.487548828125,
        854.5
      ],
      "bbox_max": [
        -124.93572998046875,
        -2203.9775390625,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -128.5823974609375,
        -2215.142578125,
        854.5
      ],
      "bbox_max": [
        -124.93572998046875,
        -2203.9775390625,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -129.67066955566406,
        -2207.738037109375,
        825.0
      ],
      "bbox_max": [
        -123.9848861694336,
        -2198.006591796875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -125.21744537353516,
        -2207.738037109375,
        836.5
      ],
      "bbox_max": [
        -123.9848861694336,
        -2200.623046875,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -396.10577392578125,
      "bbox_min": [
        -131.5,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -117.00479888916016,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.922624409198761,
        0.19026373326778412,
        -0.3355054557323456
      ],
      "plane_d": 807.68359375,
      "bbox_min": [
        -124.31903076171875,
        -2201.4755859375,
        825.0
      ],
      "bbox_max": [
        -117.00479888916016,
        -2187.44677734375,
        837.3982543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        -0.0
      ],
      "plane_d": -502.9472961425781,
      "bbox_min": [
        -131.5,
        -2205.07421875,
        825.0
      ],
      "bbox_max": [
        -125.16639709472656,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -743.253662109375,
      "bbox_min": [
        -131.5,
        -2204.288818359375,
        825.0
      ],
      "bbox_max": [
        -125.16639709472656,
        -2187.44677734375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7738210558891296,
        -0.1340513974428177,
        -0.6190568208694458
      ],
      "plane_d": 135.5439453125,
      "bbox_min": [
        -131.5,
        -2204.288818359375,
        836.5
      ],
      "bbox_max": [
        -125.16639709472656,
        -2187.44677734375,
        857.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -499.0059814453125,
      "bbox_min": [
        -127.5,
        -2200.917724609375,
        836.5
      ],
      "bbox_max": [
        -125.16639709472656,
        -2187.44677734375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9783713817596436,
        -0.16948628425598145,
        -0.11859047412872314
      ],
      "plane_d": -9.649078369140625,
      "bbox_min": [
        -275.4665832519531,
        -2203.78076171875,
        830.9840087890625
      ],
      "bbox_max": [
        -263.5,
        -2187.44677734375,
        861.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9390870928764343,
        0.19268985092639923,
        -0.2845807671546936
      ],
      "plane_d": 402.31842041015625,
      "bbox_min": [
        -275.4665832519531,
        -2193.832275390625,
        830.9840087890625
      ],
      "bbox_max": [
        -272.2456970214844,
        -2187.44677734375,
        837.3982543945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9853246808052063,
        -0.17069083452224731,
        0.0
      ],
      "plane_d": -109.80276489257812,
      "bbox_min": [
        -267.8114929199219,
        -2189.244873046875,
        835.8590698242188
      ],
      "bbox_max": [
        -267.2770690917969,
        -2187.44677734375,
        838.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.932102620601654,
        -0.16147100925445557,
        0.324209600687027
      ],
      "plane_d": -375.0731201171875,
      "bbox_min": [
        -267.6134948730469,
        -2188.101806640625,
        835.8590698242188
      ],
      "bbox_max": [
        -267.2770690917969,
        -2187.44677734375,
        836.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -582.3368530273438,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5031259059906006,
        -0.8475584983825684,
        0.16884596645832062
      ],
      "plane_d": -2108.238037109375,
      "bbox_min": [
        -497.283447265625,
        -1979.7894287109375,
        1066.3836669921875
      ],
      "bbox_max": [
        -493.35882568359375,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5680782794952393,
        -0.8229745030403137,
        0.0
      ],
      "plane_d": -1346.862060546875,
      "bbox_min": [
        -495.131103515625,
        -1978.3544921875,
        1076.9432373046875
      ],
      "bbox_max": [
        -493.35882568359375,
        -1977.131103515625,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        0.5900004506111145
      ],
      "plane_d": 1274.8353271484375,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -261.0,
      "bbox_min": [
        -261.0,
        -2181.5,
        821.5
      ],
      "bbox_max": [
        -261.0,
        -2179.60009765625,
        824.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.807403028011322,
        -0.5900004506111145
      ],
      "plane_d": 2268.16015625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2179.60009765625,
      "bbox_min": [
        -261.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -146.0,
      "bbox_min": [
        -249.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 134.0,
      "bbox_min": [
        -134.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -134.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 249.0,
      "bbox_min": [
        -249.0,
        -2181.5,
        859.0
      ],
      "bbox_max": [
        -249.0,
        -2179.60009765625,
        863.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45128148794174194,
        -0.8216733932495117,
        0.3481350243091583
      ],
      "plane_d": -1708.6090087890625,
      "bbox_min": [
        -597.4422607421875,
        -2233.1513671875,
        763.703125
      ],
      "bbox_max": [
        -113.07188415527344,
        -2025.8553466796875,
        830.4201049804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08636579662561417,
        0.9781541228294373,
        0.18909122049808502
      ],
      "plane_d": 2005.1881103515625,
      "bbox_min": [
        -370.3136901855469,
        -2233.1513671875,
        763.703125
      ],
      "bbox_max": [
        -113.07188415527344,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -370.3136901855469,
        -2233.1513671875,
        798.7386474609375
      ],
      "bbox_max": [
        -347.122314453125,
        -2220.0126953125,
        818.1638793945312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -354.3086242675781,
        -2228.36083984375,
        783.25390625
      ],
      "bbox_max": [
        -251.1885986328125,
        -2176.740966796875,
        820.7006225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40011247992515564,
        0.792174220085144,
        0.4608362317085266
      ],
      "plane_d": 1247.305908203125,
      "bbox_min": [
        -354.3086242675781,
        -2228.36083984375,
        791.8031616210938
      ],
      "bbox_max": [
        -314.28076171875,
        -2198.047119140625,
        819.2825317382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48106518387794495,
        0.726759672164917,
        0.490302711725235
      ],
      "plane_d": 1051.346435546875,
      "bbox_min": [
        -354.3086242675781,
        -2228.36083984375,
        796.3135986328125
      ],
      "bbox_max": [
        -330.51251220703125,
        -2211.443115234375,
        818.80322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3004262149333954,
        0.839409589767456,
        0.452919065952301
      ],
      "plane_d": 1389.72607421875,
      "bbox_min": [
        -302.4618225097656,
        -2200.54150390625,
        785.8125
      ],
      "bbox_max": [
        -251.1885986328125,
        -2183.931884765625,
        820.7006225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -253.25575256347656,
        -2186.987548828125,
        817.9110107421875
      ],
      "bbox_max": [
        -251.1885986328125,
        -2185.724365234375,
        820.7006225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2994823157787323,
        0.9154420495033264,
        0.26884233951568604
      ],
      "plane_d": 1851.52099609375,
      "bbox_min": [
        -279.11785888671875,
        -2188.4384765625,
        773.5294799804688
      ],
      "bbox_max": [
        -209.06512451171875,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2527424097061157,
        0.9215744137763977,
        0.294655442237854
      ],
      "plane_d": 1832.737548828125,
      "bbox_min": [
        -279.11785888671875,
        -2186.517822265625,
        778.9343872070312
      ],
      "bbox_max": [
        -235.501708984375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4140956699848175,
        0.7585507035255432,
        0.5031157732009888
      ],
      "plane_d": 1141.6068115234375,
      "bbox_min": [
        -279.11785888671875,
        -2186.446044921875,
        779.7889404296875
      ],
      "bbox_max": [
        -245.962646484375,
        -2165.850830078125,
        820.8666381835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40897637605667114,
        0.7616539597511292,
        0.5026147961616516
      ],
      "plane_d": 1150.095947265625,
      "bbox_min": [
        -279.11785888671875,
        -2185.724365234375,
        780.6771850585938
      ],
      "bbox_max": [
        -253.25575256347656,
        -2168.66357421875,
        817.9110107421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25527524948120117,
        0.9336197376251221,
        0.25137388706207275
      ],
      "plane_d": 1895.1923828125,
      "bbox_min": [
        -235.501708984375,
        -2188.4384765625,
        773.5294799804688
      ],
      "bbox_max": [
        -209.06512451171875,
        -2179.7744140625,
        820.6962890625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: hdr2",
      "entity_class": "CSlidingDoor",
      "piece_name": "hdr2",
      "offset": 1735,
      "centroid": [
        -306.5,
        -2254.75,
        845.25
      ],
      "bbox_min": [
        -309.0,
        -2255.300048828125,
        841.5
      ],
      "bbox_max": [
        -304.0,
        -2254.199951171875,
        849.0
      ],
      "dimensions_source": {
        "span_x": 5.0,
        "span_y": 1.10009765625,
        "height_z": 7.5,
        "door_width": 5.0,
        "door_depth": 1.10009765625,
        "leaf_depth": 1.06009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -309.0,
          -2255.300048828125,
          841.5
        ],
        [
          -309.0,
          -2254.199951171875,
          849.0
        ],
        [
          -309.0,
          -2255.300048828125,
          849.0
        ],
        [
          -309.0,
          -2254.199951171875,
          841.5
        ],
        [
          -304.0,
          -2255.300048828125,
          841.5
        ],
        [
          -304.0,
          -2254.199951171875,
          849.0
        ],
        [
          -304.0,
          -2255.300048828125,
          849.0
        ],
        [
          -304.0,
          -2254.199951171875,
          841.5
        ]
      ],
      "plane_distance": -309.0,
      "authentic_texture": "chkptdoor1"
    }
  ],
  "tutorial_messages": []
}